import { NestedTreeControl } from '@angular/cdk/tree';
import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import Exporting from 'highcharts/modules/exporting';
import xrange from 'highcharts/modules/xrange';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MatTreeNestedDataSource,
} from '@angular/material/tree';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { ToastrService } from 'ngx-toastr';
import { PlantGroupElement, } from 'src/app/models/O3AdministrationModels/plant-model';
import { ProductivityService } from 'src/app/services/productivity-service';
import { PrimeNGConfig } from 'primeng/api';
import * as moment from 'moment';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { StockChart } from 'angular-highcharts';
import { MatTabGroup } from '@angular/material/tabs';
import { ChecklistService } from 'src/app/services/checklist.service';
import { flatten } from 'lodash-es';
import {
  animate,
  group,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';
xrange(Highcharts);
Exporting(Highcharts);
import { ButtonEditRendererComponent } from 'src/app/components/button-edit-render.components';
import { ButtonPrintRendererComponent } from 'src/app/components/button-print-render.components';
import { ButtonSelectRendererComponent } from 'src/app/components/button-select-render.components';
import { ButtonViewRendererComponent } from 'src/app/components/button-view-render.components';
import { QualityParameterService } from 'src/app/services/quality-parameter.service';
import { BtnCellRenderer } from 'src/app/btn-cell-renderer.component';
import { BtnCellRendererActualEntry } from 'src/app/btn-cell-rendererActualEntry.component';
import { CustomTooltip } from 'src/app/custom-tooltip.component';
import { PrimeCellEditorComponent } from 'src/app/editors/prime-cell-editor.component';
import { ProcessControlService } from 'src/app/services/processControlService.service';
import { QualityexecutionService } from 'src/app/services/qualityexecution.service';
import { NotificationService } from 'src/app/services/notification.service';
import { MachineMappingService } from 'src/app/services/machinemapping.service';
import { AreaService } from 'src/app/services/area.service';
import { MatDialog } from '@angular/material/dialog';
import { ShopFloorDataService } from 'src/app/services/shopFloorData.service';
import * as Chart from 'chart.js';
import { CrewScheduleService } from 'src/app/services/crewSchedule.service';
import { MachineParamtersService } from 'src/app/services/machine-paramters.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent } from '@ngx-translate/core';
import { SelectionModel } from '@angular/cdk/collections';
import { CustomLoadingCellRenderer } from 'src/app/aggrid custom/custom-loading-cell-renderer.component';
import { differenceInCalendarDays } from 'date-fns';
import { interval, Subscription } from 'rxjs';
import { CustomLoadingOverlay } from 'src/app/custom-loading-overlay.component';
import { CilConfigurationService } from 'src/app/services/cil-configuration.service';
import { PlanGroupComponent } from 'src/app/models/O3AdministrationModels/plant-model';
import { ThemePalette } from '@angular/material/core';
import { CILManagementElement } from 'src/app/models/CILManagementElement';
import * as Highcharts from 'highcharts';
import { CommonService } from 'src/app/services/common.service';
import { Subject, timer } from 'rxjs';
import { takeUntil, map, share } from 'rxjs/operators';
import { OperatorExecutionService } from 'src/app/services/operator-execution.service';
import { BtnCellRendererNewSFDC } from 'src/app/btn-cell-rendererNewSFDC';
import { BtnCellRendererRawMaterial } from 'src/app/btn-cellRenderer-RawMaterial';
import { BaseApi } from 'src/backend/api/base-api';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { QualityCheckHistoryService } from 'src/app/services/quality-check-history.service';
import { GroupView } from '../shop-floor-data-food/model';
import { generateGuid } from 'src/app/guidGenerator';
import { WorkFlowService } from 'src/app/services/work-flow.service';
import { SafeUrl } from '@angular/platform-browser';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { CommonMessages } from 'src/@smartmanufacturing/common/enum';

const pdfMake = require('pdfmake/build/pdfmake.js');
require('highcharts/modules/networkgraph')(Highcharts);

const left = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), {
    optional: true,
  }),
  group([
    query(
      ':enter',
      [
        style({ transform: 'translateX(-100%)' }),
        animate('3s ease-out', style({ transform: 'translateX(0%)' })),
      ],
      {
        optional: true,
      }
    ),
    query(
      ':leave',
      [
        style({ transform: 'translateX(0%)' }),
        animate('3s ease-out', style({ transform: 'translateX(100%)' })),
      ],
      {
        optional: true,
      }
    ),
  ]),
];

const right = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), {
    optional: true,
  }),
  group([
    query(
      ':enter',
      [
        style({ transform: 'translateX(100%)' }),
        animate('3s ease-out', style({ transform: 'translateX(0%)' })),
      ],
      {
        optional: true,
      }
    ),
    query(
      ':leave',
      [
        style({ transform: 'translateX(0%)' }),
        animate('3s ease-out', style({ transform: 'translateX(-100%)' })),
      ],
      {
        optional: true,
      }
    ),
  ]),
];
interface ShiftCloseInterface {
  sno: number;
  item: string;
}

interface LineInterface {
  KpiparaId: number;
  KpiName: string;
  KpiValues: boolean;
}

interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}

@Component({
  selector: 'app-new-sfdc-honey',
  templateUrl: './new-sfdc-honey.component.html',
  styleUrls: ['./new-sfdc-honey.component.scss'],
  animations: [
    trigger('animSlider', [
      transition(':increment', right),
      transition(':decrement', left),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})

export class NewSfdcHoneyComponent implements OnInit, OnDestroy, AfterViewInit {
  spinnerButtonOptions1: MatProgressButtonOptions = {
    active: false,
    text: 'Comparison',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    buttonColor: 'primary',
    spinnerColor: 'accent',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  };
  spinnerButtonOptionsOrders: MatProgressButtonOptions = {
    active: false,
    text: 'PO List',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    buttonColor: 'primary',
    spinnerColor: 'accent',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  };
  spinnerButtonOptionsAnalysis: MatProgressButtonOptions = {
    active: false,
    text: 'Orders',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    buttonColor: 'primary',
    spinnerColor: 'accent',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  };
  spinnerButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Analysis',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    buttonColor: 'primary',
    spinnerColor: 'accent',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  };
  displayPosition!: boolean;
  position!: string;
  materialConsumptionForm!: FormGroup;
  style = {
    width: '100%',
    height: '100%',
  };
  operatorName: any;

  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('displayRoleModal') private displayRoleModal!: TemplateRef<any>;
  @ViewChild('QRscanner') private QRscanner!: TemplateRef<any>;
  @ViewChild('pdfModel') private pdfModel!: TemplateRef<any>;
  @ViewChild('pdfModelQC') private pdfModelQC!: TemplateRef<any>;

  @ViewChild('historyBatchModal') private historyBatchModal!: TemplateRef<any>;
  @ViewChild('faultmodal') private faultmodal!: TemplateRef<any>;
  @ViewChild('popupViewModal') private popupViewModal!: TemplateRef<any>;
  @ViewChild('alternativeMaterialModel') private alternativeMaterialModel!: TemplateRef<any>;
  @ViewChild('historyMaterialModal')
  private historyMaterialModal!: TemplateRef<any>;
  @ViewChild('displayPoModal') private displayPoModal!: TemplateRef<any>;
  @ViewChild('displayQCModal') private displayQCModal!: TemplateRef<any>;
  @ViewChild('pickerforprocessgrid') processpicker!: any;
  @ViewChild('pickerforqualitygrid') qualitypicker!: any;
  @ViewChild('changeOverCheckListExecutionModel') private changeOverCheckListExecutionModel!: TemplateRef<any>;
  @ViewChildren(MatPaginator) paginatorView = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sortView = new QueryList<MatSort>();
  disablMaterialSave = false;
  isPlantGroupModelVisible = false;
  StatusColor = '';
  treeControl = new NestedTreeControl<PlantGroupElement>(
    (node) => node.children
  );
  UnitNode: any;
  sfdcForm!: FormGroup;
  urll: any;
  MachineId: any;
  qty: any;
  result: any;
  columnBatchHistory: any;
  columnMaterialBatchHistory: any;
  columnMaterialConsumptionHistory: any;
  ColumnDefsAlternateItem: any;
  itemCode!: string;
  ItemTypeList: any;
  materialConsumptionMode = true;
  chart: any;
  PPID: any;
  plantId: any;
  JobBatchId: any;
  alternativeItemsRowData: any;
  gridApiAlternateItem: any;
  gridColumnApiAlternateItem: any;
  machineSelectProperty!: boolean;
  materialConsumptionDataSource = new MatTableDataSource<any>([]);
  productionOutputDataSource!: MatTableDataSource<any>;
  groups!: any[];
  successMessage!: any;
  showMaterialButtons = false;
  stock!: StockChart;
  Machinetype = false;
  batchChecklistOnlyForShowColumns: string[] = ['checklist', 'values'];
  batchChecklist1Columns: string[] = ['checklist', 'values'];
  // toaster: any;
  gridOptionsCheckList: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,
      filter: true,
      suppressColumnVirtualisation: true,
      filterParams: { newRowsAction: 'keep' },
    },
    paginationPageSize: 10,
    popupParent: document.querySelector('body'),
    frameworkComponents: {
      customLoadingOverlay: CustomLoadingOverlay,
    },
  };
  materialColumns: any[] = [
    'Action',
    'itemtype',
    'batch',
    'length',
    'remarks',
    'time',
    'createdon',
    'createdby',
  ];
  productionColumns: any[] = ['checklist', 'values'];
  production1Columns: string[] = [
    'action',
    'batchCon',
    'lotcode',
    'act',
    'remarks',
    'time',
    'createdon',
    'createdby',
  ];
  wasteColumns: any[] = [
    'cattype',
    'time',
    'failure',
    'uom',
    'createdon',
    'createdby',
  ];
  highChartsColor = [
    '#00008B',
    '#34A56F',
    '#F80000',
    '#2D0A77',
    '#8C001A',
    '#FF69B4',
    '#FA4A08',
    '#5453A6',
    '#8B008B',
    '#3090C7',
    '#F1C40F',
    '#CB4335',
    '#36454F',
    '#A569BD',
    '#FFA500',
    '#179fcc',
    '#093323',
    '#08fa03',
    '#048b8e',
    '#9637A4',
    '#F39C12',
    '#0b774e',
    '#F5B7B1',
    '#0d98da',
    '#512E5F',
    '#C471A5',
    '#0034bb',
    '#06573d',
    '#0d6e54',
    '#0692aa',
    '#611745',
    '#F80000',
    '#FFDF00',
    '#6D81A8',
    '#08FAC7',
    '#D208FA',
    '#FAEB08',
  ];

  ProcessControlDataForm!: FormGroup;
  processparameter1Columns: string[] = ['processparameter', 'values'];
  detailPrentId!: any;
  processControlResumeInterval = true;
  qualityControlResumeInterval = true;
  processparameter1DataSource!: MatTableDataSource<any>;
  processparameter2Columns: string[] = ['materialparameter', 'values'];
  processparameter22DataSource!: MatTableDataSource<any>;
  processparameter3Columns: string[] = ['lineclearance', 'values'];
  processparameter33DataSource!: MatTableDataSource<any>;
  isFoodSector: boolean = false;
  total!: any;
  total1!: any;
  // chart!: StockChart;
  processValues!: any[];
  processValues1!: any[];
  productionOutputForm!: FormGroup;
  productionMode = true;
  batchCheckList: any;
  arrayCheckList!: any[];
  qrCodeData: string = '';
  qrCodeDownloadLink: any;
  isAuto!: boolean;
  batchConsumptionList!: any[];
  filteredbatchConsumptionList!: any[];
  Result!: any;
  targetQty!: any;
  remainingQty = 0;
  plantDDL!: any[];
  areaDDL!: any[];
  ViewProductionOutputDataSource!: MatTableDataSource<any>;
  HistoryBatchDataSource1!: MatTableDataSource<any>;
  BatchCheckListTypeId!: any;
  dropdownArray: any[] = [];
  Groups!: any[];
  currentImagePath!: any;
  newDropdownList: any = [];
  centerLineDataSource!: MatTableDataSource<any>;
  options: any;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('imageZoomModel') private imageZoomModel!: TemplateRef<any>;
  @ViewChild('ProfileImageZoomModal')
  private ProfileImageZoomModal!: TemplateRef<any>;
  @ViewChild('imageZoomModelShow')
  private imageZoomModelShow!: TemplateRef<any>;
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  @ViewChild('centerlineModal') private centerlineModal!: TemplateRef<any>;
  @ViewChild('wastehistoryModal') private wastehistoryModal!: TemplateRef<any>;
  @ViewChild('matTabId', { static: false }) matTabId!: MatTabGroup;
  @ViewChild('lastshiftModal') private lastshiftModal!: TemplateRef<any>;
  groupTypeList: any;
  @ViewChild('historyBatch1Modal')
  private historyBatch1Modal!: TemplateRef<any>;
  @ViewChild('materialViewModal') private materialViewModal!: TemplateRef<any>;
  ManPowerRequired!: any;
  ManPower!: any;
  displayQualitySpecificationModal!: boolean;
  displayQualityDefectModal!: boolean;
  displayProcssDefectModal!: boolean;
  centerLineMode = true;
  obKpiParamInfoId1!: any;
  booleanConvertedArray: LineInterface[] = [];
  booleanConvertedArray1: LineInterface[] = [];
  booleanConvertedArray2: LineInterface[] = [];
  MaterialParameterList!: any[];
  LineParameterList!: any[];
  wasteForm!: FormGroup;
  wasteMode = true;
  WasteEntryId!: any;
  newJbWasteHistoryList!: any[];
  rowDataWasteHistory!: any[];
  wasteDataSource1!: MatTableDataSource<any>;
  totalWaste!: any;
  FaultList!: any[];
  GTList!: any[];
  filteredGTList!: any[];
  shortStopsForm!: FormGroup;
  resultWaste: any;
  wasteButtonShow = false;
  name!: any;
  downTimeForm!: FormGroup;
  downTimeMode = true;
  JobDownTimeId!: any;
  DTFaultList!: any[];
  formDirective: any;
  qualityBoolVal!: string;
  filteredDTFaultList!: any[];
  JbDowntimeHistoryList!: any[];
  materialConsumptionDataSource1!: MatTableDataSource<any>;
  downtimeDataSource!: MatTableDataSource<any>;
  downtimeHistoryDataSource!: MatTableDataSource<any>;
  disableSFDCbuttons = true;
  autoGroupColumnDef = {
    headerName: 'Parameter Group',
    pinned: 'left',
    resizable: true,
    flex: 1,
    sortable: true,
    wrapText: true,
    autoHeight: true,
    filter: true,
    filterValueGetter: (params: any) => params.data.ParameterGroup,
  };
  downtimecolumns2: any[] = [
    'starttime',
    'endtime',
    'duration',
    'fault',
    'remarks',
    'createdon',
    'createdby',
  ];
  materialFoodSectorColumns: any[] = [
    'isrework',
    'batch',
    'length',
    'totalActQty',
    'totalActQtyDrum',
    'remarks',
    'time',
    'createdon',
    'createdby',
    'sfdcactions',
  ];
  downtimeColumns: any[] = [
    'starttime',
    'endtime',
    'duration',
    'fault',
    'remarks',
    'createdon',
    'createdby',
  ];
  executeRole!: any;
  customerManagementColumns: string[] = [
    'action',
    'listName',
    'Area',
    'Machine',
    'createdOn',
    'TotalExec',
    'LastexecDate',
  ];
  selectionName: any;
  groupDataForm!: FormGroup;
  onlymachineSelectProperty = false;
  rowDataDowntimeHistory!: any[];
  ONE_HOUR = 60 * 60 * 1000;
  TWO_HOURS = 2 * (60 * 60 * 1000);
  div1: boolean = true;
  div2: boolean = false;
  div3: boolean = false;
  div4: boolean = false;
  div5: boolean = false;
  div6: boolean = false;
  panelOpenState = false;
  PDtooltip: any;
  columnWasteHistry!: any[];
  frameworkComponents: any;
  rowSelection: any;
  columnDefs!: any[];
  columnDefsDowntimeHistory!: any[];
  materialFoodSectorConsumptionForm!: FormGroup;
  JobBatchMaterialId!: any;
  selectedSupplier!: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefsProcessControl!: any[];
  rowDataProcessControl!: any[];
  rowDataProcessControl2!: any[];
  rowDataQualityControl!: any[];
  rowDataQualityControl2!: any[];
  columnDefsQualityControl!: any[];
  poprocessOrder: any;
  itemCodePo: any;
  itemDescPo: any;
  statusPo: any;
  chartArray: any[] = [];
  qualityProcessOrder = new MatTableDataSource<any>([]);
  startEndDuration: any;
  starttimediff: any;
  endtimediff: any;
  timedifference: any;
  points: any;
  customerManagementDataSource = new MatTableDataSource<any>([]);
  checklistDataForm!: FormGroup;
  goodImgArray: File[] = [];
  formMode = true;
  checkListId!: any;
  checklistId!: number;
  shiftName!: any;
  itemColumns: string[] = ['items', 'good', 'bad', 'standard',
    'minimum',
    'maximum', 'score', 'remarks'];
  addtabledata: Array<{
    id: number;
    itemtype: number;
    drop: string;
    item: string;
    checkListDetailId: number;
    score: number;
    remarks: string;
    catType: string;
    goodImage: string;
    badImage: string;
  }> = [];
  BadExampleImage = false;
  listTypeDDL!: any[];
  valueCheck!: any;
  valueCheck2!: any;
  itemTypeDDL!: any[];
  Plants!: any[];
  unitId: any;
  storageTanksList: any;
  filteredStorageTanksList!: any[];
  machineType = true;
  preAuto = false;
  preAuto2 = false;
  meetingParticipants: any[] = [];
  preCheck!: any;
  checkListAddModel = new MatTableDataSource<any | Group>([]);
  preCheck2!: any;
  _alldata!: any[];
  GoodExampleImage = false;
  isAuto2 = false;
  groupByColumns: string[] = [];
  counter = 1;
  hidetrue = false;
  fileSave!: any;
  categoryTypeDDL: any[] = [
    { id: 'Yes', name: 'Yes' },
    { id: 'No', name: 'No' },
  ];
  yes = true;
  no = true;
  rowDataBatchHistory!: any[];
  materialSubColumns1: any[] = [
    'alternateMaterial',
    'itemtype',
    'itemDesc',
    'itemuom',
    'estQty',
    'consumedQuantity',
    'actQty',
    'actQtyDrums',
    'traceCode',
    'kgUnit',
    // 'NoOfDrums',

  ];
  paramterSpcecificationName: any;
  parametrdefect!: MatTableDataSource<any>;
  processcontrolcolumns: string[] = [
    'LRL',
    'LSL',
    'LWL',
    'TGT',
    'UWL',
    'USL',
    'URL',
  ];
  qcVerifyColumns: string[] = [
    'ParameterId',
    'Parameter',
    'Sample',
    'Value',
    'verify',
    'remarks',
  ];
  parameterspecifications = new MatTableDataSource<any>([]);
  defectColumns: string[] = [
    'DefectMode',
    'Department',
    'Line',
    'Unit',
    'Assembly',
    'Subassembly',
    'Component',
  ];
  gridOptionsBatchHistory: any =
    {
      frameworkComponents: {
        btnCellRenderer: BtnCellRendererNewSFDC,
      },
    };
  defaultColDefinition = {
    rowModelType: 'infinite',
    infiniteInitialRowCount: 2,
    editable: false,
    sortable: true,
    flex: 1,
    minWidth: 225,
    filter: true,
    resizable: true,
    wrapText: true,
    autoHeight: true,
  }

  gridOptions: any = {
    frameworkComponents: {
      btnCellRenderer: BtnCellRendererRawMaterial,
    },
    // gridOptions.columnApi.moveColumns(['gold', 'silver', 'bronze', 'total'], 0);
    defaultColDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 225,
      filter: true,
      resizable: true,
      wrapText: true,
      autoHeight: true,
    },
  };




  selectedMeeting: any = {
    meetingId: 0,
    meetingName: '',
  };
  meetingOriginalArray: any[] = [];
  rowDataMaterialBatchHistory!: any[];
  processIntervalTypeDDL!: any[];
  ItemBOMViewList!: any[];
  materialSubColumns2: any[] = [
    'itemtype',
    'itemDesc',
    'itemuom',
    'estQty',
    'actQty',
    'traceCode',
    'kgUnit',
    // 'NoOfDrums'
  ];
  rowDataMaterialConsumptionHistory!: any[];
  materialHistoryItemBOMList!: MatTableDataSource<any>;
  isFoodMaterialHisory: boolean = false;
  masterList!: any[];
  showButtons = false;
  showShiftClose = false;
  ProductionOutputDataSource!: MatTableDataSource<any>;
  @ViewChild('displayshiftcloseRoleModal')
  private displayshiftcloseRoleModal!: TemplateRef<any>;
  availabilityDataSource!: MatTableDataSource<any>;
  PerformanceDataSource!: MatTableDataSource<any>;
  crewId!: any;
  qualityDataSource!: MatTableDataSource<any>;
  shiftDataSource!: MatTableDataSource<any>;
  shiftactionDataSource!: MatTableDataSource<any>;
  poListDataSource!: MatTableDataSource<any>;
  rowData!: any[];
  canvas!: any;
  ctx!: any;
  lastShiftDataSource!: MatTableDataSource<any>;
  showMode = false;
  Supervisor!: any;
  OEEInfoList!: any[];
  ShiftStart!: any;
  userProfileImg!: any;
  shiftStartDate: any;
  ShiftEnd!: any;
  UserName!: any;
  DowntimeInfoList!: any[];
  Shift!: any;
  @ViewChild('visibleParameterComparison')
  private visibleParameterComparison!: TemplateRef<any>;
  showLastShiftProperty = false;
  UnitName: any;
  IsReworkRequired: boolean = false;
  processGroupType: any;
  intervalList: any;
  crewScheduleList: any;
  shiftList: any;
  qualityControlGroupTypeList: any;
  qualityGroupType: any;
  qualityIntervalList: any;
  processControlForm!: FormGroup;
  qualityControlForm!: FormGroup;
  boolList: any;
  maxCavity: any;
  qualityboolList: any;
  poListForm!: FormGroup;
  lastshiftColumns: string[] = ['sno', 'validations'];
  availabilityColumns: string[] = ['ttime', 'dtime', 'atime', 'rtime', 'mtime'];
  PerformanceColumns: string[] = ['order', 'qty', 'speed', 'total', 'diff'];
  qualityColumns: string[] = [
    'order',
    'production',
    'waste',
    'pieces',
    'calculation',
  ];
  ordersColumns: string[] = [
    'ProcessOrder',
    'ProdCode',
    'ProdDesc',
    'StartTime',
    'EndTime',
  ];

  timer = '00:00:00';
  meetingStartTime: any;
  meetingEndTime: any;
  downTimeStarted = false;
  downTimeStopped = false;
  meetingStarted = false;
  meetingStoped = false;
  rxjsTimer = timer(1000, 1000);
  filteredFailMode: any = [];
  minutes = 0;
  hours = 0;
  seconds = 0;
  days = 0;
  destroy = new Subject();
  QualityIntervalTypeDDL!: any[];
  shiftColumns: string[] = ['sno', 'validation', 'values'];
  shiftCloseArray: ShiftCloseInterface[] = [];
  shiftactionColumns: any[] = ['sno', 'item'];
  JobBatchItemTypeId!: any;
  PPS_ID!: any;
  ItemBOMList!: MatTableDataSource<any>;
  indexMaterial: number = 0;
  statusList!: any[];
  IDtooltip: any;
  batchItemBOMList!: MatTableDataSource<any>;
  isRework: boolean = false;
  HistoryBatchDataSource = new MatTableDataSource<any>();
  translateForm!: FormGroup;
  MeetingMatrixForm!: FormGroup;
  displayUserModal = false;
  faultclose: boolean = true;
  languageDir = 'ltr';
  shift1 = ' ';
  currentprocessOrder: any;
  qcdataSource = new MatTableDataSource<any>([]);
  qcRole = false;
  qcParamsSlot: any;
  qcStartTimeSlot: any;
  qcEndTimeSlot: any;
  qcheadertooltip: any;
  qcProcessorderNo: any;
  qcProdCode: any;
  qcProcdDesc: any;
  detailArray: any;
  verifyCheckedArray: any;
  verifcationStatus: any;
  remarks: any;
  chartSpecifications: any;
  langObj: any = {};
  isCardExpanded = false;
  isCardExpandedQuality = false;
  CollapsehideQuality = false;
  ExdpandhideQuality = true;
  Exdpandhide = true;
  Collapsehide = false;
  @ViewChild('displayQualityOrdersModal')
  private displayQualityOrdersModal!: TemplateRef<any>;
  @ViewChild('visibleYearlyTarget')
  private visibleYearlyTargetTbl!: TemplateRef<any>;
  loadingOverlayComponent: any;
  loadingOverlayComponentParams: any;
  qualityGridApi: any;
  qualityGridColumnApi: any;
  processGridApi: any;
  processGridColumnApi: any;
  isProcessGrid = false;
  boolColId: any;
  boolRowIndex: any;
  SFDC_OEE: any;
  time = new Date();
  SFDC_Availability: any;
  SFDC_Performance: any;
  SFDC_Quality: any;
  SFDC_TotalProducedQTy = 0;
  SFDC_TotalGoodPieces = 0;
  SFDC_Totalwaste: any;
  SFDC_TotalDowntime = 0;
  SFDC_TotalAverageSpeed: any;
  SFDC_RemaningTime = 0;
  calculatedremainingtime: any;
  poStartDate: any;
  curentTimeDiff: any;
  today = new Date();
  subscription!: Subscription;
  cavityList!: any[];
  showCavity = false;
  processControlSpecificationModal!: boolean;
  @ViewChild('qualityBoolListModal')
  private qualityBoolListModal!: TemplateRef<any>;
  dateArrCell = [];
  @ViewChild('qualityDateListModal')
  private qualityDateListModal!: TemplateRef<any>;
  @ViewChild('displayResponsibleModal') private displayResponsibleModal!: TemplateRef<any>;
  OeeDashboardData!: any;

  // Variables from CIL Management
  hideBtn = true;
  hidesidePanel = false;
  displayMAchineModal = false;
  displayComponentModal = false;
  displayActionModal = false;
  CilManagDataForm!: FormGroup;
  CilActionDataForm!: FormGroup;
  performCILItemForm!: FormGroup;
  flattenArr: any;
  hideImage = false;
  disableRow = false;
  plant: any;
  ImageUrl!: any;
  units: any;
  filteredUnits: any;
  components: any[] = [];
  filteredcomponents: any;
  isButtonEnable = true;
  assembly!: any;
  filteredAssembly!: any;
  @ViewChild(MatTable) table!: MatTable<any>;
  compTreeSource = new MatTreeNestedDataSource<any>();
  machineTreeSource = new MatTreeNestedDataSource<any>();
  plantGroupComponentSource = new MatTreeNestedDataSource<PlanGroupComponent>();
  treeControlComponent = new NestedTreeControl<PlanGroupComponent>(
    (node) => node.children
  );

  // Add new variable Group Form
  isEditCILModelVisible = false;

  // Drop-down Variables
  selected: string | undefined;
  selectedMachine: string | undefined;
  selectedComponent: string | undefined;
  selectedGroup!: string;

  // upload file name
  uploadFileInfo!: File;
  file: File | undefined = undefined;

  // Dropdown Values
  plants!: any[];
  Lines!: any[];
  Machines!: any[];
  machineList!: any[];
  componentList!: any[];
  componentId!: any;
  machineId!: any;
  selectedTaskId!: any;
  selectedTaskComp!: any;
  imageSrc = new Array<string>();
  show = false;
  selectedFault = '';
  // Date-Time Picker Variable
  startTime!: any;
  // public date!: moment.Moment;
  public color: ThemePalette = 'primary';
  public showSpinners = true;
  // Icon Url
  grpImgurl = 'assets/images/grp-icon.png';
  pltImgurl = 'assets/images/plt-icon.png';
  divImgurl = 'assets/images/div-icon.png';
  dptImgurl = 'assets/images/dpt-icon.png';
  linImgurl = 'assets/images/lin-icon.png';
  untImgurl = 'assets/images/unt-icon.png';
  asmImgurl = 'assets/images/asm-icon.png';
  samImgurl = 'assets/images/sam-icon.png';
  copImgurl = 'assets/images/cop-icon.png';
  collapseAllImgurl = 'assets/images/collapse-all-icon.png';
  expandAllImgurl = 'assets/images/expand-all-icon.png';
  downloadIconurl = 'assets/images/download-image-icon.png';
  uploadIconurl = 'assets/images/upload-icon.png';
  editIconurl = 'assets/images/edit-icon.png';
  deleteIconurl = 'assets/images/delete-icon.png';
  messageIconurl = 'assets/images/message-icon.png';
  public formGroup = new FormGroup({
    date: new FormControl(null, [Validators.required]),
  });
  shiftstarttime: any;
  shiftendtime: any;
  CILManagementElementData: CILManagementElement[] = [];
  cilmanagementColumns: string[] = [
    'isChecked',
    'action',
    'task',
    'type',
    'unit',
    'component',
    'frequency',
    'nexttime',
    'image',
    'remarks',
    'postImage',
    'postRemarks',
    'sop',

  ];
  executedCilmanagementColumns: string[] = [
    'isChecked',
    'task',
    'type',
    'unit',
    'component',
    'frequency',
    'nexttime',
    'image',
    'remarks',
    'postImage',
    'postRemarks',
    'sop',
    'lastExecutedDate'
  ];
  cilManagementVariableGroupData!: MatTableDataSource<CILManagementElement>;
  selection = new SelectionModel<CILManagementElement>(true, []);

  expandedElement: any;
  // CIL Management End Here
  frameworkComponentsProduction: any;
  startbutton = true;
  pausebutton = true;
  woType: any = [];
  failMode: any = [];
  closebutton = true;
  interval: any;
  ButtonType!: any;
  shiftStartTime: any;
  qualityparameterGroupList: any;
  processparameterGroupList: any;
  fromStartButton = false;
  IsEmptyEndDate = false;
  fileType !: any;
  operatorObj: any;
  chartDownTime: any[] = [];
  rxTime = new Date();
  intervalId: any;
  hasChild = (_: number, node: PlantGroupElement) =>
    !!node.children && node.children.length > 0
  selectedfaultId: any;
  chartData!: any;
  subscription2: Subscription;
  machineName: any;
  machineStatus: any;
  machineProducts: any[];
  selectedParameters: any;
  selectedProducts: any;
  Gridtype: string;
  range = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
  });
  cilManagementExecuted: MatTableDataSource<CILManagementElement>;
  AssignedUsers: any[];
  shiftWiseGrossProduced: number = 0;
  shiftWiseWaste: number = 0;
  shiftWiseNetProduced: number = 0;

  groupSession: any;
  plantSession: any;
  ActiveUserCode: any;
  userMenus: any;
  pageId: string;
  moduleId: any;
  ActiveUsername: string;
  IsAccess = ApplicationPermission.NEW_SFDC_HONEY_ACCESS;
  IsWrite = ApplicationPermission.NEW_SFDC_HONEY_CREATE;
  IsUpdate = ApplicationPermission.NEW_SFDC_HONEY_UPDATE;
  IsDelete = ApplicationPermission.NEW_SFDC_HONEY_DELETE;
  dataSourceView = new MatTableDataSource<any | GroupView>([]);
  checklistDataFormView!: FormGroup;
  alldataView: any;
  groupByColumnsView: string[];
  isChangeOverCheckListShow: boolean = false;
  changeOverProductionList: any[] = [];
  changeOverProductionDataSource = new MatTableDataSource([]);
  ProductId: any;
  changeIntervalMode!: boolean;
  POType = '';
  startInterval!: any;
  endInterval!: any;
  isIntervalSaveMode!: boolean;
  changeOverTableColumn: string[] = ['Product', 'ItemLabel', 'good', 'bad', 'result'];
  doc: any;
  images: any[];
  displayMaximizable: boolean;
  imageIndexOne = 0;
  ncrWorkFlow: any;
  transitions: any;
  columnsQC: any[];
  selectedColumnsQC: any = [];
  selectedColumns: any = [];
  columns: any;
  gridApiCheckList: any;
  gridColumnCheckListApi: any;
  slectedItemBOMDetailId: number = 0;
  scanning: boolean = false;
  qrCodeDialogRef: any;
  qrResultObj: any = {};
  userImage: string = '';
  constructor(
    private QualityCheckService: QualityCheckHistoryService,
    private productivityservice: ProductivityService,
    private commonService: CommonService,
    private crewService: CrewScheduleService,
    private router: Router,
    private toaster: ToastrService,
    private fb: FormBuilder,
    private primengConfig: PrimeNGConfig,
    private spinner: NgxSpinnerService,
    private qualityParameterService: QualityParameterService,
    private processService: ProcessControlService,
    private ChecklistService: ChecklistService,
    private qualityexecutionService: QualityexecutionService,
    private notificationService: NotificationService,
    private machineService: MachineMappingService,
    private AreaServices: AreaService,
    private dialog: MatDialog,
    private sfdService: ShopFloorDataService,
    private machineParamtersService: MachineParamtersService,
    public translate: TranslateService,
    public translater: TranslaterService,
    private cilService: CilConfigurationService,
    private baseApi: BaseApi,
    public datepipe: DatePipe,
    private workFlowService: WorkFlowService,
    private cdRef: ChangeDetectorRef
  ) {
    this.frameworkComponentsProduction = {
      BtnCellRenderer: BtnCellRendererNewSFDC,
    };
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang === 'ar') {
        this.languageDir = 'ltr';
        this.getLangWords();
      } else {
        this.languageDir = 'ltr';
        this.getLangWords();
      }
    });
    this.frameworkComponents = {
      buttonSelectRenderer: ButtonSelectRendererComponent,
      buttonEditRenderer: ButtonEditRendererComponent,
      buttonViewRenderer: ButtonViewRendererComponent,
      buttonPrintRenderer: ButtonPrintRendererComponent,
      customLoadingOverlay: CustomLoadingOverlay,
    };
    this.rowSelection = 'single';
    this.columnDefs = [
      {
        headerName: 'Actions',
        cellRenderer: 'buttonSelectRenderer',
        cellRendererParams: {
          onClick: this.selectHistory.bind(this),
          label: 'select',
        },
        maxWidth: 100,
      },
      { headerName: 'Id', field: 'PPDId', maxWidth: 85 },
      { headerName: 'PO No', field: 'PO', maxWidth: 150 },
      { headerName: 'Operation No', field: 'Oper' },
      { headerName: 'Status', field: 'OperStatus' },
      { headerName: 'Product Details', field: 'ProductDetail' },
      { headerName: 'Item Code', field: 'ItemCode' },
      { headerName: 'Item Description', field: 'ItemDesc' },
      { headerName: 'Priority', field: 'Priority' },
      { headerName: 'Remarks', field: 'Remarks' },
      {
        headerName: 'Created On',
        field: 'CreatedOn',
        valueFormatter: (params: any) => {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
      },
      { headerName: 'Created By', field: 'CreatedBy' },
    ];
    this.ColumnDefsAlternateItem = [
      { headerName: 'Item Code', field: 'ItemCode' },
      { headerName: 'Item Desc', field: 'ItemDesc' },
      { headerName: 'UOM', field: 'UOM' },
      { headerName: 'Estimated Qty', field: 'EsimatedQty' },
    ]
    this.columnMaterialConsumptionHistory = [
      {
        headerName: 'Is Rework',
        field: 'IsRework',
        cellRenderer: (params: any) => (params.value === true ? 'Yes' : 'No'),
        maxWidth: 120,
      },
      { headerName: 'Lotcode/Pallet', field: 'BatchNo' },
      { headerName: 'act', field: 'Result', maxWidth: 180 },
      { headerName: 'Total Act Qty', field: 'Actual' },
      { headerName: 'Total Act Qty Drums', field: 'ActualValueDrum', hide: this.POType === 'Processing' },
      { headerName: 'Remarks', field: 'remarks' },
      {
        headerName: 'Time', field: 'RollStarttime', cellRenderer: (data: any) => {
          return data.value
            ? moment(new Date(data.value)).format('DD/MM/YYYY HH:mm:ss')
            : '';
        },
      },
      {
        headerName: 'Created On', field: 'CreatedOn', cellRenderer: (data: any) => {
          return data.value
            ? moment(new Date(data.value)).format('DD/MM/YYYY HH:mm:ss')
            : '';
        },
      },
      { headerName: 'Created By', field: 'CreatedBy' },
      {
        headerName: 'Actions',
        cellRenderer: 'buttonEditRenderer',
        cellRendererParams: {
          onClick: this.onClickEditFoodSectorMaterial.bind(this),
          label: 'Edit',
        },
        maxWidth: 90,
        suppressMenu: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonViewRenderer',
        cellRendererParams: {
          onClick: this.onClickPopupViewForMaterialHistory.bind(this),
          label: 'View',
        },
        maxWidth: 85,
        suppressMenu: true,
      },
    ];
    this.translateForm = this.fb.group({
      languagvalue: [''],
    });
    this.groupByColumns = ['itemGroup'];
    this.groupByColumnsView = ['itemGroup'];
    this.loadingOverlayComponent = 'customLoadingOverlay';
    this.loadingOverlayComponentParams = {
      loadingMessage: 'One moment please...',
    };
    this.selection.changed.subscribe((item) => {
      this.isButtonEnable =
        this.selection.selected.filter((c: any) => c.submitted === false)
          .length < 2;
    });
  }

  ngOnInit(): void {
    this.getSessionData();
    this.getLangWords();
    this.InitializeForms();
    this.getTreeMasterData();
    this.GetStatus();
    const user = this.baseApi.getUserSession();
    this.userImage = user.picture;
    this.userProfileImg = 'https://o3storage.blob.core.windows.net/o3-live-attachments/' + this.userImage;
    this.subscription2 = timer(0, 1000)
      .pipe(
        map(() => new Date()),
        share()
      )
      .subscribe(time => {
        this.rxTime = time;
      });
    this.onPrevious8();
    this.GetcolumnDefs();

    this.operatorName = this.ActiveUsername;
    this.ImageUrl = Constants.BLOB_STORAGE_URL;
    this.performCILItemForm.get('option')?.valueChanges.subscribe((val) => {
      if (val === 'NotDone') {
        this.performCILItemForm.controls.Remarks.setValidators([
          Validators.required,
        ]);
      } else {
        this.performCILItemForm.controls.Remarks.clearValidators();
      }
      this.performCILItemForm.controls.Remarks.updateValueAndValidity();
    });

    if (this.disableSFDCbuttons === true) {
      // this.toaster.warning('Please select the unit first');
    }




    this.GetTotalBatchForStaticTotal();
    this.total = 'Total: ';
    this.itemCode = 'ProdCode: ';

    this.translateForm.get('languagvalue')?.setValue('en');



    const start = new Date();
    const processdates: any[] = [];
    processdates.push(new Date(start.setHours(0, 0, 0, 0)).toISOString());
    processdates.push(new Date().toISOString());
    this.processControlForm
      .get('datePicker')
      ?.setValue(processdates, { emitEvent: false });
    const qualitydates: any[] = [];
    qualitydates.push(new Date(start.setHours(0, 0, 0, 0)).toISOString());
    qualitydates.push(new Date().toISOString());
    this.qualityControlForm
      .get('datePicker')
      ?.setValue(qualitydates, { emitEvent: false });
    const selected = {
      startDate: new Date(start.setHours(0, 0, 0, 0)),
      endDate: new Date(),
    };
    this.processControlForm.get('datePicker')?.setValue(selected);
    this.qualityControlForm.get('datePicker')?.setValue(selected);
    const source = interval(5 * 60 * 1000);
    this.subscription = source.subscribe((val) =>
      this.onProcessControlRefresh()
    );
    this.subscription = source.subscribe((val) =>
      this.onQualityControlRefresh()
    );

    this.primengConfig.ripple = true; //
    this.initialdisplay();
    this.initialtimer();
    this.GetCurrentDate();

    // this.getGroups();
    this.initialEffect();
  }

  getSessionData(): void {
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.plantSession = this.baseApi.getPlantFromStorage();
    const user = this.baseApi.getUserSession();
    this.ActiveUserCode = user.userCode;
    this.ActiveUsername = user.fullName;
    this.userMenus = this.baseApi.getUserPermissionsSession();

  }

  InitializeForms() {
    this.checklistDataFormView = this.fb.group({
      checktype: [''],
      Listname: [''],
      area: [''],
      executionDate: [''],
      shift: [''],
      Unit: [''],
      currentProcessOrder: [''],
      currentProductDescription: [''],
      previousProcessOrder: [''],
      previousProductDescription: [''],
      targetOrderQuantity: [''],
      producedQuantity: [''],
      con: [''],
      ver: [''],
    });

    this.CilManagDataForm = this.fb.group({
      id: [''],
      unit: new FormControl('', []),
      group: new FormControl('', []),
      plant: new FormControl('', []),
      component: new FormControl('', []),
      machine: new FormControl('', []),
      machineId: new FormControl('', []),
      assembly: new FormControl('', []),
    });

    this.performCILItemForm = this.fb.group({
      // id :[''],
      option: new FormControl('', [Validators.required]),
      startDate: new FormControl('', [Validators.required]),
      endDate: new FormControl('', [Validators.required]),
      Remarks: new FormControl('', [Validators.required]),
      postImage: new FormControl(''),
    });

    this.sfdcForm = this.fb.group({
      group: ['', Validators.required],
    });

    this.materialConsumptionForm = this.fb.group({
      Id: [],
      materialDate: new Date(),
      qty: [],
      lot: [],
      actQty: [],
      remarks: [],
      date: [],
    });
    this.groupDataForm = this.fb.group({
      Id: [],
      group: [''],
      plant: [''],
      line: [''],
      machine: [''],
      status: [''],
      Unit: [''],
      processOrder: [''],
      operationName: [''],
      productDetail: [''],
      itemCode: [''],
      itemDescription: [''],
      remarks: [''],
      fromProcessDate: ['', Validators.required],
      toProcessDate: ['', Validators.required],
      processType: [''],
      parameterInterval: [],
      intervalType: [],
    });

    this.productionOutputForm = this.fb.group({
      batchcon: [],
      pallet: [''],
      actQty: [''],
      remarks: [''],
      time: new Date(),
      storageTanks: [''],
    });
    this.wasteForm = this.fb.group({
      categoryType: [],
      dateTime: new Date(),
      uom: [],
      failureMode: [],
    });
    this.downTimeForm = this.fb.group({
      Id: [],
      startDate: [new Date(), Validators.required],
      endDate: [new Date(new Date().getTime() + this.ONE_HOUR)],
      duration: [''],
      fault: ['', Validators.required],
      faults: [''],
      remarks: [''],
    });
    this.materialFoodSectorConsumptionForm = this.fb.group({
      isRework: [],
      mlotCode: [],
      mActQtys: [],
      tActQtys: [],
      mTime: new FormControl(new Date(), [Validators.required]),
      remarks: [],
    });
    this.shortStopsForm = this.fb.group({
      startDate: new Date(),
      endDate: new Date(),
      duration: [''],
      fault: [''],
      remarks: [''],
    });

    this.poListForm = this.fb.group({
      Id: [],
      poNo: [''],
      operationNo: [''],
      status: [''],
      productDetails: [''],
      itemCode: [''],
      itemDescription: [''],
      priority: [''],
      action: [''],
    });
    this.processControlForm = this.fb.group({
      groupType: [''],
      eventType: [''],
      timeInterval: [0],
      datePicker: [''],
      parameterGroup: [''],
      processType: [''],
      // fromProcessDate: [''],
      // toProcessDate: [''],
      pdfcolumn: [''],
    });
    this.qualityControlForm = this.fb.group({
      groupType: [''],
      eventType: [''],
      datePicker: [''],
      timeInterval: [0],
      fromProcessDate: [''],
      toProcessDate: [''],
      parameterGroup: [''],
      pdfcolumnQC: [''],
    });

    this.checklistDataForm = this.fb.group({
      group: [''],
      plant: [''],
      checktype: ['', Validators.required],
      checkname: ['', [Validators.required, Validators.pattern('[^"]+$')]],
      area: [''],
      executionDate: ['', Validators.required],
      shift: [''],
      shiftName: [''],
      unitName: [''],
      currentProcessOrder: [''],
      currentProcessOrderId: [''],
      currentProductName: [''],
      previousProcessOrder: [''],
      previousProcessOrderId: [''],
      previousProductName: [''],
      date: moment(new Date()).format('YYYY-MM-DD HH:mm'),
    });

    this.MeetingMatrixForm = this.fb.group({
      group: ['', Validators.required],
      plant: ['', Validators.required],
    });
  }

  getTreeMasterData() {
    const group = this.groupSession.groupName.toString();
    const plant = this.plantSession.plantName.toString();

    this.groupDataForm.get('group').setValue(group);
    this.groupDataForm.get('plant').setValue(plant);
    const data = {
      GroupCode: this.groupSession.groupCode,
      PlantCode: this.plantSession.plantCode,
    };
    this.spinner.show();
    this.machineService.GetTreeMasterData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.Line.length > 0) {
          this.Lines = res.Line;
          this.groupDataForm.get('line')?.setValue(this.Lines[0].PL_Id);
          this.getMachines(this.Lines[0].PL_Id);
        } else {
          this.groupDataForm.get('line')?.setValue('');
          this.groupDataForm.get('machine')?.setValue('');
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error?.Status);
      }
    );
  }


  ngAfterViewInit(): void {
    this.initialTheme();
    this.gridOptionsProcessControl.api.hideOverlay();
    this.gridOptionsQualityControl.api.hideOverlay();
  }
  ngOnDestroy(): any {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription2) {
      this.subscription2.unsubscribe();
    }
  }
  isCharNumeric(charStr: any): boolean {
    return !!/\d/.test(charStr);
  }
  // DUMMY CODE
  hasChild1 = (_: number, node: ExampleFlatNode) => node.expandable;
  onRefresh(): void {
    if (this.processControlForm.valid || this.qualityControlForm.valid) {
      const start = new Date();
      const selected = {
        startDate: this.processControlForm.value.datePicker.startDate,
        endDate: new Date(),
      };
      this.processControlForm.get('datePicker')?.setValue(selected);
      const selected2 = {
        startDate: this.qualityControlForm.value.datePicker.startDate,
        endDate: new Date(),
      };
      this.qualityControlForm.get('datePicker')?.setValue(selected2);
      this.rowDataProcessControl = [];
      this.rowDataQualityControl = [];
      this.onToProcessDate();
      this.onToProcessDateQuanlityControl();
    } else {
      this.spinner.hide();
    }
  }

  applyFilter(event: any): void {
    // this.spinner.show();
    const filterValue = (event.target as HTMLInputElement).value;
    this.cilManagementVariableGroupData.filter = filterValue
      .trim()
      .toLowerCase();

    if (this.cilManagementVariableGroupData.paginator) {
      this.cilManagementVariableGroupData.paginator.firstPage();
    }
  }

  // DUMMY CODE
  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }
  initialEffect() {
    const input = document.querySelector('#input');
    input?.classList.remove('effect');
    input?.classList.add('disableEffect');
  }
  initialtimer(): void {
    const wrapper1 = document.querySelector('#timer');
    wrapper1?.classList.add('hide-timer');
    wrapper1?.classList.remove('show-timer');
  }
  initialdisplay(): void {
    const wrapper1 = document.querySelector('#wrapper1');
    wrapper1?.classList.add('content-show');
    wrapper1?.classList.remove('content-hide');
    const wrapper2 = document.querySelector('#wrapper2');
    wrapper2?.classList.remove('content-show');
    wrapper2?.classList.add('content-hide');
    const wrapper3 = document.querySelector('#wrapper3');
    wrapper3?.classList.remove('content-show');
    wrapper3?.classList.add('content-hide');
    const wrapper4 = document.querySelector('#wrapper4');
    wrapper4?.classList.remove('content-show');
    wrapper4?.classList.add('content-hide');
    const wrapper5 = document.querySelector('#wrapper5');
    wrapper5?.classList.remove('content-show');
    wrapper5?.classList.add('content-hide');
    const wrapper6 = document.querySelector('#wrapper6');
    wrapper6?.classList.remove('content-show');
    wrapper6?.classList.add('content-hide');
    const wrapper7 = document.querySelector('#wrapper7');
    wrapper7?.classList.remove('content-show');
    wrapper7?.classList.add('content-hide');
    const wrapper8 = document.querySelector('#wrapper8');
    wrapper8?.classList.remove('content-show');
    wrapper8?.classList.add('content-hide');
  }

  ProcessControltoggleTimer(): void {
    if (this.processControlResumeInterval) {
      this.processControlResumeInterval = false;
    } else {
      this.processControlResumeInterval = true;
    }
  }

  QualityControltoggleTimer(): void {
    if (this.qualityControlResumeInterval) {
      this.qualityControlResumeInterval = false;
    } else {
      this.qualityControlResumeInterval = true;
    }
  }

  onChangeLine(data: any): void {
    this.getMachines(data.value);
  }

  getMachines(id: any): void {
    const key = {
      LineId: this.groupDataForm.value.line,
      // userCode: this.ActiveUserCode,
    };
    this.commonService.getUnitList(key).subscribe(
      (res: any) => {
        this.Machines = res;
        if (res?.length > 0) {
          this.groupDataForm.get('machine')?.setValue(this.Machines[0].unitId);
          this.SelectUnitName();
          this.GetProcessOrderList();
          this.resetMeeting();
          this.getAssembly();
          // this.GetJbDowntimeHistory();
        } else {
          this.groupDataForm.get('machine')?.setValue('');
        }
      },
      (error) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  shiftCloseChange(event: any, element: any): void {
    const found = this.shiftCloseArray.find((x) => x.sno === element.sno);
    if (found) {
      found.item = event.target.value.trim();
    }
  }
  getArea(): any {
    const key = {
      plantId: this.checklistDataForm.value.plant,
    };
    this.AreaServices.getQualityArea(key).subscribe(
      (areadata: any) => {
        this.areaDDL = areadata;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
        this.spinner.hide();
      }
    );
  }
  scoreUpdate(event: any, data: any): void {
    this.detailPrentId = data.checkListDetailId;
    const checkListDetailId = parseInt(data.checkListDetailId, 10);
    const d = this._alldata.find(
      (x) => x.checkListDetailId === checkListDetailId
    );
    if (data.itemType === 1) {
      const v = event.value;
      d.catType = v;
    } else {
      const score = event.target.value === '' ? '' : event.target.value;
      d.score = score;
      d.catType = score;
    }

    const result = this.checkListAddModel;
  }

  showPositionDialog(position: string) {
    this.position = position;
    this.displayPosition = true;
  }


  ViewBatchCheckListByUnitForProductionOutput(): void {
    this.batchCheckList = [];
    const key = {
      PUId: this.machineId,
      UserCode: this.ActiveUserCode,
      JobBatchId: this.JobBatchId, // 17911
    };
    this.spinner.show();
    this.sfdService.GetJbBatchchecklistDetails(key).subscribe((res: any) => {
      const array: any = [];
      res.batchCheckList.forEach(
        (element: {
          BatchCheckListTypeId: any;
          Name: any;
          DataType: any;
          BatchCheckListValue: any;
        }) => {
          const data2 = {
            BatchCheckListTypeId: element.BatchCheckListTypeId,
            Name: element.Name,
            DataType: element.DataType,
            BatchCheckListValue: element.BatchCheckListValue,
          };
          array.push(data2);
        }
      );
      this.ViewProductionOutputDataSource = new MatTableDataSource<any>(array);
      this.spinner.hide();
      this.GetBatchCheckListByUnit();
    });
  }
  viewProductionHistoryBatch(element: any): void {
    this.JobBatchId = element.JobBatchId;
    this.ViewProductionOutputDataSource = new MatTableDataSource<any>([]);
    this.ViewBatchCheckListByUnitForProductionOutput();
  }
  RefreshMaterialConsumption(): void {
    this.materialConsumptionForm.get('lot')?.reset();
    this.materialConsumptionForm.get('actQty')?.reset();
    this.materialConsumptionForm.get('remarks')?.reset();
    this.materialConsumptionForm
      .get('materialDate')
      ?.setValue(this.ItemTypeList[0]?.BatchItemTypeId);
    this.materialConsumptionForm.get('date')?.setValue(new Date());
    this.materialConsumptionMode = true;
  }
  RefreshProductionOutput(): void {
    this.productionOutputForm.get('actQty')?.reset();
    this.productionOutputForm.get('remarks')?.reset();
    this.productionOutputForm.get('batchcon')?.reset();
    this.productionOutputForm.get('time')?.setValue(new Date());
    this.productionMode = true;
    this.GetBatchCheckListByUnit();
    this.LastInstOPjobBatch();
    this.GetLatestLotCode();
  }
  RefreshWaste(): void {
    this.wasteForm.get('dateTime')?.setValue(new Date());
    this.wasteForm.get('failureMode')?.reset();
    this.wasteForm.get('uom')?.reset();
    this.wasteForm.get('categoryType')?.setValue(this.FaultList[0]?.FaultId);
    this.wasteMode = true;
  }
  RefreshDownTime(): void {
    this.downTimeForm.get('remarks')?.reset();
    this.downTimeForm.reset();
    this.dialog.closeAll();
    this.downTimeMode = true;
  }
  editDownTime(element: any): void {
    this.downTimeMode = false;
    this.downTimeForm.get('startDate')?.setValue(element.StartTime);
    if (element.EndTime === null) {
      this.IsEmptyEndDate = true;
    }
    this.downTimeForm.get('endDate')?.setValue(element.EndTime);
    this.downTimeForm.get('duration')?.setValue(element.Duration);
    this.downTimeForm
      .get('fault')
      ?.setValue(
        this.DTFaultList.find((x) => x.FaultName === element.FaultName).FaultId
      );
    this.downTimeForm.get('remarks')?.setValue(element.Remarks);
    this.JobDownTimeId = element.JobDownTimeId;
    this.dialog.closeAll();
    this.getMinutes(element);
    this.getEndMinutes(element);
  }

  GetJbDowntimeHistory(): void {
    const key = {
      PUID: this.machineId,
      UserCode: this.ActiveUserCode,
      Ishistory: false,
    };
    this.spinner.show();
    this.downtimeDataSource = new MatTableDataSource<any>([]);
    this.sfdService.GetJbDowntimeHistory(key).subscribe((res: any) => {
      this.spinner.hide();

      this.JbDowntimeHistoryList = res.JbDowntimeHistoryList;
      this.downtimeDataSource = new MatTableDataSource<any>(
        res.JbDowntimeHistoryList
      );
    });
  }

  GetJbDowntimeHistory1(): void {
    this.downTimeStarted = false;
    const key = {
      PUID: this.machineId,
      UserCode: this.ActiveUserCode,
      Ishistory: true,
    };
    this.spinner.show();
    this.downtimeHistoryDataSource = new MatTableDataSource<any>([]);
    this.sfdService.GetJbDowntimeHistory(key).subscribe((res: any) => {
      this.JbDowntimeHistoryList = res.JbDowntimeHistoryList;
      this.downtimeHistoryDataSource = new MatTableDataSource<any>(
        res.JbDowntimeHistoryList
      );
      // let counter = 0;
      this.SFDC_TotalDowntime = 0;
      this.getDefaultFault();
      this.JbDowntimeHistoryList.forEach((element) => {
        if (element.EndTime === null) {
          this.selectedFault = element.FaultName;
          const stratTime = new Date(element.StartTime);
          const dateFuture = new Date().valueOf();
          const dateNow = stratTime.valueOf();
          let seconds = Math.floor((dateFuture - dateNow) / 1000);
          let minutes = Math.floor(seconds / 60);
          let hours = Math.floor(minutes / 60);
          const days = Math.floor(hours / 24);
          hours = hours - days * 24;
          minutes = minutes - days * 24 * 60 - hours * 60;
          seconds = seconds - days * 86400 - hours * 3600 - minutes * 60;
          this.hours = hours;
          this.minutes = minutes;
          this.seconds = seconds;
          this.days = days;
          this.downTimeStarted = true;
          this.timerflag = !this.timerflag;
          const wrapper1 = document.querySelector('#timer');
          wrapper1?.classList.remove('hide-timer');
          wrapper1?.classList.add('show-timer');
          clearInterval(this.interval);
          this.timer = '00:00:00';
          this.applyTheme();
          this.interval = setInterval(() => {
            this.seconds = this.seconds + 1;
            if (this.seconds === 60) {
              this.minutes = this.minutes + 1;
              this.seconds = 0;
            }
            if (this.minutes === 60) {
              this.hours = this.hours + 1;
              this.minutes = 0;
              this.seconds = 0;
            }
            if (this.hours === 24) {
              this.days = this.days + 1;
              this.hours = 0;
              this.minutes = 0;
              this.seconds = 0;
            }
            if (this.days > 0) {
              this.timer =
                this.days +
                ':' +
                ('0' + this.hours).slice(-2) +
                ':' +
                ('0' + this.minutes).slice(-2) +
                ':' +
                ('0' + this.seconds).slice(-2);
            } else {
              this.timer =
                ('0' + this.hours).slice(-2) +
                ':' +
                ('0' + this.minutes).slice(-2) +
                ':' +
                ('0' + this.seconds).slice(-2);
            }
          }, 1000);
        }
      });
      this.downTimeForm.get('duration')?.setValue('60');
      // tslint:disable-next-line:max-line-length
      const array = this.JbDowntimeHistoryList.filter(
        (x) =>
          (new Date(x.EndTime) > this.shiftstart &&
            new Date(x.EndTime) <= new Date(Date.now())) ||
          x.EndTime === null
      );
      //  this.chartDownTime = [];
      this.chartDownTime = [];
      array.map((elem: any) => {
        const obj =
        {
          x: Date.UTC(new Date(elem.StartTime).getFullYear(), new Date(elem.StartTime).getUTCMonth(),
            new Date(elem.StartTime).getUTCDate(),
            new Date(elem.StartTime).getHours(), new Date(elem.StartTime).getMinutes(), new Date(elem.StartTime).getSeconds()),
          x2: Date.UTC(new Date(elem.EndTime).getFullYear(), new Date(elem.EndTime).getUTCMonth(),
            new Date(elem.EndTime).getUTCDate(),
            new Date(elem.EndTime).getHours(), new Date(elem.EndTime).getMinutes(), new Date(elem.EndTime).getSeconds()),
          color: '#FF0000'
        };
        this.chartDownTime.push(obj);
      });


      this.getSFDCChart();

      this.rowDataDowntimeHistory = res.JbDowntimeHistoryList;

      this.spinner.hide();

      this.getPaginator(this.downtimeHistoryDataSource, 2);
    });
  }

  imageZoomModal(imagePath: string): void {
    this.currentImagePath = imagePath;
    this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }

  ProfileImageZoom(imagePath: string): void {
    this.currentImagePath = imagePath;
    this.dialog.open(this.ProfileImageZoomModal, {
      height: '50%',
      width: '30%',
    });
  }

  imageZoomModalShow(imagePath: string): void {
    this.currentImagePath = imagePath;
    this.dialog.open(this.imageZoomModelShow, { height: '90%', width: '90%' });
  }
  onChangeradio(value: any): void {
    if (value.value === 'Yes') {
      this.yes;
    } else {
      this.no;
    }
  }
  uploadedFile(event: any, checkListDetailId: number): void {
    const ind = this.addtabledata.findIndex(
      (c: any) => c.checkListDetailId === checkListDetailId
    );
    const found = this.goodImgArray[ind];
    if (found) {
      this.goodImgArray[ind] = event.target.files[0];
      this.addtabledata[ind].catType = event.target.files[0]?.name;
    } else {
      if (event.target.files.length > 0) {
        this.fileSave = event.target.files[0];
        this.addtabledata[ind].catType = event.target.files[0].name;
        this.goodImgArray.push(this.fileSave);
      }
    }
  }
  onDateChange(event: any, element: any): void {
    this.getDateShifts(event);
    const checkListDetailId = parseInt(element.checkListDetailId, 10);
    const d = this._alldata.find(
      (x) => x.checkListDetailId === checkListDetailId
    );
    d.catType = event.target.value;
  }
  remarksUpdate(event: any, data: any): void {
    const remarks = event.target.value;
    const checkListDetailId = parseInt(data.checkListDetailId, 10);
    const m = this._alldata.find(
      (x) => x.checkListDetailId === checkListDetailId
    );
    m.remarks = remarks;

    const result = this.checkListAddModel;
  }

  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.today) > 0;
  groupHeaderClick(row: any): void {
    row.expanded = !row.expanded;
    this.checkListAddModel.filter = performance.now().toString(); // bug here need to fix
  }

  isGroup(index: any, item: any): boolean {
    return item.level;
  }
  GetBatchCheckListByUnit() {
    this.batchCheckList = [];
    const key = {
      PUId: this.machineId,
    };

    this.sfdService.GetBatchCheckListByUnit(key).subscribe((res: any) => {
      this.batchCheckList = [];
      res.batchCheckList.forEach(
        (
          element: { BatchCheckListTypeId: any; Name: any; DataType: any },
          index: any
        ) => {
          this.BatchCheckListTypeId = element.BatchCheckListTypeId;
          const data = {
            BatchCheckListTypeId: element.BatchCheckListTypeId,
            Name: element.Name,
            DataType: element.DataType,
            DataValue: element.DataType === 'bool' ? false : '',
          };
          this.batchCheckList.push(data);
        }
      );
      const array = [];
      for (let i = 0; i < res.batchCheckList.length; i++) {
        if (res.batchCheckList[i].DataType === 'dropdown') {
          array.push(res.batchCheckList[i]);
          this.dropdownArray = array;
        }
        for (let j = 0; j < this.dropdownArray.length; j++) {
          this.newDropdownList[i] = this.dropdownArray[j].BCListType.masterList;
          this.checkListFunctionForDropdown(
            this.batchCheckList[i].BatchCheckListTypeId,
            this.newDropdownList[i][0]?.TypeName
          );
        }
      }
      this.productionOutputDataSource = new MatTableDataSource<any>([]);
      this.productionOutputDataSource = new MatTableDataSource<any>(
        this.batchCheckList
      );
    });
  }
  checkListFunctionForDropdown(id: number, value: any): void {
    const check = this.batchCheckList.find(
      (x: { BatchCheckListTypeId: number }) => x.BatchCheckListTypeId === id
    );
    if (check.DataType === 'dropdown') {
      check.DataValue = value;
    }
  }

  LastInstOPjobBatch(): void {
    const key = {
      PPDID: this.PPID,
      UserCode: this.ActiveUserCode,
      Ishistory: false,
      BatchTypeId: 3,
      JobBatchItemTypeId: 0,
    };
    // this.spinner.show();

    this.sfdService.GetJbBatchHistory(key).subscribe((res: any) => {
      this.HistoryBatchDataSource1 = new MatTableDataSource<any>(
        res.JbBatchHistoryList
      );
      // this.spinner.hide();
    });
  }

  GetLatestLotCode(): void {
    const key = {
      PPDID: this.PPID,
      PUID: this.machineId,
    };
    this.sfdService.GetLatestLotCode(key).subscribe((res: any) => {
      this.isAuto = res.isAuto;
      if (res.isAuto === true) {
        this.productionOutputForm.get('pallet')?.setValue(res.LotCode);
      } else {
        this.productionOutputForm.get('pallet')?.setValue(res.LotCode);
      }
    });
  }

  GetLableBatch(element: any): void {
    const key = {
      PPDID: 0,
      BatchTypeId: 0,//this.materialConsumptionForm.get('materialDate')?.value,
      UserCode: this.ActiveUserCode,
      PUID: this.machineId,
      TypeId: 1,
    };
    this.sfdService.GetLableBatch(key).subscribe((res: any) => {
      this.materialConsumptionForm.get('qty')?.setValue(res.Qty);
      this.materialConsumptionForm.get('date')?.setValue(new Date());
      this.qty = res.Qty;
      this.result = res.Result;

      this.columnMaterialConsumptionHistory.forEach(function (
        colDef: { headerName: string },
        index: any
      ) {
        if (colDef.headerName === 'act') {
          colDef.headerName = 'Estimated Qty' + '(' + res.Result + ')';
        }
      });
      this.itemCode =
        'Item Code: ' +
        this.ItemTypeList.find(
          (x: { BatchItemTypeId: any }) => x.BatchItemTypeId === element.value
        )?.ItemCode;
      this.GetJbBatchHistory();
      this.GetJbBatchHistory1();
      this.GetTotalBatch();
    });
  }
  GetJbBatchHistory(): void {
    const key = {

      PPDID: this.PPID !== undefined ? this.PPID : 0,
      UserCode: this.ActiveUserCode,
      Ishistory: false,
      BatchTypeId: 1,
      JobBatchItemTypeId: 0
    };
    this.spinner.show();
    this.sfdService.GetJbBatchHistory(key).subscribe((res: any) => {
      this.columnMaterialBatchHistory = [
        {
          headerName: 'Action',
          hide: !this.IsWrite,
          lockPosition: true,
          cellRenderer: 'buttonEditRenderer',
          cellRendererParams: {
            onClick: this.onClickEditMaterialConsumptionBatch.bind(this),
            label: 'Edit',
          },
        },
        { headerName: 'Item Type', field: 'Name' },
        { headerName: 'Lotcode/Details', field: 'BatchNo' },
        { headerName: 'Act Qty' + '(' + this.result + ')', field: 'Result' },
        { headerName: 'Remarks', field: 'Remarks' },
        {
          headerName: 'Time',
          field: 'RollStarttime',
          valueFormatter: function (params: any) {
            return moment(params.value).format('MM/DD/YYYY HH:mm');
          },
        },
        {
          headerName: 'Created On',
          field: 'CreatedOn',
          valueFormatter: function (params: any) {
            return moment(params.value).format('MM/DD/YYYY HH:mm');
          },
        },
        {
          headerName: 'Created By', field: 'CreatedBy'//, maxWidth: 120 
        },
      ];

      this.materialConsumptionDataSource = new MatTableDataSource<any>(
        res.JbBatchHistoryList
      );
      this.spinner.hide();
    });
  }
  GetJbBatchHistory1(): void {
    const key = {
      PPDID: this.PPID !== undefined ? this.PPID : 0,
      UserCode: this.ActiveUserCode,
      Ishistory: true,
      BatchTypeId: 1,
      JobBatchItemTypeId: 0,
    };
    this.spinner.show();
    this.materialConsumptionDataSource1 = new MatTableDataSource<any>([]);
    this.sfdService.GetJbBatchHistory(key).subscribe((res: any) => {
      this.materialConsumptionDataSource1 = new MatTableDataSource<any>(
        res.JbBatchHistoryList
      );
      this.rowDataMaterialBatchHistory = res.JbBatchHistoryList;
      this.spinner.hide();

      this.getPaginator(this.materialConsumptionDataSource1, 2);
    });
  }
  GetTotalBatch(): void {
    const key = {
      PPDID: this.PPID,
      BatchTypeId: 1,
      BatchItemTypeId: this.materialConsumptionForm.get('materialDate')?.value,
      UserCode: this.ActiveUserCode,
    };
    this.sfdService.GetTotalBatch(key).subscribe((res: any) => {
      this.total = res.ErrorMessage;
    });
  }
  SaveJBBatchInfoForMaterialConsumption(): void {
    this.disablMaterialSave = true;
    const key = {
      TransactionTypeId: 1,
      PPDID: this.PPID !== undefined ? this.PPID : 0,
      JobBatchId: 0,
      BatchTypeId: 1,
      RollNo: 0,
      Result: this.materialConsumptionForm.value.actQty,
      BatchNo: this.materialConsumptionForm.value.lot,
      BatchItemTypeId: 0,
      Remarks: this.materialConsumptionForm.value.remarks,
      RollStarttime: this.materialConsumptionForm.value.date,
      UserCode: this.ActiveUserCode,
      JobBatchCheckList: []
    };
    const data = {
      plantId: this.groupDataForm.value.plant,
      lotcode: this.materialConsumptionForm.value.lot,
      eventDateTime: this.materialConsumptionForm.value.date,
      eventTypeId: 1,
      puId: this.machineId,
      processOrder: this.groupDataForm.get('processOrder')?.value,
      processOrderId: this.PPID,
    };
    this.sfdService.SaveJBBatchInfo(key).subscribe(
      (res: any) => {
        this.disablMaterialSave = false;
        this.getOeeDashboard();
        if (res.ErrorMessage.substring(2, 1) === '0') {
          this.sfdService.insertSfdcEvent(data).then(
            (response) => { },
            (error) => {
              this.showPopupMsg(error.ErrorMessage);
            }
          );
        }
        this.GetJbBatchHistory();

        this.GetTotalBatch();
        this.showPopupMsg(res.ErrorMessage);
        this.materialConsumptionForm.get('date')?.setValue(new Date());
        this.materialConsumptionForm
          .get('materialDate')
          ?.setValue(this.ItemTypeList[0]?.BatchItemTypeId);
        this.materialConsumptionForm.get('lot')?.reset();
        this.materialConsumptionForm.get('actQty')?.reset();
        this.materialConsumptionForm.get('remarks')?.reset();
        const start = new Date();
        const selected = {
          startDate: this.processControlForm.value.datePicker.startDate,
          endDate: new Date(),
        };
        this.processControlForm.get('datePicker')?.setValue(selected);
        const selected2 = {
          startDate: this.qualityControlForm.value.datePicker.startDate,
          endDate: new Date(),
        };
        this.qualityControlForm.get('datePicker')?.setValue(selected2);
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  showPopupMsg(msg: any): any {
    if (msg !== null || msg !== '') {
      if (msg.substring(2, 1) === '0') {
        this.dialog.closeAll();
        this.toaster.success('Success', msg.substring(3, msg.length));
      } else {
        this.toaster.error('Error', msg.substring(3, msg.length));
      }
    }
  }
  SumbitShiftClose(manPower: any): void {
    if (manPower > 0) {
      Swal.fire({
        title: this.translate.instant('MakeSure'),
        text: this.translate.instant('AllDetails'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.translate.instant('Ok'),
        cancelButtonText: this.translate.instant('Cancel'),
      }).then((result) => {
        if (result.value) {
          const key = {
            CrewId: this.crewId,
            ShiftActionList: this.shiftCloseArray,
            ManPowerRequired: manPower,
          };
          this.sfdService.SumbitShiftClose(key).subscribe((res: any) => {
            this.successMessage = res.ErrorMessage;
            this.showPopupMsg(res.ErrorMessage);
            this.GetIsShiftStart();
            this.dialog.closeAll();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            this.translate.instant('Cancelled'),
            this.translate.instant('AlertShiftMessage'),
            'error'
          );
        }
      });
    } else {
      this.toaster.error(
        this.translate.instant('ManPower should be greater than Zero')
      );
    }
  }

  UpdateJBBatchInfoForMaterialConsumption(): void {
    this.disablMaterialSave = true;
    const key = {
      TransactionTypeId: 2,
      PPDID: this.PPID,
      JobBatchId: this.JobBatchId,
      BatchTypeId: 1,
      RollNo: 0,
      Result: this.materialConsumptionForm.value.actQty,
      BatchNo: this.materialConsumptionForm.value.lot,
      BatchItemTypeId: this.materialConsumptionForm.value.materialDate,
      Remarks: this.materialConsumptionForm.value.remarks,
      RollStarttime: this.materialConsumptionForm.value.date,
      UserCode: this.ActiveUserCode,
    };
    this.sfdService.SaveJBBatchInfo(key).subscribe(
      (res: any) => {
        this.disablMaterialSave = false;
        this.getOeeDashboard();
        this.GetTotalBatch();
        this.GetJbBatchHistory();
        this.showPopupMsg(res.ErrorMessage);
        this.materialConsumptionForm.get('lot')?.reset();
        this.materialConsumptionForm.get('actQty')?.reset();
        this.materialConsumptionForm.get('remarks')?.reset();
        this.materialConsumptionMode = true;
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }
  UpdateJBDowntimeInfo(n: number): void {
    let IsHavingEndDateNull = true;
    this.rowDataDowntimeHistory.forEach((elem) => {
      if (elem.EndTime === null) {
        IsHavingEndDateNull = false;
      }
    });
    if (this.downTimeForm.get('endDate')?.value !== null) {
      const timeDiff = moment(this.downTimeForm.get('endDate')?.value).diff(
        moment(new Date(this.downTimeForm.get('startDate')?.value)),
        'minutes'
      );
      const key = {
        TransactionTypeId: 2,
        PUID: this.machineId,
        JobdowtimeId: this.JobDownTimeId,
        FaultId: this.downTimeForm.get('fault')?.value,
        StartTime: this.downTimeForm.get('startDate')?.value,
        EndTime: this.downTimeForm.get('endDate')?.value,
        Remarks: this.downTimeForm.get('remarks')?.value,
        Duration: timeDiff, // this.downTimeForm.get('duration')?.value,
        UserCode: this.ActiveUserCode,
      };
      this.sfdService.SaveJBDowntimeInfo(key).subscribe(
        (res: any) => {
          if (n === 1) {
            clearInterval(this.interval);
            this.timer = '';
            this.downTimeStarted = false;
            this.removeTheme();
            const wrapper1 = document.querySelector('#timer');
            wrapper1?.classList.add('hide-timer');
            wrapper1?.classList.remove('show-timer');
          }
          if (n === 2 && this.IsEmptyEndDate) {
            clearInterval(this.interval);
            this.timer = '';
            this.downTimeStarted = false;
            const wrapper1 = document.querySelector('#timer');
            wrapper1?.classList.add('hide-timer');
            wrapper1?.classList.remove('show-timer');
            this.removeTheme();
          }
          this.GetJbDowntimeHistory1();
          this.GetJbDowntimeHistory();
          this.showPopupMsg(res.ErrorMessage);
          this.downTimeForm.get('remarks')?.reset();
          this.downTimeMode = true;
        },
        (error) => {
          this.showPopupMsg(error.ErrorMessage);
          this.timer = '';
          clearInterval(this.interval);
          this.downTimeStarted = false;
        }
      );
    }
    else {
      const key = {
        TransactionTypeId: 2,
        PUID: this.machineId,
        JobdowtimeId: this.JobDownTimeId,
        FaultId: this.downTimeForm.get('fault')?.value,
        StartTime: this.downTimeForm.get('startDate')?.value,
        EndTime: null,
        Remarks: this.downTimeForm.get('remarks')?.value,
        Duration: null, // this.downTimeForm.get('duration')?.value,
        UserCode: this.ActiveUserCode,
      };
      this.sfdService.SaveJBDowntimeInfo(key).subscribe(
        (res: any) => {
          this.GetJbDowntimeHistory1();
          this.GetJbDowntimeHistory();
          this.showPopupMsg(res.ErrorMessage);
          this.downTimeForm.get('remarks')?.reset();
          this.downTimeMode = true;
        },
        (error) => {
          this.showPopupMsg(error.ErrorMessage);
          this.timer = '';
          clearInterval(this.interval);
          this.downTimeStarted = false;
        }
      );
    }
  }

  getFoodSectorMaterialConsumptionHistoryList(): void {
    const key = {
      Ishistory: true,
      PPDId: this.PPID,
    };
    this.sfdService.getBatchItemBOMList(key).subscribe(
      (res: any) => {
        this.materialHistoryItemBOMList = res.BatchItemBOMList;
        this.rowDataMaterialConsumptionHistory = res.BatchItemBOMList;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }
  openHistoryFoodMaterialModal(): void {
    this.isFoodMaterialHisory = true;
    this.dialog.open(this.historyMaterialModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.getFoodSectorMaterialConsumptionHistoryList();
  }

  RemainingTime(): void {
    const num = this.SFDC_RemaningTime;
    const days = num / 1440;
    const rdays = Math.round(days);
    const hours = num / 60;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    if (rhours >= 24) {
      this.calculatedremainingtime = rdays + 'day(s)';
    } else if (rminutes >= 60) {
      this.calculatedremainingtime =
        rhours + ' hr(s) and ' + rminutes + ' min(s).';
    } else if (rminutes < 60) {
      this.calculatedremainingtime = rminutes + ' min(s).';
    }
  }
  openModal(): void {
    if (this.onlymachineSelectProperty === true) {
      this.dialog.open(this.displayRoleModal, {
        width: '100vw !important',
        height: 'auto',
        minWidth: '100vw',
      });
    } else {
      this.toaster.error('error', this.translate.instant('UnitSelection'));
    }
  }

  openHistorybatchModal(element: any): void {
    if (this.machineSelectProperty === true) {
      this.dialog.open(this.historyBatch1Modal, {
        width: '100vw !important',
        height: 'auto',
        minWidth: '100vw',
      });
    } else {
      this.toaster.error('error', this.translate.instant('PoListSelection'));
    }
    const code = { value: this.ItemTypeList[0]?.BatchItemTypeId };
    this.GetLableBatch(code);
  }

  createNewRow(id: number): ShiftCloseInterface {
    return {
      sno: id,
      item: '',
    };
  }
  shAdd(): void {
    const data: ShiftCloseInterface[] = [];
    for (let i = 1; i <= 50; i++) {
      data.push(this.createNewRow(i));
    }
    this.shiftactionDataSource.data.push(
      this.createNewRow(this.shiftactionDataSource.data.length + 1)
    );
    this.shiftactionDataSource.filter = '';
    this.shiftCloseArray.push(
      this.createNewRow(this.shiftactionDataSource.data.length)
    );
  }
  editProductionHistoryBatch(element: any): void {
    this.productionMode = false;
    this.productionOutputForm.get('batchcon')?.setValue(element.IPBatchId);
    this.productionOutputForm.get('pallet')?.setValue(element.BatchNo);
    this.productionOutputForm.get('actQty')?.setValue(element.Result);
    this.productionOutputForm.get('remarks')?.setValue(element.Remarks);
    this.productionOutputForm.get('time')?.setValue(element.RollStarttime);
    this.productionOutputForm.get('storageTanks')?.setValue(element.TankId)
    this.JobBatchId = element.JobBatchId;
    this.ProductionOutputDataSource = new MatTableDataSource<any>([]);
    this.GetBatchCheckListByUnitForProductionOutput();
    this.dialog.closeAll();
  }
  GetBatchCheckListByUnitForProductionOutput(): void {
    this.batchCheckList = [];
    const key = {
      PUId: this.machineId,
      UserCode: this.ActiveUserCode,
      JobBatchId: this.JobBatchId,
    };
    this.sfdService.GetJbBatchchecklistDetails(key).subscribe((res: any) => {
      const array: any = [];
      res.batchCheckList.forEach(
        (element: {
          BatchCheckListTypeId: any;
          Name: any;
          DataType: any;
          BatchCheckListValue: any;
        }) => {
          const data2 = {
            BatchCheckListTypeId: element.BatchCheckListTypeId,
            Name: element.Name,
            DataType: element.DataType,
            BatchCheckListValue: element.BatchCheckListValue,
          };
          array.push(data2);
          this.batchCheckList = res.batchCheckList;
        }
      );
      this.productionOutputDataSource = new MatTableDataSource<any>([]);
      this.productionOutputDataSource = new MatTableDataSource<any>(array);
    });
  }
  SaveJBBatchInfoForProductionOutput(): void {
    const array: {
      BatchCheckListTypeId: number;
      BatchCheckListValue: any;
    }[] = [];
    this.batchCheckList.forEach(
      (element: { BatchCheckListTypeId: any; DataValue: any }) => {
        const data = {
          BatchCheckListTypeId: element.BatchCheckListTypeId ? element.BatchCheckListTypeId : 0,
          BatchCheckListValue: element.DataValue ? element.DataValue : 0,
        };
        array.push(data);
      }
    );
    const key = {
      TransactionTypeId: 1,
      PPDID: this.PPID,
      JobBatchId: 0,
      BatchTypeId: 3,
      RollNo: 0,
      Result: this.productionOutputForm.value.actQty,
      BatchNo: this.productionOutputForm.value.pallet,
      BatchItemTypeId: 0,
      Remarks: this.productionOutputForm.value.remarks,
      RollStarttime: this.productionOutputForm.value.time,
      UserCode: this.ActiveUserCode,
      IPBatch: this.productionOutputForm.value.batchcon ? this.productionOutputForm.value.batchcon : 0,
      JobBatchCheckList: array,
      StorageTankId: this.productionOutputForm.value.storageTanks ? this.productionOutputForm.value.storageTanks : null
    };
    const data = {
      plantId: this.groupDataForm.value.plant,
      lotcode: this.productionOutputForm.value.pallet,
      eventDateTime: this.productionOutputForm.value.time,
      eventTypeId: 2,
      puId: this.machineId,
      processOrder: this.groupDataForm.get('processOrder')?.value,
      processOrderId: this.PPID,
    };
    this.sfdService.SaveJBBatchInfo(key).subscribe((res: any) => {
      if (this.machineSelectProperty === true) {
        this.LastInstOPjobBatch();
        this.getOeeDashboard();
        this.GetJbBatchHistoryNew();
        this.GetTotalBatch1();
        this.GetLatestLotCode();
        this.showPopupMsg(res.ErrorMessage);
        this.GetBatchCheckListByUnit();
        this.productionOutputForm.get('time')?.setValue(new Date());
        this.productionOutputForm.get('actQty')?.reset();
        this.productionOutputForm.get('remarks')?.reset();
        this.getTanksByMachine();
        if (this.isAuto === false) {
          this.productionOutputForm.get('pallet')?.reset();
        }
        this.productionMode = true;
        if (res.ErrorMessage.substring(2, 1) === '0') {
          this.sfdService.insertSfdcEvent(data).then(
            (response) => { },
            (error) => {
              this.showPopupMsg(error.ErrorMessage);
            }
          );
        }
      } else {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('PoListSelection')
        );
      }
      const start = new Date();
      const selected = {
        startDate: this.processControlForm.value.datePicker.startDate,
        endDate: new Date(),
      };
      this.processControlForm.get('datePicker')?.setValue(selected);
      const selected2 = {
        startDate: this.qualityControlForm.value.datePicker.startDate,
        endDate: new Date(),
      };
      this.qualityControlForm.get('datePicker')?.setValue(selected2);
    });
  }

  GetJbBatchHistoryNew(): void {
    const key = {
      PPDID: this.PPID,
      UserCode: this.ActiveUserCode,
      Ishistory: true,
      BatchTypeId: 3,
      JobBatchItemTypeId: 0,
    };
    this.spinner.show();
    this.gridApi?.showLoadingOverlay();
    this.sfdService.GetJbBatchHistory(key).subscribe((res: any) => {
      this.spinner.hide();

      this.HistoryBatchDataSource1 = new MatTableDataSource<any>(
        res.JbBatchHistoryList[0]
      );
      this.HistoryBatchDataSource = new MatTableDataSource<any>(
        res.JbBatchHistoryList
      );
      this.rowDataBatchHistory = res.JbBatchHistoryList;
      this.getPaginator(this.HistoryBatchDataSource, 2);
      this.shiftStartDate = moment(this.shiftstart).format('DD/MM/YYYY hh:mm:ss');
      const shiftBatch = res.JbBatchHistoryList.filter(x => moment(x.CreatedOn).format('DD/MM/YYYY') >= moment(this.shiftstart).format('DD/MM/YYYY') && moment(x.CreatedOn).format('DD/MM/YYYY') <= moment(this.shiftend).format('DD/MM/YYYY'));
      if (shiftBatch.length > 0) {
        const sum = shiftBatch.reduce((accumulator, object) => {
          return accumulator + object.Result;
        }, 0);
        this.shiftWiseGrossProduced = sum;
      } else {
        this.shiftWiseGrossProduced = 0;
      }
      this.GetJbWasteHistoryForHistory();
      this.LastInstOPjobBatch();
    });
  }

  GetTotalBatch1(): void {
    const key = {
      PPDID: this.PPID,
      BatchTypeId: 3,
      BatchItemTypeId: this.productionOutputForm.value.batchcon ? this.productionOutputForm.value.batchcon : 0,
      UserCode: this.ActiveUserCode,
    };
    this.sfdService.GetTotalBatch(key).subscribe((res: any) => {
      this.total1 = res.ErrorMessage;
      this.SFDC_TotalProducedQTy = this.total1.replace(/[^0-9.]/gi, ''); // .replace(/\D/g, '');
      this.GetTotalWaste();
      const currenttimeDiff = moment(new Date()).diff(
        moment(new Date(this.shiftstart)),
        'minutes'
      );
      this.curentTimeDiff = currenttimeDiff;
      const timeslotsDiff =
        // tslint:disable-next-line:max-line-length
        this.SFDC_TotalProducedQTy < 1 ? 0 : (this.timedifference - this.SFDC_TotalDowntime) / (this.SFDC_TotalProducedQTy > 0 ? this.SFDC_TotalProducedQTy : 1);
      this.SFDC_TotalAverageSpeed = timeslotsDiff.toFixed(2) ?? 0;
      const grossporduceinMin =
        this.curentTimeDiff / this.SFDC_TotalProducedQTy;
      const remaningQty = this.targetQty - this.SFDC_TotalProducedQTy;
      this.SFDC_RemaningTime =
        remaningQty > 0
          ? (this.targetQty - this.SFDC_TotalProducedQTy) * grossporduceinMin
          : 0;
      this.SFDC_RemaningTime =
        this.SFDC_RemaningTime === Infinity ? 0 : this.SFDC_RemaningTime;
      this.SFDC_TotalGoodPieces =
        this.SFDC_TotalProducedQTy - this.SFDC_Totalwaste || 0;
      this.getSFDCChart();
      this.RemainingTime();
      this.GetLableBatch1(this.SFDC_TotalProducedQTy);
    });
  }

  getOeeDashboard(): void {
    const key = {
      Groupcode: this.groupSession.groupCode,
      Plantcode: this.plantSession.plantCode,
      UnitId: this.unitId,
      dtEndDate: new Date(),
      dtStartDate: this.shiftstart,
      shift: '*',
    };
    this.spinner.show();
    this.productivityservice.getOEE(key).subscribe(
      (data: any) => {
        this.OeeDashboardData = data;
        this.SFDC_OEE = (Math.round(data.AvgOee)).toString() + '%';
        this.SFDC_Availability = Math.round(data.AvgAvailability) + '%';
        this.SFDC_Performance = Math.round(data.AvgPerformance) + '%';
        this.SFDC_Quality = Math.round(data.AvgQualityRate) + '%';
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('error', error.message);
        this.spinner.hide();
      }
    );
  }

  UpdateJBBatchInfoForProductionOutput(): void {
    const dataArray = this.batchCheckList;
    const array: { BatchCheckListTypeId: any; BatchCheckListValue: any }[] = [];
    dataArray.forEach(
      (element: {
        BatchCheckListTypeId: any;
        hasOwnProperty: (arg0: string) => boolean;
        DataValue: any;
        BatchCheckListValue: any;
      }) => {
        const data = {
          BatchCheckListTypeId: element.BatchCheckListTypeId,
          BatchCheckListValue:
            element.hasOwnProperty('DataValue') === true
              ? element.DataValue
              : element.BatchCheckListValue,
        };
        array.push(data);
      }
    );
    const key = {
      TransactionTypeId: 2,
      PPDID: this.PPID,
      JobBatchId: this.JobBatchId,
      BatchTypeId: 3,
      RollNo: 0,
      Result: this.productionOutputForm.value.actQty,
      BatchNo: this.productionOutputForm.value.pallet,
      BatchItemTypeId: 0,
      Remarks: this.productionOutputForm.value.remarks,
      RollStarttime: this.productionOutputForm.value.time,
      UserCode: this.ActiveUserCode,
      IPBatch: this.productionOutputForm.value.batchcon ? this.productionOutputForm.value.batchcon : 0,
      JobBatchCheckList: array,
    };

    this.sfdService.SaveJBBatchInfo(key).subscribe(
      (res: any) => {
        this.getOeeDashboard();
        this.GetLatestLotCode();
        this.LastInstOPjobBatch();
        this.GetJbBatchHistoryNew();
        this.GetBatchCheckListByUnit();
        this.GetTotalBatch1();
        this.showPopupMsg(res.ErrorMessage);
        this.productionOutputForm.get('time')?.setValue(new Date());
        this.productionOutputForm.get('actQty')?.reset();
        this.productionOutputForm.get('remarks')?.reset();
        this.productionMode = true;
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }
  highlight(row: any): void { }

  getBatchConsumption() {
    const key = {
      id: this.PPID,
    };
    this.sfdService.getBatchConsumptionDD(key).subscribe(
      (res: any) => {
        this.batchConsumptionList = res.masterList;
        this.filteredbatchConsumptionList = this.batchConsumptionList.slice();
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }
  checkListFunction(id: number, event: any): void {
    const check = this.batchCheckList.find(
      (x: { BatchCheckListTypeId: number }) => x.BatchCheckListTypeId === id
    );
    switch (check?.DataType) {
      case 'bool':
        check.DataValue =
          check.DataValue === 'true' || check.BatchCheckListValue === 'true'
            ? false
            : true;
        break;
      case 'number':
        check.DataValue = parseInt(event.target.value, 10);
        break;
      case 'string':
        check.DataValue = event.target.value;
        break;
      case 'date':
        check.DataValue = event.target.value._d;
        break;
      case 'dropdown':
        check.DataValue = event.target.value;
    }
  }

  openHistoryModal(): void {
    if (this.machineSelectProperty === true) {
      this.dialog.open(this.historyBatchModal, {
        width: '100vw !important',
        height: 'auto',
        minWidth: '100vw',
      });
      this.GetJbBatchHistoryNew();
      this.getLabelProductOutput();
    } else {
      this.toaster.error('error', this.translate.instant('PoListSelection'));
    }
  }

  getLabelProductOutput(): void {
    const key = {
      BatchTypeId: this.PPID,
      UserCode: this.ActiveUserCode,
      PUID: this.machineId,
      TypeId: 2,
    };
    this.sfdService.GetLableBatch(key).subscribe((res: any) => {
      this.columnBatchHistory.forEach(function (colDef, index) {
        if (colDef.headerName === 'act') {
          colDef.headerName = 'Act Qty' + '(' + res.Result + ')';
        }
      });
      this.gridOptions.api.setColumnDefs(this.columnBatchHistory);
    });
  }
  GetBarCodeDetails(element: any): void {
    // 
    this.batchCheckList = [];
    this.arrayCheckList = [];
    const key1 = {
      PUId: this.machineId,
      UserCode: this.ActiveUserCode,
      JobBatchId: element.JobBatchId, //this.JobBatchId, // 17911
    };

    this.sfdService.GetJbBatchchecklistDetails(key1).subscribe((res: any) => {
      const array: any = [];
      res.batchCheckList.forEach(
        // tslint:disable-next-line:no-shadowed-variable
        (element: {
          BatchCheckListTypeId: any;
          Name: any;
          DataType: any;
          BatchCheckListValue: any;
        }) => {
          const data2 = {
            BatchCheckListTypeId: element.BatchCheckListTypeId,
            Name: element.Name,
            DataType: element.DataType,
            BatchCheckListValue: element.BatchCheckListValue,
          };
          array.push(data2);
        }
      );

      this.arrayCheckList = array;
      if (true) {


        const key = {
          UnitId: this.machineId,
          PPD_ID: this.PPID,
          BCType: this.arrayCheckList.some(
            (data) => data.BatchCheckListValue == 'Local'
          )
            ? 2
            : 1,
          Id: element.JobBatchId,
          PalletType: this.arrayCheckList.some(
            (data) => data.BatchCheckListValue == 'Local'
          )
            ? 'Local'
            : 'Export',
        };
        this.sfdService
          .GetBarCodeDetailsLocalOrExport(key)
          .subscribe((res: any) => {

            if (res.GetBarCodeDetails.length > 0) {
              let htmlcontent = res.GetBarCodeDetails[0].HTMLLayout;
              const detailItems = res.GetBarCodeDetails[0].detailItems;
              this.qrCodeData = res?.BarCodeSeries;
              this.spinner.show();
              try {
                setTimeout(() => {
                  fetch(this.qrCodeDownloadLink.changingThisBreaksApplicationSecurity).then(response => response.blob()).then(blob => {
                    const objectURL = URL.createObjectURL(blob);
                    htmlcontent = htmlcontent.replace(
                      '[qrCode]',
                      `<img src="${objectURL}" style="width: 100px; height: 100px;"/>`
                      + `<h2>` + res?.BarCodeSeries + `</h2>`
                    );
                    $.each(detailItems, (i, item) => {
                      if (item.Name === 'TimeNow') {
                        htmlcontent = htmlcontent.replace(
                          '[' + item.Name + ']',
                          moment(new Date()).format('DD-MM-YYYY hh:mm A')
                        );
                      } else {
                        htmlcontent = htmlcontent.replace(
                          '[' + item.Name + ']',
                          item.Value
                        );
                      }
                    });

                    const printWindow = window.open('', 'Print-Window')!;
                    printWindow.document.open();

                    const styleTags = '' +
                      '<style type="text/css">' +
                      `.innerTableMAH{
                        width: 100%;
                      }
                      `+
                      `.main-heading{
                      text-align: center;
                      font-size:25px;
                      font-weight:bold;
                      color:blue;
                      }` +
                      `
                      td{
                        padding: 2px !important;
                      }
                    @media print {
                      .main-heading{
                        text-align: center;
                        font-size:12px;
                        font-weight:bold;
                        color:blue;
                        }
                        .th-headerMAH{
                          font-size:9px !important;
                          height: auto !important;
                          margin-right: 0px !important;
                          margin-top: 0px !important;
                          margin-bottom: 0px !important;
                          margin-left: 2px !important;
                        } 
                        .td-text{
                            padding-left: 5px;
                            font-size: 10px;
                        }
                        @page{
                          size: A6 !important;
                          margin: 5px !important;
                        }
                        .barcode{
                          width: 95%;
                          height: 60px;
                        }
                        .innerTableMAH{
                          width: 100.15%;
                          margin-left: -0.4px;
                        }
                        body{
                          margin: 5px !important;
                        }   
                    }` +
                      'table, th, td {' +
                      'border:1px solid black;' +
                      'border-collapse: collapse;' +
                      'padding:0px;' +
                      '}' +
                      '.td-bold {font-weight:bold; color:blue; }' +
                      '</style>';


                    const JsBCScript =
                      '' +
                      '<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.3/dist/JsBarcode.all.min.js"></script>';

                    const scriptTags =
                      '' +
                      '<script type="text/javascript">' +
                      'window.addEventListener(' +
                      "'load'" +
                      ', function () {' +
                      'JsBarcode(".barcode").init();' +
                      '})' +
                      '</script>';
                    printWindow.document.write(styleTags + JsBCScript + '<html><body onload="setTimeout(() => {window.print();},3000);">' + htmlcontent + '</body></html>');
                    printWindow.document.close();
                  });
                  this.spinner.hide();
                }, 3000);
              }
              catch (exception) {
                this.spinner.hide();
              }
              // window.print();
            } else {
              this.toaster.error('error', 'Data is Empty !');
            }
          });
      } else {
        const key = {
          UnitId: this.MachineId,
          PPD_ID: this.PPID,
          BCType: 1,
          Id: element.JobBatchId,
        };

        this.sfdService.GetBarCodeDetails(key).subscribe((res: any) => {
          if (res.GetBarCodeDetails.length > 0) {
            let htmlcontent = res.GetBarCodeDetails[0].HTMLLayout;
            const detailItems = res.GetBarCodeDetails[0].detailItems;
            htmlcontent = htmlcontent.replace(
              '[BarCodeSeries]',
              res.BarCodeSeries
            );

            $.each(detailItems, (i, item) => {
              htmlcontent = htmlcontent.replace(
                '[' + item.Name + ']',
                item.Value
              );
            });

            const printWindow = window.open('', 'Print-Window')!;
            printWindow.document.open();

            const styleTags =
              '' +
              '<style type="text/css">' +
              `
              .innerTableMAH{
                width: 100%;
              }
              `+
              `.main-heading{
              text-align: center;
              font-size:12px;
              font-weight:bold;
              color:blue;
              }` +
              `
            @media print {
              .main-heading{
                text-align: center;
                font-size:16px;
                font-weight:bold;
                color:blue;
                }
                .th-headerMAH{
                  font-size: 9px !important;
                  height: auto !important;
                  margin-right: 0px !important;
                  margin-top: 0px !important;
                  margin-bottom: 0px !important;
                  margin-left: 2px !important;
                }
                .td-text{
                    padding-left: 5px;
                    font-size: 10px;
                }
                
                .barcode{
                    width: 95%;
                    height: 60px;
                }
                .innerTableMAH{
                  width: 100.15%;
                  margin-left: -0.4px;
                }
                body{
                  margin: 5px !important;
                }
                @page{
                  size: A6 !important;
                  margin: 5px !important;

                }   
            }` +
              'table, th, td {' +
              'border:1px solid black;' +
              'border-collapse: collapse;' +
              'padding:0px;' +
              '}' +
              '.td-bold {font-weight:bold; color:blue; }' +
              '</style>';

            const JsBCScript =
              '' +
              '<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.3/dist/JsBarcode.all.min.js"></script>';

            const scriptTags =
              '' +
              '<script type="text/javascript">' +
              'window.addEventListener(' +
              "'load'" +
              ', function () {' +
              'JsBarcode(".barcode").init();' +
              '})' +
              '</script>';

            //Moving the scriptTags to the barcodehtml table
            //printWindow.document.write(styleTags + JsBCScript + scriptTags + '<html><body onload="window.print()">' + htmlcontent + '</body></html>');
            printWindow.document.write(styleTags + JsBCScript + '<html><body onload="setTimeout(() => {window.print();},3000);">' + htmlcontent + '</body></html>');
            printWindow.document.close();

            // printWindow?.print();
          } else {
            this.toaster.error('error', 'Data is Empty !');
          }
        });
      }
    });
    this.GetBatchCheckListByUnit();
  }
  onClickPopupViewForChecklistHistory(data: any): void {
    this.openPopupViewForChecklistHistory(data.data);
  }

  openPopupViewForChecklistHistory(element: any): void {
    this.dialog.open(this.popupViewModal, {
      width: '100vw !important',
      height: '80vh',
      minWidth: '100vw',
    });
    this.spinner.show();
    this.viewProductionHistoryBatch(element);
  }

  GetKpiParameters(): void {
    const key = {
      PUId: this.machineId,
      UserCode: this.ActiveUserCode,
    };
    this.spinner.show();

    this.sfdService.GetKpiParameters(key).subscribe((res: any) => {
      this.processparameter1DataSource = new MatTableDataSource<any>(
        res.ProcessParameterList
      );
      this.processparameter22DataSource = new MatTableDataSource<any>(
        res.MeterialParameterList
      );
      this.processparameter33DataSource = new MatTableDataSource<any>(
        res.LineParameterList
      );
      this.spinner.hide();
    });
  }

  getPaginator(data: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      if (data) {
        data.paginator = this.paginator.toArray()[index];
        data.sort = this.sort.toArray()[index];
      }
    }, 1000);
  }
  GetKpiParamInfoList(element: any): void {
    this.spinner.show();
    const key = {
      PPD_Id: this.PPID,
      UserCode: this.ActiveUserCode,
      JobKpiParamInfoId: 0,
    };
    this.sfdService.GetKpiParamInfoList(key).subscribe((res: any) => {
      this.centerLineDataSource = new MatTableDataSource<any>(
        res.KpiParameterinfoList
      );
      this.getPaginator(this.centerLineDataSource, 0);
      this.spinner.hide();
    });
  }

  SumbitJobKpiParameters(element1: any): void {
    this.processValues1 = [];
    const table1 = this.processparameter1DataSource.filteredData;
    const table2 = this.processparameter22DataSource.filteredData;
    const table3 = this.processparameter33DataSource.filteredData;
    table1.forEach((element) => {
      const Id = element.id;
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues1.push(data);
    });
    table2.forEach((element) => {
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues1.push(data);
    });
    table3.forEach((element) => {
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues1.push(data);
    });
    const key = {
      UserCode: this.ActiveUserCode,
      TransactionTypeId: 1,
      JobKpiParamInfoId: 0,
      JobkpiparaInfoList: this.processValues1,
    };
    this.sfdService.SumbitJobKpiParameters(key).subscribe(
      (res: any) => {
        this.GetKpiParamInfoList(element1);
        this.showPopupMsg(res.ErrorMessage);
        this.dialog.closeAll();
      },
      (error: { ErrorMessage: any }) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  SumbitJobKpiParameters1(element1: any): void {
    // //
    this.processValues = [];
    const table1 = this.processparameter1DataSource.filteredData;
    const table2 = this.processparameter22DataSource.filteredData;
    const table3 = this.processparameter33DataSource.filteredData;
    table1.forEach((element) => {
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues.push(data);
    });
    table2.forEach((element) => {
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues.push(data);
    });
    table3.forEach((element) => {
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues.push(data);
    });
    const key = {
      UserCode: this.ActiveUserCode,
      TransactionTypeId: 2,
      JobKpiParamInfoId: this.obKpiParamInfoId1,
      JobkpiparaInfoList: this.processValues,
    };
    this.sfdService.SumbitJobKpiParameters(key).subscribe(
      (res: any) => {
        this.GetKpiParamInfoList(element1);
        this.showPopupMsg(res.ErrorMessage);
        this.dialog.closeAll();
      },
      (error: { ErrorMessage: any }) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  editProcessParameter(element: any): void {
    this.centerLineMode = false;
    this.dialog.open(this.centerlineModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.obKpiParamInfoId1 = element.JobKpiParamInfoId;
    this.GetKpiParamInfoDetails();
  }
  GetKpiParamInfoDetails(): void {
    this.booleanConvertedArray = [];
    this.booleanConvertedArray1 = [];
    this.booleanConvertedArray2 = [];
    const key = {
      PPD_Id: this.PPID,
      UserCode: this.ActiveUserCode,
      JobKpiParamInfoId: this.obKpiParamInfoId1,
    };
    this.spinner.show();
    this.sfdService.GetKpiParamInfoDetails(key).subscribe((res: any) => {
      this.spinner.hide();

      this.MaterialParameterList = res.MeterialParameterList;
      this.LineParameterList = res.LineParameterList;
      res.ProcessParameterList.forEach((element: any) => {
        const data = {
          KpiparaId: element.KpiparaId,
          KpiName: element.KpiName,
          KpiValues: element.KpiValues,
        };
        this.booleanConvertedArray2.push(data);
      });
      res.MeterialParameterList.forEach((element: any) => {
        const data = {
          KpiparaId: element.KpiparaId,
          KpiName: element.KpiName,
          KpiValues: element.KpiValues,
        };
        this.booleanConvertedArray.push(data);
      });
      res.LineParameterList.forEach((element: any) => {
        const data = {
          KpiparaId: element.KpiparaId,
          KpiName: element.KpiName,
          KpiValues: Boolean(JSON.parse(element.KpiValues)),
        };
        this.booleanConvertedArray1.push(data);
      });
      this.processparameter1DataSource = new MatTableDataSource<any>(
        this.booleanConvertedArray2
      );
      this.processparameter22DataSource = new MatTableDataSource<LineInterface>(
        this.booleanConvertedArray
      );
      this.processparameter33DataSource = new MatTableDataSource<LineInterface>(
        this.booleanConvertedArray1
      );
    });
  }
  checkListFunctionForProcess(element: any, event: any): void {
    if (!this.centerLineMode) {
      const check = this.booleanConvertedArray2.find(
        (x) => x.KpiparaId === element.KpiparaId
      );
      check!.KpiValues = event.target.value;
    } else {
      const index = this.processparameter1DataSource.filteredData.findIndex(
        (e: any) => e.KpiparaId === element.KpiparaId
      );
      this.processparameter1DataSource.filteredData[index].KpiValues =
        event.target.value;
    }
  }
  checkListFunctionMaterial(element: any, event: any): void {
    if (!this.centerLineMode) {
      const check = this.booleanConvertedArray.find(
        (x) => x.KpiparaId === element.KpiparaId
      );
      check!.KpiValues = event.target.value;
    } else {
      const index = this.processparameter22DataSource.filteredData.findIndex(
        (e: any) => e.KpiparaId === element.KpiparaId
      );
      this.processparameter22DataSource.filteredData[index].KpiValues =
        event.target.value;
    }
  }

  checkListFunctionLine(element: any, event: any): void {
    if (!this.centerLineMode) {
      const check = this.booleanConvertedArray1.find(
        (x) => x.KpiparaId === element.KpiparaId
      );
      check!.KpiValues = check?.KpiValues ? false : true;
    } else {
      const index = this.processparameter33DataSource.filteredData.findIndex(
        (e: any) => e.KpiparaId === element.KpiparaId
      );
      this.processparameter33DataSource.filteredData[index].KpiValues = event
        .target.value
        ? true
        : false;
    }
  }
  async GetQualityAllDataTypesDetail(val: any): Promise<any> {
    const key = {
      variableId: val,
    };
    await this.qualityParameterService
      .GetAllDataTypesDetail(key)
      .then((res: any) => {
        this.qualityboolList = res.map((c: any) => c.text);
      });
  }
  GetJbWasteHistoryForHistory(): void {
    const key = {
      PPDID: this.PPID,
      UserCode: this.ActiveUserCode,
      Ishistory: true,
    };
    this.spinner.show();
    this.sfdService.GetJbWasteHistory(key).subscribe((res: any) => {
      this.newJbWasteHistoryList = res.JbWasteHistoryList;
      this.rowDataWasteHistory = res.JbWasteHistoryList;
      const shiftWaste = res.JbWasteHistoryList.filter(x => moment(x.Time).format('DD/MM/YYYY') >= moment(this.shiftstart).format('DD/MM/YYYY') && moment(x.Time).format('DD/MM/YYYY') <= moment(this.shiftend).format('DD/MM/YYYY'));
      if (shiftWaste.length > 0) {
        const sum = shiftWaste.reduce((accumulator, object) => {
          return accumulator + object.Amount;
        }, 0);
        this.shiftWiseWaste = sum;
      } else {
        this.shiftWiseWaste = 0;
      }
      this.shiftWiseNetProduced = this.shiftWiseGrossProduced - this.shiftWiseWaste;

      this.spinner.hide();
      this.wasteDataSource1 = new MatTableDataSource<any>([
        this.newJbWasteHistoryList[0],
      ]);
    });
  }
  GetTotalWaste(): void {
    const key = {
      PPDID: this.PPID,
      UserCode: this.ActiveUserCode,
    };
    this.sfdService.GetTotalWaste(key).subscribe((res: any) => {
      this.totalWaste = res.ErrorMessage;
      this.SFDC_Totalwaste = this.totalWaste?.replace(/[^0-9.]/gi, '');
    });
  }
  date: any;

  GetCurrentDate() {
    this.date = new Date();
    let latest_date = this.datepipe.transform(this.date, 'yyyy-MM-dd');
  }
  GetJbWasteHistory(): void {
    const key = {
      PPDID: this.PPID,
      UserCode: this.ActiveUserCode,
      Ishistory: false,
    };
    this.spinner.show();

    this.sfdService.GetJbWasteHistory(key).subscribe((res: any) => {
      this.newJbWasteHistoryList = res.JbWasteHistoryList;
      this.wasteDataSource1 = new MatTableDataSource<any>(
        res.JbWasteHistoryList
      );
      this.spinner.hide();
    });
  }
  SaveJBWasteInfo(): void {
    const key = {
      TransactionTypeId: 1,
      PPDID: this.PPID,
      WasteEntryId: 0,
      FaultId: this.wasteForm.get('categoryType')?.value,
      Amount: this.wasteForm.get('uom')?.value,
      Time: this.wasteForm.value.dateTime,
      Remarks: this.wasteForm.get('failureMode')?.value,
      UserCode: this.ActiveUserCode,
    };
    this.sfdService.SaveJBWasteInfo(key).subscribe(
      (res: any) => {
        this.getOeeDashboard();
        this.GetJbWasteHistoryForHistory();
        this.GetTotalWaste();
        this.showPopupMsg(res.ErrorMessage);
        this.wasteForm.get('failureMode')?.reset();
        this.wasteForm.get('uom')?.reset();
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  UpdateJBWasteInfo(): void {
    const key = {
      TransactionTypeId: 2,
      PPDID: this.PPID,
      WasteEntryId: this.WasteEntryId,
      FaultId: this.wasteForm.get('categoryType')?.value,
      Amount: this.wasteForm.get('uom')?.value,
      Time: this.wasteForm.value.dateTime,
      Remarks: this.wasteForm.get('failureMode')?.value,
      UserCode: this.ActiveUserCode,
    };

    this.sfdService.SaveJBWasteInfo(key).subscribe(
      (res: any) => {
        this.getOeeDashboard();
        this.GetJbWasteHistory();
        this.GetTotalWaste();
        this.showPopupMsg(res.ErrorMessage);
        this.wasteForm.get('failureMode')?.reset();
        this.wasteForm.get('uom')?.reset();
        this.wasteMode = true;
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  editMaterialConsumptionHistoryBatch(element: any): void {
    this.materialConsumptionMode = false;
    this.materialConsumptionForm.get('lot')?.setValue(element.BatchNo);
    this.materialConsumptionForm.get('actQty')?.setValue(element.Result);
    this.materialConsumptionForm.get('remarks')?.setValue(element.Remarks);
    this.materialConsumptionForm.get('date')?.setValue(element.RollStarttime);
    this.JobBatchId = element.JobBatchId;
    this.dialog.closeAll();
  }
  editWasteHistory(element: any): void {
    this.wasteMode = false;
    this.wasteForm.get('dateTime')?.setValue(element.Time);
    this.wasteForm.get('failureMode')?.setValue(element.Remarks);
    this.wasteForm.get('uom')?.setValue(element.Amount);
    this.WasteEntryId = element.WasteEntryId;
    this.dialog.closeAll();
    this.wasteForm.get('categoryType')?.setValue(element.FaultId);
  }
  GetSTFault(): void {
    const key = {
      PUId: this.machineId,
    };
    this.sfdService.GetSTFault(key).subscribe((res: any) => {
      this.GTList = res.FaultList;
      this.filteredGTList = this.GTList.slice();
      this.shortStopsForm.get('fault')?.setValue(this.GTList[0]?.FaultId);
    });
  }
  changeExpireDate(event: any, id: number) {
    this.ItemBOMList.data.find((item) => item.ItemBOMDetailId === id).ExpireDate =
      moment(event.target.value).format('YYYY-MM-DD HH:mm');
    this.dateRangeValidation(id, event);
  }
  invalidDate: boolean = false;
  dateRangeValidation(id: number, event: any) {
    let from = '';
    let to = '';
    this.ItemBOMList.data.forEach((item: any, index: any) => {
      if (item.ItemBOMDetailId === id) {
        from = item.ExpireDate;
        to = item.ProductionDate;
        if (from && to) {
          this.invalidDate = new Date(from).valueOf() > new Date(to).valueOf();
          this.invalidDate ? { invalidRange: { from, to } } : null;
          if (this.invalidDate === false) {
            this.toaster.error(this.translate.instant('CheckExpiryDate'));
            event.target.value = '';
            this.ItemBOMList.data.find(
              (item) => item.ItemBOMDetailId === id
            ).ExpireDate = '';
          }
        } else if (to === '' || to === null) {
          this.toaster.error(
            this.translate.instant('ProductionDateSelection')
          );
          event.target.value = '';
          this.ItemBOMList.data.find(
            (item) => item.ItemBOMDetailId === id
          ).ExpireDate = '';
        }
      }
    });
  }
  changeActQty(event: any, id: number) {
    this.ItemBOMList?.data.forEach((x: any, index) => {
      if (x?.ItemBOMDetailId === id) {
        this.ItemBOMList.data[index].ItemBOMValue = parseFloat(event.target.value);
        this.ItemBOMList.data[index].ItemBOMValueDrums = event.target.value ? this.ItemBOMList?.data[index].MinSkuUnit ? (parseFloat(event.target.value) / this.ItemBOMList?.data[index].MinSkuUnit)?.toFixed(2) : 0 : 0;
        this.ItemBOMList.data[index].calculatedValue = event.target.value ? this.ItemBOMList?.data[index].MinSkuUnit ? (parseFloat(event.target.value) / this.ItemBOMList?.data[index].MinSkuUnit)?.toFixed(2) : 0 : 0;
      }
    })
  }

  changeSupplier(event: any, id: number) {
    let obj = this.ItemBOMList?.data.find((item) => item.ItemBOMDetailId === id);
    if (obj.supplierList.length > 0) {
      let findObj = obj.supplierList.find((item: any) => item.supplierName === event.target.value);
      this.indexMaterial = obj.supplierList.indexOf(findObj);
      this.ItemBOMList.data.find((item) => item.ItemBOMDetailId === id).supplierList[this.indexMaterial].NOBags = findObj.NOBags;
      this.ItemBOMList.data.find((item) => item.ItemBOMDetailId === id).supplierList[this.indexMaterial].BagperWeight = findObj.BagperWeight;
      this.ItemBOMList.data.find((item) => item.ItemBOMDetailId === id).supplierList[this.indexMaterial].totalWeight = findObj.totalWeight;
      this.ItemBOMList.data.find((item) => item.ItemBOMDetailId === id).Supplier = event.target.value;
    } else {
      this.ItemBOMList.data.find((item) => item.ItemBOMDetailId === id).Supplier =
        event.target.value;
    }
  }

  changeProductionDate(event: any, id: number) {
    this.ItemBOMList.data.find(
      (item) => item.ItemBOMDetailId === id
    ).ProductionDate = moment(event.target.value).format('YYYY-MM-DD HH:mm');
    this.dateRangeValidation(id, event);
  }
  SaveFoodSectorMaterialConsumption(): void {
    this.spinner.show();
    let flag = true;
    if (flag) {
      if (this.JobBatchMaterialId > 0) {
        const array: {
          ItemBOMDetailId: number;
          ItemBOMValue: any;
          Supplier: any;
          ExpireDate: any;
          ProductionDate: any;
          NOBags: any;
          BagperWeight: any;
          labCode: any;
          traceCode: any;
        }[] = [];
        this.ItemBOMList?.data.forEach((element) => {
          if (element.Supplier === '') {
            var obj = (document.getElementById("selectedSupplier")) as HTMLSelectElement;
            this.selectedSupplier = element.supplierList.find((val: any) => val.supplierName === obj.value)
          }
          const data = {
            ItemBOMDetailId: element.ItemBOMDetailId,
            Supplier: element.Supplier !== '' ? element.Supplier : this.selectedSupplier?.supplierName,
            ExpireDate: element.ExpireDate,
            ProductionDate: element.ProductionDate,
            ItemBOMValue: element.ItemBOMValue,
            NOBags: element.Supplier !== '' ? element.NOBags : this.selectedSupplier?.NOBags,
            BagperWeight: element.Supplier !== '' ? element.BagperWeight : this.selectedSupplier?.BagperWeight,
            labCode: element?.labCode,
            traceCode: element?.traceCode,
            ItemBOMDrumValue: parseFloat(element?.ItemBOMValueDrums)
          };
          array.push(data);
          this.selectedSupplier = null;
        });
        const key = {
          TransactionTypeId: 2,
          PPDID: this.PPID,
          Result: this.materialFoodSectorConsumptionForm.value.mActQtys,
          BatchNo: this.materialFoodSectorConsumptionForm.value.mlotCode,
          Remarks: this.materialFoodSectorConsumptionForm.value.remarks,
          RollStarttime: this.materialFoodSectorConsumptionForm.value.mTime,
          UserCode: this.ActiveUserCode,
          JobBatchItemBomList: array,
          JobBatchId: this.JobBatchMaterialId,
        };
        const data = {
          PlantCode: this.plantSession.plantCode,
          lotcode: this.materialFoodSectorConsumptionForm.value.mlot,
          eventDateTime: this.materialFoodSectorConsumptionForm.value.mTime,
          eventTypeId: 1,
          puId: this.MachineId,
          processOrder: this.groupDataForm.get('processOrder')?.value,
          processOrderId: this.PPID,
        };
        this.sfdService.SaveFoodSectorMaterialConsumption(key).subscribe(
          (res: any) => {
            if (res.HasError === false) {
              this.toaster.success(
                this.translate.instant('Success'),
                this.translate.instant('MaterialConsumptionSaved')
              );
              // Get Material Consumption Data 
              this.getFoodSectorMaterialConsumptionList();
              this.getBatchConsumption();
              this.getItemBomListInfo();
              // Get Production Output
              this.LastInstOPjobBatch();
              this.GetJbBatchHistoryNew();
              this.GetTotalBatch1();
              this.GetLatestLotCode();
              this.spinner.hide();
              this.sfdService.insertSfdcEvent(data).then(
                (response) => { },
                (error) => {
                  this.showPopupMsg(error.ErrorMessage);
                }
              );
            } else {
              this.spinner.hide();
            }
          },
          (error: any) => {
            this.toaster.error(
              this.translate.instant('Error'),
              this.translate.instant('WentWrong')
            );
            this.spinner.hide();
          }
        );
      } else if (this.materialFoodSectorConsumptionForm.valid) {
        const array: {
          ItemBOMDetailId: number;
          ItemBOMValue: any;
          Supplier: any;
          ExpireDate: any;
          ProductionDate: any;
          NOBags: any;
          BagperWeight: any;
          labCode: any;
          traceCode: any;
        }[] = [];
        this.ItemBOMList?.data.forEach((element) => {
          if (element.Supplier === '') {
            var obj = (document.getElementById("selectedSupplier")) as HTMLSelectElement;
            this.selectedSupplier = element.supplierList.find((val: any) => val.supplierName === obj.value)
          }
          const data = {
            ItemBOMDetailId: element.ItemBOMDetailId,
            Supplier: element.Supplier !== '' ? element.Supplier : this.selectedSupplier?.supplierName,
            ExpireDate: element.ExpireDate,
            ProductionDate: element.ProductionDate,
            ItemBOMValue: element.ItemBOMValue,
            NOBags: element.Supplier !== '' ? element.NOBags : this.selectedSupplier?.NOBags,
            BagperWeight: element.Supplier !== '' ? element.BagperWeight : this.selectedSupplier?.BagperWeight,
            labCode: element?.labCode,
            traceCode: element?.traceCode,
            ItemBOMDrumValue: parseFloat(element?.ItemBOMValueDrums)
          };
          array.push(data);
          this.selectedSupplier = null;
        });
        const key = {
          TransactionTypeId: 1,
          PPDID: this.PPID,
          Result: this.materialFoodSectorConsumptionForm.value.mActQtys,
          BatchNo: this.materialFoodSectorConsumptionForm.value.mlotCode,
          Remarks: this.materialFoodSectorConsumptionForm.value.remarks,
          RollStarttime: this.materialFoodSectorConsumptionForm.value.mTime,
          UserCode: this.ActiveUserCode,
          JobBatchItemBomList: array,
        };
        const data = {
          PlantCode: this.plantSession.plantCode,
          lotcode: this.materialFoodSectorConsumptionForm.value.mlot,
          eventDateTime: this.materialFoodSectorConsumptionForm.value.mTime,
          eventTypeId: 1,
          puId: this.MachineId,
          processOrder: this.groupDataForm.get('processOrder')?.value,
          processOrderId: this.PPID,
        };
        this.sfdService.SaveFoodSectorMaterialConsumption(key).subscribe(
          (res: any) => {
            if (res.HasError === false) {
              this.showPopupMsg(res.ErrorMessage);
              // Get Material Consumption Data 
              this.getFoodSectorMaterialConsumptionList();
              this.getBatchConsumption();
              this.getItemBomListInfo();
              // Get Production Output
              this.LastInstOPjobBatch();
              this.GetJbBatchHistoryNew();
              this.GetTotalBatch1();
              this.GetLatestLotCode();
              this.sfdService.insertSfdcEvent(data).then(
                (response) => { },
                (error) => {
                  this.showPopupMsg(error.ErrorMessage);
                }
              );
              this.spinner.hide();
            } else {
              this.spinner.hide();
            }
          },
          (error: any) => {
            this.toaster.error('error', error.message);
            this.spinner.hide();
          }
        );
      } else {
        this.toaster.error('Expiry date should be greater than Production date');
      }
    }
    this.spinner.hide();
  }
  RefreshMaterialSubConsumption(): void {
    this.materialFoodSectorConsumptionForm.get('remarks')?.reset();
    // this.materialFoodSectorConsumptionForm.get('isRework')?.reset();
    this.materialFoodSectorConsumptionForm.get('mTime')?.setValue(new Date());
    this.JobBatchMaterialId = '';
    this.isRework = false;
    this.getItemBomListInfo();
  }
  openWasteHistoryModal(): void {
    this.dialog.open(this.wastehistoryModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.GetJbWasteHistoryForHistory();
  }
  getMinutes(event: any): void {
    const sDate = new Date(this.downTimeForm.get('startDate')?.value);
    const eDate = new Date(this.downTimeForm.get('endDate')?.value);
    const dateTimeDifference = eDate.getTime() - sDate.getTime();
    const days = dateTimeDifference / (1000 * 3600 * 24);
    const minutes = parseInt((days * 1440).toFixed(0), 10);
    this.downTimeForm.get('duration')?.setValue(minutes);
  }

  getEndMinutes(event: any): void {
    const sDate = this.downTimeForm.get('startDate')?.value;
    const eDate = this.downTimeForm.get('endDate')?.value;
    const dateTimeDifference = eDate?.getTime() - sDate?.getTime();
    const days = dateTimeDifference / (1000 * 3600 * 24);
    const minutes = parseInt((days * 1440).toFixed(0), 10);
    this.downTimeForm.get('duration')?.setValue(minutes);
  }

  getMinutes1(event: any): void {
    const sDate = this.downTimeForm.get('startDate')?.value;
    const eDate = this.downTimeForm.get('endDate')?.value;
    const dateTimeDifference = eDate?.getTime() - sDate?.getTime();
    const days = dateTimeDifference / (1000 * 3600 * 24);
    const minutes = (days * 1440).toFixed(0);
    this.downTimeForm.get('duration')?.setValue(minutes);
    this.shortStopsForm.get('duration')?.setValue(minutes);
  }

  getChangeStartTime(element: any): void {
    const min = this.shortStopsForm.get('duration')?.value;
    const today = new Date();
    const sttime = new Date(today.getTime() - min * 60000);
    this.shortStopsForm.get('startDate')?.setValue(sttime);
    this.shortStopsForm.get('endDate')?.setValue(today);
  }
  SaveJBDowntimeInfo(): void {
    this.spinner.show();
    let IsHavingEndDateNull = true;
    this.rowDataDowntimeHistory.forEach((elem) => {
      if (elem.EndTime === null) {
        IsHavingEndDateNull = false;
      }
    });
    if (
      IsHavingEndDateNull ||
      this.downTimeForm.get('endDate')?.value !== null
    ) {
      if (this.fromStartButton) {
        this.downTimeForm.get('endDate')?.setValue(null);
      }
      const key = {
        TransactionTypeId: 1,
        PUID: this.machineId,
        JobdowtimeId: 0,
        FaultId: this.downTimeForm.get('fault')?.value,
        StartTime: this.downTimeForm.get('startDate')?.value,
        EndTime: this.downTimeForm.get('endDate')?.value,
        Remarks: this.downTimeForm.get('remarks')?.value,
        Duration: this.downTimeForm.get('duration')?.value,
        UserCode: this.ActiveUserCode,
      };

      this.sfdService.SaveJBDowntimeInfo(key).subscribe(
        (res: any) => {
          this.spinner.hide();
          this.GetJbDowntimeHistory();
          this.GetJbDowntimeHistory1();
          this.showPopupMsg(res.ErrorMessage);
          this.downTimeForm.get('remarks')?.reset();
        },
        (error) => {
          this.spinner.hide();
          this.showPopupMsg(error.ErrorMessage);
          this.timerflag = !this.timerflag;
          this.downTimeStarted = false;
          this.timer = '';
          clearInterval(this.interval);
        }
      );
    } else {
      this.toaster.error('Error', 'Already DownTime Started');
    }
  }

  SaveJBDowntimeInfo2(): void {
    let IsHavingEndDateNull = true;
    this.rowDataDowntimeHistory.forEach((elem) => {
      if (elem.EndTime === null) {
        IsHavingEndDateNull = false;
      }
    });
    if (IsHavingEndDateNull) {
      const key = {
        TransactionTypeId: 1,
        PUID: this.machineId,
        JobdowtimeId: 0,
        FaultId: this.selectedfaultId,
        StartTime: new Date(),
        EndTime: null,
        Remarks: this.downTimeForm.get('remarks')?.value,
        Duration: this.downTimeForm.get('duration')?.value,
        UserCode: this.ActiveUserCode,
      };
      this.sfdService.SaveJBDowntimeInfo(key).subscribe(
        (res: any) => {
          this.GetJbDowntimeHistory();
          this.GetJbDowntimeHistory1();
          this.showPopupMsg(res.ErrorMessage);
          this.downTimeForm.get('remarks')?.reset();
        },
        (error) => {
          this.showPopupMsg(error.ErrorMessage);
          this.timerflag = !this.timerflag;
          this.downTimeStarted = false;
          this.timer = '';
          clearInterval(this.interval);
        }
      );
    } else {
      this.toaster.error('Error', 'Already DownTime Started');
    }
  }
  saveQcVerify(): void {
    const key = {
      startTimeSlot: this.qcStartTimeSlot,
      timeSlot: this.qcParamsSlot,
      endTimeSlot: this.qcEndTimeSlot,
      processOrderNo: this.qcProcessorderNo,
      verifcationStatus: this.verifcationStatus,
      unitId: this.unitId,
      createdBy: this.ActiveUserCode,
      createdOn: new Date(),
      prodCode: this.qcProdCode,
      prodDesc: this.qcProcdDesc,
      detail: this.qcdataSource.data, // data
      groupType: this.qualityGroupType,
    };
    this.qualityParameterService.saveQcVerify(key).subscribe(
      (response: any) => {
        this.showPopupMsg(response.data);
        this.onToProcessDateQuanlityControl();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  verifyChnage(element: any, event: any): void {
    const obj = this.qcdataSource.data.find(
      (x: any) => x.parameterId === element.parameterId
    );
    obj.verificationStatus = event.target.value;
  }

  QcVerifyremarksUpdate(element: any, event: any): void {
    const obj = this.qcdataSource.data.find(
      (x: any) => x.parameterId === element.parameterId
    );
    obj.remarks = event.target.value;
  }
  onPrevious1(): void {
    if (this.disableSFDCbuttons == true) {
      this.toaster.error('Please Select Unit First');
    } else {
      const wrapper1 = document.querySelector('#wrapper1');
      wrapper1?.classList.remove('content-show');
      wrapper1?.classList.add('content-hide');
      const wrapper2 = document.querySelector('#wrapper2');
      wrapper2?.classList.add('content-show');
      wrapper2?.classList.remove('content-hide');
      const wrapper3 = document.querySelector('#wrapper3');
      wrapper3?.classList.remove('content-show');
      wrapper3?.classList.add('content-hide');
      const wrapper4 = document.querySelector('#wrapper4');
      wrapper4?.classList.remove('content-show');
      wrapper4?.classList.add('content-hide');
      const wrapper5 = document.querySelector('#wrapper5');
      wrapper5?.classList.remove('content-show');
      wrapper5?.classList.add('content-hide');
      const wrapper6 = document.querySelector('#wrapper6');
      wrapper6?.classList.remove('content-show');
      wrapper6?.classList.add('content-hide');
      const wrapper7 = document.querySelector('#wrapper7');
      wrapper7?.classList.remove('content-show');
      wrapper7?.classList.add('content-hide');
      const wrapper8 = document.querySelector('#wrapper8');
      wrapper8?.classList.remove('content-show');
      wrapper8?.classList.add('content-hide');
      const wrapper9 = document.querySelector('#wrapper9');
      wrapper9?.classList.remove('content-show');
      wrapper9?.classList.add('content-hide');
    }
  }
  onPrevious2(): void {
    const wrapper1 = document.querySelector('#wrapper1');
    wrapper1?.classList.remove('content-show');
    wrapper1?.classList.add('content-hide');
    const wrapper2 = document.querySelector('#wrapper2');
    wrapper2?.classList.remove('content-show');
    wrapper2?.classList.add('content-hide');
    const wrapper3 = document.querySelector('#wrapper3');
    wrapper3?.classList.add('content-show');
    wrapper3?.classList.remove('content-hide');
    const wrapper4 = document.querySelector('#wrapper4');
    wrapper4?.classList.remove('content-show');
    wrapper4?.classList.add('content-hide');
    const wrapper5 = document.querySelector('#wrapper5');
    wrapper5?.classList.remove('content-show');
    wrapper5?.classList.add('content-hide');
    const wrapper6 = document.querySelector('#wrapper6');
    wrapper6?.classList.remove('content-show');
    wrapper6?.classList.add('content-hide');
    const wrapper7 = document.querySelector('#wrapper7');
    wrapper7?.classList.remove('content-show');
    wrapper7?.classList.add('content-hide');
    const wrapper8 = document.querySelector('#wrapper8');
    wrapper8?.classList.remove('content-show');
    wrapper8?.classList.add('content-hide');
    const wrapper9 = document.querySelector('#wrapper9');
    wrapper9?.classList.remove('content-show');
    wrapper9?.classList.add('content-hide');
  }
  onPrevious3(): void {
    const wrapper1 = document.querySelector('#wrapper1');
    wrapper1?.classList.remove('content-show');
    wrapper1?.classList.add('content-hide');
    const wrapper2 = document.querySelector('#wrapper2');
    wrapper2?.classList.remove('content-show');
    wrapper2?.classList.add('content-hide');
    const wrapper3 = document.querySelector('#wrapper3');
    wrapper3?.classList.remove('content-show');
    wrapper3?.classList.add('content-hide');
    const wrapper4 = document.querySelector('#wrapper4');
    wrapper4?.classList.add('content-show');
    wrapper4?.classList.remove('content-hide');
    const wrapper5 = document.querySelector('#wrapper5');
    wrapper5?.classList.remove('content-show');
    wrapper5?.classList.add('content-hide');
    const wrapper6 = document.querySelector('#wrapper6');
    wrapper6?.classList.remove('content-show');
    wrapper6?.classList.add('content-hide');
    const wrapper7 = document.querySelector('#wrapper7');
    wrapper7?.classList.remove('content-show');
    wrapper7?.classList.add('content-hide');
    const wrapper8 = document.querySelector('#wrapper8');
    wrapper8?.classList.remove('content-show');
    wrapper8?.classList.add('content-hide');
    const wrapper9 = document.querySelector('#wrapper9');
    wrapper9?.classList.remove('content-show');
    wrapper9?.classList.add('content-hide');
  }
  onPrevious4(): void {
    const wrapper1 = document.querySelector('#wrapper1');
    wrapper1?.classList.remove('content-show');
    wrapper1?.classList.add('content-hide');
    const wrapper2 = document.querySelector('#wrapper2');
    wrapper2?.classList.remove('content-show');
    wrapper2?.classList.add('content-hide');
    const wrapper3 = document.querySelector('#wrapper3');
    wrapper3?.classList.remove('content-show');
    wrapper3?.classList.add('content-hide');
    const wrapper4 = document.querySelector('#wrapper4');
    wrapper4?.classList.remove('content-show');
    wrapper4?.classList.add('content-hide');
    const wrapper5 = document.querySelector('#wrapper5');
    wrapper5?.classList.add('content-show');
    wrapper5?.classList.remove('content-hide');
    const wrapper6 = document.querySelector('#wrapper6');
    wrapper6?.classList.remove('content-show');
    wrapper6?.classList.add('content-hide');
    const wrapper7 = document.querySelector('#wrapper7');
    wrapper7?.classList.remove('content-show');
    wrapper7?.classList.add('content-hide');
    const wrapper8 = document.querySelector('#wrapper8');
    wrapper8?.classList.remove('content-show');
    wrapper8?.classList.add('content-hide');
    const wrapper9 = document.querySelector('#wrapper9');
    wrapper9?.classList.remove('content-show');
    wrapper9?.classList.add('content-hide');
  }
  onPrevious5(): void {
    const wrapper1 = document.querySelector('#wrapper1');
    wrapper1?.classList.remove('content-show');
    wrapper1?.classList.add('content-hide');
    const wrapper2 = document.querySelector('#wrapper2');
    wrapper2?.classList.remove('content-show');
    wrapper2?.classList.add('content-hide');
    const wrapper3 = document.querySelector('#wrapper3');
    wrapper3?.classList.remove('content-show');
    wrapper3?.classList.add('content-hide');
    const wrapper4 = document.querySelector('#wrapper4');
    wrapper4?.classList.remove('content-show');
    wrapper4?.classList.add('content-hide');
    const wrapper5 = document.querySelector('#wrapper5');
    wrapper5?.classList.remove('content-show');
    wrapper5?.classList.add('content-hide');
    const wrapper6 = document.querySelector('#wrapper6');
    wrapper6?.classList.add('content-show');
    wrapper6?.classList.remove('content-hide');
    const wrapper7 = document.querySelector('#wrapper7');
    wrapper7?.classList.remove('content-show');
    wrapper7?.classList.add('content-hide');
    const wrapper8 = document.querySelector('#wrapper8');
    wrapper8?.classList.remove('content-show');
    wrapper8?.classList.add('content-hide');
    const wrapper9 = document.querySelector('#wrapper9');
    wrapper9?.classList.remove('content-show');
    wrapper9?.classList.add('content-hide');
  }
  onPrevious6(): void {
    const wrapper1 = document.querySelector('#wrapper1');
    wrapper1?.classList.remove('content-show');
    wrapper1?.classList.add('content-hide');
    const wrapper2 = document.querySelector('#wrapper2');
    wrapper2?.classList.remove('content-show');
    wrapper2?.classList.add('content-hide');
    const wrapper3 = document.querySelector('#wrapper3');
    wrapper3?.classList.remove('content-show');
    wrapper3?.classList.add('content-hide');
    const wrapper4 = document.querySelector('#wrapper4');
    wrapper4?.classList.remove('content-show');
    wrapper4?.classList.add('content-hide');
    const wrapper5 = document.querySelector('#wrapper5');
    wrapper5?.classList.remove('content-show');
    wrapper5?.classList.add('content-hide');
    const wrapper6 = document.querySelector('#wrapper6');
    wrapper6?.classList.remove('content-show');
    wrapper6?.classList.add('content-hide');
    const wrapper7 = document.querySelector('#wrapper7');
    wrapper7?.classList.add('content-show');
    wrapper7?.classList.remove('content-hide');
    const wrapper8 = document.querySelector('#wrapper8');
    wrapper8?.classList.remove('content-show');
    wrapper8?.classList.add('content-hide');
    const wrapper9 = document.querySelector('#wrapper9');
    wrapper9?.classList.remove('content-show');
    wrapper9?.classList.add('content-hide');
  }
  onPrevious7(): void {
    const wrapper1 = document.querySelector('#wrapper1');
    wrapper1?.classList.remove('content-show');
    wrapper1?.classList.add('content-hide');
    const wrapper2 = document.querySelector('#wrapper2');
    wrapper2?.classList.remove('content-show');
    wrapper2?.classList.add('content-hide');
    const wrapper3 = document.querySelector('#wrapper3');
    wrapper3?.classList.remove('content-show');
    wrapper3?.classList.add('content-hide');
    const wrapper4 = document.querySelector('#wrapper4');
    wrapper4?.classList.remove('content-show');
    wrapper4?.classList.add('content-hide');
    const wrapper5 = document.querySelector('#wrapper5');
    wrapper5?.classList.remove('content-show');
    wrapper5?.classList.add('content-hide');
    const wrapper6 = document.querySelector('#wrapper6');
    wrapper6?.classList.remove('content-show');
    wrapper6?.classList.add('content-hide');
    const wrapper7 = document.querySelector('#wrapper7');
    wrapper7?.classList.remove('content-show');
    wrapper7?.classList.add('content-hide');
    const wrapper8 = document.querySelector('#wrapper8');
    wrapper8?.classList.add('content-show');
    wrapper8?.classList.remove('content-hide');
    const wrapper9 = document.querySelector('#wrapper9');
    wrapper9?.classList.remove('content-show');
    wrapper9?.classList.add('content-hide');
  }
  onPrevious8(): void {
    const wrapper1 = document.querySelector('#wrapper1');
    wrapper1?.classList.add('content-show');
    wrapper1?.classList.remove('content-hide');
    const wrapper2 = document.querySelector('#wrapper2');
    wrapper2?.classList.remove('content-show');
    wrapper2?.classList.add('content-hide');
    const wrapper3 = document.querySelector('#wrapper3');
    wrapper3?.classList.remove('content-show');
    wrapper3?.classList.add('content-hide');
    const wrapper4 = document.querySelector('#wrapper4');
    wrapper4?.classList.remove('content-show');
    wrapper4?.classList.add('content-hide');
    const wrapper5 = document.querySelector('#wrapper5');
    wrapper5?.classList.remove('content-show');
    wrapper5?.classList.add('content-hide');
    const wrapper6 = document.querySelector('#wrapper6');
    wrapper6?.classList.remove('content-show');
    wrapper6?.classList.add('content-hide');
    const wrapper7 = document.querySelector('#wrapper7');
    wrapper7?.classList.remove('content-show');
    wrapper7?.classList.add('content-hide');
    const wrapper8 = document.querySelector('#wrapper8');
    wrapper8?.classList.remove('content-show');
    wrapper8?.classList.add('content-hide');
    const wrapper9 = document.querySelector('#wrapper9');
    wrapper9?.classList.remove('content-show');
    wrapper9?.classList.add('content-hide');
  }
  onPrevious9(): void {
    const wrapper1 = document.querySelector('#wrapper1');
    wrapper1?.classList.remove('content-show');
    wrapper1?.classList.add('content-hide');
    const wrapper2 = document.querySelector('#wrapper2');
    wrapper2?.classList.remove('content-show');
    wrapper2?.classList.add('content-hide');
    const wrapper3 = document.querySelector('#wrapper3');
    wrapper3?.classList.remove('content-show');
    wrapper3?.classList.add('content-hide');
    const wrapper4 = document.querySelector('#wrapper4');
    wrapper4?.classList.remove('content-show');
    wrapper4?.classList.add('content-hide');
    const wrapper5 = document.querySelector('#wrapper5');
    wrapper5?.classList.remove('content-show');
    wrapper5?.classList.add('content-hide');
    const wrapper6 = document.querySelector('#wrapper6');
    wrapper6?.classList.remove('content-show');
    wrapper6?.classList.add('content-hide');
    const wrapper7 = document.querySelector('#wrapper7');
    wrapper7?.classList.remove('content-show');
    wrapper7?.classList.add('content-hide');
    const wrapper8 = document.querySelector('#wrapper8');
    wrapper8?.classList.remove('content-show');
    wrapper8?.classList.add('content-hide');
    const wrapper9 = document.querySelector('#wrapper9');
    wrapper9?.classList.add('content-show');
    wrapper9?.classList.remove('content-hide');
  }

  isReworkWork(event: any) {
    this.isRework = event.checked;
    this.RefreshMaterialSubConsumptionOnIsreworkChecked();
  }
  RefreshMaterialSubConsumptionOnIsreworkChecked(): void {
    const key = {
      IsRework: this.isRework,
      PPDId: this.PPID,
    };
    this.sfdService.getItemBomListInfo(key).subscribe(
      (res: any) => {
        this.ItemBOMList = res.ItemBOMList;
        this.materialFoodSectorConsumptionForm
          .get('mActQtys')
          ?.setValue(res.Qty);
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }
  public checkErrorMaterialFoodConsumption = (
    controlName: string,
    errorName: string
  ) => {
    return this.materialFoodSectorConsumptionForm.controls[
      controlName
    ].hasError(errorName);
  };

  generateColumnsQualityControl(data: any[]): any {
    this.columnDefsQualityControl = [];
    let columnDefinitions: any[] = [];
    data.map((object) => {
      Object.keys(object).map((key) => {
        const mappedColumn = {
          headerName: key === 'Cavity' ? 'Sample' : key, // .toUpperCase()
          headerClass: {},
          headerTooltip: key,
          tooltipComponent: 'customTooltip',
          tooltipValueGetter,
          field: key,
          toolTip: key,
          resizable: true,
          wrapText: true,
          rowGroup: key === 'ParameterGroup' ? true : false,
          width:
            key === 'Cavity' || key === 'DataType' || key === 'ParameterGroup'
              ? 150
              : key === 'Parameter'
                ? 300
                : 200,
          cellStyle: {},
          hide:
            key === 'ParameterGroup' || key === 'Cavity' || key === 'DataType'
              ? true
              : false,
          filter: true,
          sortable: true,
          editable: false,
          valueParser: {},
          valueGetter:
            key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType' &&
              key !== 'parameterId'
              ? this.abValueGetter
              : null,
          pinned:
            key === 'Parameter' ||
              key === 'Cavity' ||
              key === 'DataType' ||
              key === 'ParameterGroup'
              ? 'left'
              : '',
          lockPinned:
            key === 'Parameter' ||
              key === 'Cavity' ||
              key === 'DataType' ||
              key === 'ParameterGroup'
              ? true
              : false,
          rowSelection: 'multiple',
          onCellClicked: (params: any) => {
            this.boolColId = params.column.colId;
            this.boolRowIndex = params.rowIndex;
            if (params.data.DataType === 'Bool') {
              params.colDef.cellEditor = 'agRichSelectCellEditor';
              this.GetAllDataTypesDetailQC(params.data.parameterId);
              this.selectionName = params.data.Parameter;
              this.isProcessGrid = false;
              if (mappedColumn.editable) {
                this.dialog.open(this.qualityBoolListModal, {
                  height: 'auto',
                  width: '45%',
                });
              }
            } else if (params.data.DataType === 'Date') {
              this.selectionName = params.data.Parameter;
              this.isProcessGrid = false;
              if (mappedColumn.editable) {
                this.reOpenQualityCalendar();
              }
            } else {
                          params.colDef.cellEditor = 'agTextCellEditor';
                        }
          },
          cellEditor: null,
          // tslint:disable-next-line:max-line-length
          cellEditorParams:
            key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType'
              ? (params: any): Promise<any> => {
                return params.value;
              }
              : null,
        };
        if (this.qualityGroupType === 'Time') {
          mappedColumn.cellStyle = (params: any): any => {
            if (
              key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType' &&
              key !== 'parameterId'
            ) {
              const fromDate = new Date(key.substring(0, 20));
              const toDate = new Date(key.substring(23, 43));
              // tslint:disable-next-line:max-line-length
              if (
                date.getTime() >= fromDate.getTime() &&
                date.getTime() <= toDate.getTime() + 1 * 60000 &&
                (key.split('~poStatus')[1].split('~')[0] === '' ||
                  key.split('~poStatus')[1].split('~')[0] === 'InProcess')
              ) {
                return {
                  'font-weight': 'bold',
                  color: params.value
                    ? params.data[params.colDef.field].split('|')[1]
                    : 'black',
                  'background-color': key.split('~isSlotVerified')[1] === '1'
                    ? '#79c500'
                    : '#bdccdd',
                };
              } else {
                if (params.value) {
                  return {
                    color: params.data[params.colDef.field].split('|')[1],
                  };
                }
              }
            }
          };
          const date = new Date(new Date().setSeconds(0));
          if (
            key !== 'Parameter' &&
            key !== 'ParameterGroup' &&
            key !== 'Cavity' &&
            key !== 'DataType' &&
            key !== 'parameterId'
          ) {
            const fromDate = new Date(key.substring(0, 20));
            const toDate = new Date(key.substring(23, 43));
            if (
              date.getTime() >= fromDate.getTime() &&
              date.getTime() <= toDate.getTime() + 1 * 60000 &&
              (key.split('~poStatus')[1].split('~')[0] === '' ||
                key.split('~poStatus')[1].split('~')[0] === 'InProcess')
            ) {
              mappedColumn.editable = true;
              mappedColumn.lockPinned = true;
              mappedColumn.pinned = 'left';
              mappedColumn.valueParser = (params: any) => {
                if (this.IsWrite) {
                  const dataType = params.data.DataType;
                  if (
                    dataType === 'Int' ||
                    dataType === 'Float' ||
                    dataType === 'String'
                  ) {
                    const dataType = params.data.DataType;
                    let newVal = params.newValue;
                    if (dataType === 'Int') {
                      const charcter = Number.isInteger(Number(newVal));
                      if (!charcter) {
                        this.toaster.warning(
                          'DigitsOnly',
                          'Please Select Int Value Only'
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          params.oldValue
                        );
                        return params.oldValue;
                      } else {
                        params.newValue = parseInt(params.newValue, 10);
                      }
                    }
                    if (dataType === 'Float') {
                      const float = parseFloat(newVal);
                      if (isNaN(float)) {
                        this.toaster.warning(
                          'Decimal Only',
                          'Please Select Decimal values Only'
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          params.oldValue
                        );
                        return params.oldValue;
                      } else {
                        params.newValue = parseFloat(params.newValue).toFixed(
                          2
                        );
                      }
                    }
                    if (dataType === 'Date') {
                      const date = params.newValue;
                      if (date.match(new RegExp('/', 'g')).length === 2) {
                      } else {
                        this.toaster.warning(
                          'SlashError',
                          'Please Select Correct Date Format'
                        );
                        return params.oldValue;
                      }
                    }
                    const startIntervalDate = params.colDef.field.substring(
                      0,
                      20
                    );
                    const endIntervalDate = params.colDef.field.substring(
                      23,
                      43
                    );
                    if (new Date() > new Date(endIntervalDate)) {
                      this.toaster.warning(
                        'Time Passed',
                        'Slot time has been passed'
                      );
                      return;
                    }
                    let cellData: any;
                    if (!params.oldValue || params.oldValue === '') {
                      cellData = {
                        result: params.newValue,
                        entryOn: new Date(),
                        resultOn: endIntervalDate,
                        endInterval: endIntervalDate,
                        startInterval: startIntervalDate,
                        varId: params.data.parameterId,
                        isOldValue: this.qualityGroupType !== 'Time' ? true : false,
                        cavity: params.data.Cavity ? params.data.Cavity : 0,
                        po: params.column.colId.split('~')[1],
                        createdBy: this.ActiveUserCode,
                        prodId:
                          params.column.colId.split('~prodId')[1] !== undefined
                            ? params.column.colId
                              .split('~prodId')[1]
                              .split('~')[0]
                            : '',
                        ppId:
                          params.column.colId.split('~ppId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppId')[1]
                              .split('~')[0]
                            : '',
                        uomId:
                          params.column.colId.split('~uomId')[1] !== undefined
                            ? params.column.colId
                              .split('~uomId')[1]
                              .split('~')[0]
                            : '',
                        ppdId:
                          params.column.colId.split('~ppdId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppdId')[1]
                              .split('~')[0]
                            : '',
                        intervalType: this.qualityGroupType,
                      };
                    } else {
                      cellData = {
                        result: params.newValue,
                        entryOn: new Date(),
                        resultOn: endIntervalDate,
                        varId: params.data.parameterId,
                        endInterval: endIntervalDate,
                        startInterval: startIntervalDate,
                        isOldValue: true,
                        cavity: params.data.Cavity ? params.data.Cavity : 0,
                        po: params.column.colId.split('~')[1],
                        createdBy: this.ActiveUserCode,
                        prodId:
                          params.column.colId.split('~prodId')[1] !== undefined
                            ? params.column.colId
                              .split('~prodId')[1]
                              .split('~')[0]
                            : '',
                        ppId:
                          params.column.colId.split('~ppId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppId')[1]
                              .split('~')[0]
                            : '',
                        uomId:
                          params.column.colId.split('~uomId')[1] !== undefined
                            ? params.column.colId
                              .split('~uomId')[1]
                              .split('~')[0]
                            : '',
                        ppdId:
                          params.column.colId.split('~ppdId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppdId')[1]
                              .split('~')[0]
                            : '',
                        intervalType: this.qualityGroupType,
                      };
                    }
                    this.processService
                      .saveQualityProcessControl(cellData)
                      .subscribe(
                        (response: any) => {
                          if (response.length && response[0]?.ncrId) {
                            this.onNCRCreate(response, params)

                          }
                          const msg = response[0].result;
                          if (msg !== null || msg !== '') {
                            if (msg.substring(2, 1) === '0') {
                              this.toaster.success(
                                'Success',
                                msg.substring(3, msg.length)
                              );
                              params.node.setDataValue(
                                params.colDef.field,
                                response[0].value
                              );
                              if (response[0].value) {
                                const color = response[0].value.split('|')[1];
                                if (color === '#ff2121') {
                                  this.sendNotificationRole(
                                    `NCR ID - ${response[0].ncrId}
                                     Out of Specification Limits! The Defect had happened against ${params.column.colId.split('~')[1]
                                    }`,
                                    'Quality Control'
                                  );
                                }
                                if (color === '#ffff00') {
                                  this.sendNotificationRole(
                                    `NCR ID - ${response[0].ncrId}
                                     Watch Out! There is a risk of defect happening against ${params.column.colId.split('~')[1]
                                    }`,
                                    'Quality Control'
                                  );
                                }
                              }
                            } else {
                              this.toaster.error(
                                'Error',
                                msg.substring(3, msg.length)
                              );
                              params.node.setDataValue(
                                params.colDef.field,
                                response[0].value
                              );
                            }
                          }
                        },
                        (error: any) => {
                          return this.toaster.error('Error', error.message);
                        }
                      );
                  }
                }
              };
            }
          }
          if (
            key !== 'Parameter' &&
            key !== 'ParameterGroup' &&
            key !== 'parameterId' &&
            key !== 'Cavity' &&
            key !== 'DataType'
          ) {
            const fromDate = new Date(key.substring(0, 20));
            const toDate = new Date(key.substring(23, 43));
            mappedColumn.headerName =
              moment(fromDate).format('HH:mm:ss') +
              ' - ' +
              moment(toDate).format('HH:mm:ss') +
              ' - ' +
              key.split('~')[1] +
              ' - ' +
              key.split('~poStatus')[1].split('~')[0];

            let pcode = '';
            let po = '';
            let name = '';
            po = `PO  :  ${key.split('~')[1]}`;
            pcode = `Code  :  ${key.split('~')[2]}`;
            name = `Name  :  ${key.split('~prodDesc')[1] ? key.split('~prodDesc')[1].split('~')[0] : ''}`;
            mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;

          }
        }

        if (
          this.qualityGroupType === 'Event' ||
          this.qualityGroupType === 'Manual'
        ) {
          if (
            key !== 'Parameter' &&
            key !== 'ParameterGroup' &&
            key !== 'parameterId' &&
            key !== 'Cavity' &&
            key !== 'DataType'
          ) {
            // tslint:disable-next-line:max-line-length
            if (this.qualityGroupType === 'Event') {
              const fromDate = new Date(key.substring(0, 20));
              mappedColumn.headerName =
                moment(fromDate).format('YYYY-MM-DD HH:mm:ss') +
                ' - ' +
                `PO  :  ${key.split('~')[1]}
                `; // LotCode:  ${key.split('~lotCode')[1].split('~')[0]}
              let pcode = '';
              let po = '';
              let name = '';
              po = `PO  :  ${key.split('~')[1]}`;
              pcode = `Code  :  ${key.split('~')[2]}`;
              name = `Name  :  ${key.split('~prodDesc')[1] ? key.split('~prodDesc')[1].split('~')[0] : ''}`;
              mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;
            } else {
              const fromDate = new Date(key.substring(0, 20));
              mappedColumn.headerName =
                moment(fromDate).format('YYYY-MM-DD HH:mm:ss') + ' - ' + key.split('~')[1];

              let pcode = '';
              let po = '';
              let name = '';
              po = `PO  :  ${key.split('~')[1]}`;
              pcode = `Code  :  ${key.split('~')[2]}`;
              name = `Name  :  ${key.split('~prodDesc')[1] ? key.split('~prodDesc')[1].split('~')[0] : ''}`;
              mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;
              // mappedColumn.headerTooltip = `PO :  ${key.split('~')[1]}`+' - '+`Code : ${key.split('~')[2]}`+' - '+name;

            }
            mappedColumn.editable = true;
          }
          mappedColumn.cellStyle = (params: any): any => {
            if (
              key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType' &&
              key !== 'parameterId'
            ) {
              // if (params.value) {
              return {
                'font-weight': 'bold',
                color: params.value
                  ? params.data[params.colDef.field].split('|')[1]
                  : 'black',
                'background-color': key.split('~isSlotVerified')[1] === '1'
                  ? '#79c500'
                  : '#bdccdd',
              };
              // }
            }
          };
          mappedColumn.valueParser = (params: any) => {
            if (this.IsWrite) {
              const dataType = params.data.DataType;
              if (
                dataType === 'Int' ||
                dataType === 'Float' ||
                dataType === 'String'
              ) {
                const dataType = params.data.DataType;
                let newVal = params.newValue;
                if (dataType === 'Int') {
                  const charcter = Number.isInteger(Number(newVal));
                  if (!charcter) {
                    this.toaster.warning(
                      'DigitsOnly',
                      'Please Select Int Value Only'
                    );
                    // newVal = params.oldValue;
                    params.node.setDataValue(
                      params.colDef.field,
                      params.oldValue
                    );
                    return params.oldValue;
                  } else {
                    params.newValue = parseInt(params.newValue, 10);
                  }
                }
                if (dataType === 'Float') {
                  const float = parseFloat(newVal);
                  // tslint:disable-next-line:use-isnan
                  if (isNaN(float)) {
                    this.toaster.warning(
                      'FloatOnly',
                      'Please Select Float Only'
                    );
                    // newVal = params.oldValue;
                    params.node.setDataValue(
                      params.colDef.field,
                      params.oldValue
                    );
                    return params.oldValue;
                  } else {
                    params.newValue = parseFloat(params.newValue).toFixed(2);
                  }
                }
                if (dataType === 'Date') {
                  const date = params.newValue;
                  if (date.match(new RegExp('/', 'g')).length === 2) {
                  } else {
                    this.toaster.warning(
                      'SlashError',
                      'Please Select Correct Date Format'
                    );
                    return params.oldValue;
                  }
                }
                const startIntervalDate = params.colDef.field.substring(0, 20);

                let cellData: any;
                if (!params.oldValue || params.oldValue === '') {
                  cellData = {
                    result: params.newValue,
                    entryOn: new Date(),
                    resultOn: startIntervalDate,
                    endInterval: startIntervalDate,
                    startInterval: startIntervalDate,
                    varId: params.data.parameterId,
                    isOldValue: this.qualityGroupType !== 'Time' ? true : false,
                    cavity: params.data.Cavity ? params.data.Cavity : 0,
                    po: params.column.colId.split('~')[1],
                    createdBy: this.ActiveUserCode,
                    intervalType: this.qualityGroupType,
                    prodId:
                      params.column.colId.split('~prodId')[1] !== undefined
                        ? params.column.colId.split('~prodId')[1].split('~')[0]
                        : '',
                    ppId:
                      params.column.colId.split('~ppId')[1] !== undefined
                        ? params.column.colId.split('~ppId')[1].split('~')[0]
                        : '',
                    uomId:
                      params.column.colId.split('~uomId')[1] !== undefined
                        ? params.column.colId.split('~uomId')[1].split('~')[0]
                        : '',
                    ppdId:
                      params.column.colId.split('~ppdId')[1] !== undefined
                        ? params.column.colId.split('~ppdId')[1].split('~')[0]
                        : '',
                  };
                } else {
                  cellData = {
                    result: params.newValue,
                    entryOn: new Date(),
                    resultOn: startIntervalDate,
                    varId: params.data.parameterId,
                    endInterval: startIntervalDate,
                    startInterval: startIntervalDate,
                    isOldValue: true,
                    cavity: params.data.Cavity ? params.data.Cavity : 0,
                    po: params.column.colId.split('~')[1],
                    createdBy: this.ActiveUserCode,
                    intervalType: this.qualityGroupType,
                    prodId:
                      params.column.colId.split('~prodId')[1] !== undefined
                        ? params.column.colId.split('~prodId')[1].split('~')[0]
                        : '',
                    ppId:
                      params.column.colId.split('~ppId')[1] !== undefined
                        ? params.column.colId.split('~ppId')[1].split('~')[0]
                        : '',
                    uomId:
                      params.column.colId.split('~uomId')[1] !== undefined
                        ? params.column.colId.split('~uomId')[1].split('~')[0]
                        : '',
                    ppdId:
                      params.column.colId.split('~ppdId')[1] !== undefined
                        ? params.column.colId.split('~ppdId')[1].split('~')[0]
                        : '',
                  };
                }
                this.processService
                  .saveQualityProcessControl(cellData)
                  .subscribe(
                    (response: any) => {
                      if (response.length && response[0]?.ncrId) {
                        this.onNCRCreate(response, params)

                      }
                      const msg = response[0].result;
                      if (msg !== null || msg !== '') {
                        if (msg.substring(2, 1) === '0') {
                          this.toaster.success(
                            'Success',
                            msg.substring(3, msg.length)
                          );
                          params.node.setDataValue(
                            params.colDef.field,
                            response[0].value
                          );
                          if (response[0].value) {
                            const color = response[0].value.split('|')[1];
                            if (color === '#ff2121') {
                              this.sendNotificationRole(
                                `NCR ID - ${response[0].ncrId}
                                                       Out of Specification Limits! The Defect had happened against ${params.column.colId.split('~')[1]
                                }`,
                                'Quality Control'
                              );
                            }
                            if (color === '#ffff00') {
                              this.sendNotificationRole(
                                `NCR ID - ${response[0].ncrId}
                                                       Watch Out! There is a risk of defect happening against ${params.column.colId.split('~')[1]
                                }`,
                                'Quality Control'
                              );
                            }
                          }
                          // params.node.setDataValue(params.colDef.field, newVal);
                        } else {
                          this.toaster.error(
                            'Error',
                            msg.substring(3, msg.length)
                          );
                          const colorElements = document.getElementsByClassName(
                            'ag-cell-focus'
                          ) as HTMLCollectionOf<HTMLElement>;
                          const color = colorElements[0].style.color;
                          params.node.setDataValue(
                            params.colDef.field,
                            response[0].value
                          );
                        }
                      }
                    },
                    (error: any) => {
                      return this.toaster.error('Error', error.message);
                    }
                  );
                // }
              }
            }
          };
        }
        if (key === 'parameterId') {
          mappedColumn.hide = true;
        }
        columnDefinitions.push(mappedColumn);
      });
    });

    columnDefinitions = columnDefinitions.filter(
      (column, index, self) =>
        index ===
        self.findIndex((colAtIndex) => colAtIndex.field === column.field)
    );
    this.rowSelection = 'multiple';
    this.columnsQC = [];
    const columnQC = columnDefinitions;
    this.columnsQC = columnQC.filter(
      (c) => c.hide !== true
    );
    return columnDefinitions;
  }

  showDropDown = false;
  onClick() {
    this.showDropDown = true;
  }

  storingMachine = [];

  GetWasteFaultByUnit(): void {
    const key = {
      PUId: this.machineId,
      UserCode: this.ActiveUserCode,
    };
    this.sfdService.GetWasteFaultByUnit(key).subscribe((res: any) => {
      this.FaultList = res.FaultList;
      this.wasteForm.get('categoryType')?.setValue(this.FaultList[0]?.FaultId);
    });
  }
  GetIsShiftStart(): void {
    const key = {
      PUID: this.machineId,
    };
    this.sfdService.GetIsShiftStart(key).subscribe((res: any) => {
      this.crewId = res.CrewId;
      if (this.crewId === 0) {
        this.showShiftClose = false;
      } else {
        this.showShiftClose = true;
      }
      this.GetShiftCloseValidation();
    });
  }
  shiftstart: any;
  shiftend: any;

  GetCrewScheduleList(): void {
    const key = {
      PUID: this.machineId,
      Date: moment(new Date()), // .format('YYYY-MM-DD'),
    };
    this.crewService.GetCrewScheduleList(key).then((res: any) => {
      this.crewScheduleList = res.CrewScheduleList;
      if (this.crewScheduleList.length) {
        const date = new Date();
        // tslint:disable-next-line:max-line-length
        const record = this.crewScheduleList.filter(
          (c: any) =>
            date.getTime() >= new Date(c.ShiftStart).getTime() &&
            date.getTime() <= new Date(c.ShiftEnd).getTime()
        );
        this.shiftstart = new Date(record[0]?.ShiftStart);
        this.shiftend = new Date();
        this.shiftStartTime = this.shiftstart?.getTime();
        // this.Chart();

        this.getSFDCChart();
        // const minutes = parseInt(Math.abs(record[0].ShiftEnd.getTime() - record[0]. ShiftStart.getTime() / (1000 * 60) % 60);
        const from = record[0]?.ShiftStart;
        const To = record[0]?.ShiftEnd;
        const timeDiff = moment(new Date(To)).diff(
          moment(new Date(from)),
          'minutes'
        );

        this.timedifference = timeDiff;
        const start = new Date();
        const selected = {
          startDate: this.shiftstart,
          endDate: this.shiftend,
        };
        this.processControlForm.get('datePicker')?.setValue(selected);
        const selected2 = {
          startDate: this.shiftstart,
          endDate: this.shiftend,
        };
        this.qualityControlForm.get('datePicker')?.setValue(selected2);
        this.GetGroupTypeList();
        this.getOeeDashboard();
        this.GetQualityControlGroupTypeList();
      } else {
        const start = new Date();
        this.shiftstart = new Date(start.setHours(0, 0, 0, 0));
        this.shiftend = new Date();
        const selected = {
          startDate: new Date(start.setHours(0, 0, 0, 0)),
          endDate: new Date(),
        };
        this.processControlForm.get('datePicker')?.setValue(selected);
        const selected2 = {
          startDate: new Date(start.setHours(0, 0, 0, 0)),
          endDate: new Date(),
        };
        this.qualityControlForm.get('datePicker')?.setValue(selected2);
        this.shiftStartTime = new Date(start.setHours(0, 0, 0, 0)).getTime();
        this.getSFDCChart();
        this.GetGroupTypeList();
        this.GetQualityControlGroupTypeList();
      }
    });
  }
  abValueGetter(params: any): any {
    if (params.data) {
      return params.data[params.colDef.field]
        ? params.data[params.colDef.field].split('|')[0]
        : '';
    }
  }
  onIntervalChange(): void { }
  onToProcessDateQuanlityControl(): any {
    const getdata = {
      fromDate: this.qualityControlForm.value.datePicker.startDate,
      toDate: this.qualityControlForm.value.datePicker.endDate,
      puId: this.unitId,
      cavity: this.maxCavity,
      processType: 'PO',
      interval: this.qualityControlForm.value.timeInterval,
      currentDateTime: new Date(),
      groupType: this.qualityGroupType,
      intervalType:
        this.qualityGroupType === 'Time' || this.qualityGroupType === 'Manual'
          ? this.qualityGroupType
          : this.qualityControlForm.value.eventType,
    };
    if (
      getdata.puId === undefined ||
      !getdata.fromDate ||
      !getdata.toDate ||
      this.UnitName === ''
    ) {
      this.toaster.warning(this.translate.instant('SelectDatesPlants'));
      return;
    }
    const from = this.qualityControlForm.value.datePicker.startDate;
    const To = this.qualityControlForm.value.datePicker.endDate;
    const timeDiff = moment(To).diff(moment(from), 'hours');

    if (!this.qualityGroupType) {
      return;
    }
    this.qualityGridApi.showLoadingOverlay();
    this.processService.getQualityProcessControl(getdata).then(
      (response: any) => {
        this.gridOptionsQualityControl.api.hideOverlay();
        const results: any = [];
        // tslint:disable-next-line:space-before-function-paren
        response.forEach(function (this: any, e: any): any {
          const a =
            e.parameterGroup +
            '|' +
            e.parameterName +
            '|' +
            e.parameterId +
            '|' +
            e.dataType +
            '|' +
            e.cavity;
          if (!this[a]) {
            // tslint:disable-next-line:max-line-length
            this[a] = {
              ParameterGroup: e.parameterGroup,
              Parameter: e.parameterName,
              parameterId: e.parameterId,
              DataType: e.dataType,
              Cavity: e.cavity,
            };
            results.push(this[a]);
          }
          this[a][e.timInterval1] = e.value;
        }, {});
        // this.rowDataQualityControl = [];
        this.qualityGridApi.setRowData(results);
        this.rowDataQualityControl2 = results;
        // this.rowDataQualityControl = response;
        if (this.rowDataQualityControl2) {
          this.columnDefsQualityControl = this.generateColumnsQualityControl(
            this.rowDataQualityControl2
          );
          setTimeout(() => {
            this.gridOptionsQualityControl.api.columnController.resetColumnState();
            const scroll = document.querySelector(
              '#gridContainerQualityControl  .ag-body-horizontal-scroll-viewport'
            );
            if (scroll !== null && this.qualityGroupType !== 'Manual' && this.qualityGroupType !== 'Event') {
              scroll.scrollLeft = scroll.scrollWidth;
            }
          }, 100);
          if (this.qualityGroupType === 'Manual') {
            this.onQualityParameterGroupChange();
          }
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
        this.spinner.hide();
      }
    );
  }
  async GetAllDataTypesDetail(val: any): Promise<any> {
    const key = {
      variableId: val,
    };
    await this.machineParamtersService
      .GetAllDataTypesDetail(key)
      .then((res: any) => {
        this.boolList = res.map((c: any) => c.text);
      });
  }
  // ------- Context Menu Process Control
  processControlSpecification(params: any): void {
    this.processControlSpecificationModal = true;
    const podata = params.column.colId.split('~')[1];
    this.paramterSpcecificationName = params.node.data.Parameter;
    const key = {
      processOrder: podata,
      paramterId: params.node.data.parameterId,
      prodId:
        params.column.colId.split('~prodId')[1] !== undefined
          ? params.column.colId.split('~prodId')[1].split('~')[0]
          : '',
    };
    this.getParameterSpecificationsProcessControl(key);
  }
  getParameterSpecificationsProcessControl(key: any): void {
    this.processService.processparameterspecs(key).subscribe(
      (response: any) => {
        this.parameterspecifications.data = response;
        // this.chartSpecifications = response;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  onClickControlProcessOrderQualityControl(): any {
    const key = {
      fromDate: this.qualityControlForm.value.datePicker.startDate,
      toDate: this.qualityControlForm.value.datePicker.endDate,
      puId: this.unitId,
      cavity: this.maxCavity,
      processType: this.qualityControlForm.value.processType,
    };
    this.spinnerButtonOptionsOrders.active = true;
    this.processService
      .getQualityControlProcessOrder(key)
      .subscribe((response: any) => {
        this.dialog.open(this.displayQualityOrdersModal, {
          height: 'auto',
          width: '90%',
        });
        this.qualityProcessOrder.data = response;
        // this.getPaginator();
      });
    this.spinnerButtonOptionsOrders.active = false;
  }

  applyFilterQPO(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.qualityProcessOrder.filter = filterValue.trim().toLowerCase();
  }

  onClickParamterComparsionQualityControl(): void {
    this.range.get('fromDate').setValue(new Date(this.qualityControlForm.value.datePicker.startDate));
    this.range.get('toDate').setValue(new Date(this.qualityControlForm.value.datePicker.endDate));

    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    this.Gridtype = 'qualityControl';
    const selectedRows = this.qualityGridApi
      .getSelectedRows()
      .filter((c: any) => c.DataType === 'Int' || c.DataType === 'Float');
    this.spinnerButtonOptions1.active = true;
    // tslint:disable-next-line:max-line-length
    this.dialog.open(this.visibleParameterComparison, {
      panelClass: 'custom-dialog-container',
      width: '100vw',
      height: '100vh',
      minWidth: '95vw',
      maxHeight: '100vh',
    });
    this.selectedParameters = selectedRows;
    this.selectedProducts = this.machineProducts;
    const array: any = [];
    const yAxisArr: any[] = [];
    const values = selectedRows
      .map((value: any) => value.parameterId)
      .toString();
    const valueNames = selectedRows.map((value: any) => value.Parameter);
    const seletedGroups = selectedRows.map(
      (value: any) => value.ParameterGroup
    );
    const uniqueGroups = [...new Set(seletedGroups)];
    const dataArrName: any[] = [];
    const key = {
      parameterId: values,
      groupType: this.qualityGroupType,
      products: this.machineProducts.map(c => c.Prod_Id).toString(),
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.show();
    this.processService.getQualityProcessParameterComparison(key).then(
      (data: any) => {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < valueNames.length; i++) {
          const dataArr = [];
          // tslint:disable-next-line:prefer-for-of
          for (let j = 0; j < data.length; j++) {
            // const arr = [];
            if (valueNames[i] === data[j].name) {
              dataArr.push({
                x: new Date(data[j].processTime).getTime(),
                y: isNaN(data[j].result) ? '' : parseFloat(data[j].result),
                label: data[j].product,
              });
            }
          }
          let negativeArr = [];
          negativeArr = dataArr.map((c) => c.y);
          const obj = {
            tooltip: {
              valueDecimals: 2,
            },
            name: valueNames[i],
            type: 'line',
            data: dataArr,
            color: this.highChartsColor[i],
            yAxis: i,
          };
          array.push(obj);
          yAxisArr.push({
            lineWidth: 1,
            opposite: negativeArr.some((v) => v < 0) ? true : false,
            title: {
              text: valueNames[i],
              style: {
                color: this.highChartsColor[i],
              },
            },
            labels: {
              style: {
                color: this.highChartsColor[i],
              },
            },
          });
        }
        this.chart = new StockChart({
          chart: {
            height: 730,
          },
          time: {
            useUTC: false
          },
          plotOptions: {
            series: {
              turboThreshold: 50000000,
              events: {
                hide(): any {
                  // this.yAxis.axisTitle.hide();
                  this.yAxis.update({
                    visible: false,
                  });
                },
                show(): any {
                  this.yAxis.update({
                    visible: true,
                  });
                },
              },
            },
          },
          rangeSelector: {
            inputEnabled: false,
            selected: 1,
          },
          title: {
            text: uniqueGroups.toString(),
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
          },
          tooltip: {
            formatter(): any {
              // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
              let s = '';
              this.points?.forEach((point: any) => {
                s +=
                  '<br/> <span style="color: ' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ' : ' +
                  point.y +
                  '<span><br/>' +
                  '<br/><span style="color: ' +
                  point.series.color +
                  '">Product : ' +
                  point.point.label +
                  '<span><br/>';
              });
              return s;
            },
          },
          yAxis: yAxisArr,
          series: array,
        });
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
    this.spinnerButtonOptions1.active = false;
  }
  onChangeParamterComparsionQualityControl(): void {

    this.spinnerButtonOptions1.active = true;
    // tslint:disable-next-line:max-line-length
    const selectedRows = this.selectedParameters;

    const array: any = [];
    const yAxisArr: any[] = [];
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    const values = selectedRows
      .map((value: any) => value.parameterId)
      .toString();
    const valueNames = selectedRows.map((value: any) => value.Parameter);
    const seletedGroups = selectedRows.map(
      (value: any) => value.ParameterGroup
    );
    const uniqueGroups = [...new Set(seletedGroups)];
    const dataArrName: any[] = [];
    const key = {
      parameterId: values,
      groupType: this.qualityGroupType,
      products: this.selectedProducts.map(c => c.Prod_Id).toString(),
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.show();
    this.processService.getQualityProcessParameterComparison(key).then(
      (data: any) => {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < valueNames.length; i++) {
          const dataArr = [];
          // tslint:disable-next-line:prefer-for-of
          for (let j = 0; j < data.length; j++) {
            // const arr = [];
            if (valueNames[i] === data[j].name) {
              dataArr.push({
                x: new Date(data[j].processTime).getTime(),
                y: isNaN(data[j].result) ? '' : parseFloat(data[j].result),
                label: data[j].product,
              });
            }
          }
          let negativeArr = [];
          negativeArr = dataArr.map((c) => c.y);
          const obj = {
            tooltip: {
              valueDecimals: 2,
            },
            name: valueNames[i],
            type: 'line',
            data: dataArr,
            color: this.highChartsColor[i],
            yAxis: i,
          };
          array.push(obj);
          yAxisArr.push({
            lineWidth: 1,
            opposite: negativeArr.some((v) => v < 0) ? true : false,
            title: {
              text: valueNames[i],
              style: {
                color: this.highChartsColor[i],
              },
            },
            labels: {
              style: {
                color: this.highChartsColor[i],
              },
            },
          });
        }
        this.chart = new StockChart({
          chart: {
            height: 730,
          },
          time: {
            useUTC: false
          },
          plotOptions: {
            series: {
              turboThreshold: 50000000,
              events: {
                hide(): any {
                  // this.yAxis.axisTitle.hide();
                  this.yAxis.update({
                    visible: false,
                  });
                },
                show(): any {
                  this.yAxis.update({
                    visible: true,
                  });
                },
              },
            },
          },
          rangeSelector: {
            inputEnabled: false,
            selected: 1,
          },
          title: {
            text: uniqueGroups.toString(),
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
          },
          tooltip: {
            formatter(): any {
              // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
              let s = '';
              this.points?.forEach((point: any) => {
                s +=
                  '<br/> <span style="color: ' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ' : ' +
                  point.y +
                  '<span><br/>' +
                  '<br/><span style="color: ' +
                  point.series.color +
                  '">Product : ' +
                  point.point.label +
                  '<span><br/>';
              });
              return s;
            },
          },
          yAxis: yAxisArr,
          series: array,
        });
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
    this.spinnerButtonOptions1.active = false;
  }
  onClickParamterAnalysisQualityControl(): any {
    this.range.reset();
    this.range.get('fromDate').setValue(new Date(this.qualityControlForm.value.datePicker.startDate));
    this.range.get('toDate').setValue(new Date(this.qualityControlForm.value.datePicker.endDate));

    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    this.Gridtype = 'qualityControl';
    const selectedRows = this.qualityGridApi
      .getSelectedRows()
      .filter(
        (c: any) =>
          c.DataType === 'Int' ||
          c.DataType === 'Bool' ||
          c.DataType === 'Float'
      );
    this.spinnerButtonOptions.active = true;
    this.chartArray = [];
    this.selectedParameters = selectedRows;
    this.selectedProducts = this.machineProducts;
    // tslint:disable-next-line:max-line-length
    this.dialog.open(this.visibleYearlyTargetTbl, {
      panelClass: 'custom-dialog-container',
      width: '95vw !important',
      height: '100vh',
      minWidth: '95vw',
      maxHeight: '100vh',
    });
    selectedRows.forEach(async (element: any) => {
      const parameterName = element.Parameter + ' (' + element.Cavity + ')';
      const key = {
        parameterId: element.parameterId,
        cavity: element.Cavity ? element.Cavity : 0,
        groupType: this.qualityGroupType,
        products: this.machineProducts.map(c => c.Prod_Id).toString(),
        fromDate: fromDate,
        toDate: toDate,
      };
      const chartObj = { id: '', chartOption: {} };
      chartObj.id = element.parameterId + '_' + element.Cavity;
      await this.processService.getQualityProcessParameterAnalysis(key).then(
        (data: any) => {
          this.spinnerButtonOptions.active = false;
          const LRLarray: any[] = [];
          const LSLarray: any[] = [];
          const LWLarray: any[] = [];
          const TGTarray: any[] = [];
          const UWLarray: any[] = [];
          const USLarray: any[] = [];
          const URLarray: any[] = [];
          const array: any[] = [];
          data.forEach((c: any) => {
            // tslint:disable-next-line:one-variable-per-declaration
            const arr = [],
              arrLRL = [];
            const arrLSL = [];
            const arrLWL = [];
            const arrTGT = [];
            const arrUWL = [];
            const arrUSL = [];
            const arrURL = [];
            arr.push(new Date(c.processTime).getTime());
            arr.push(parseFloat(c.result));
            // array.push(arr);
            array.push({
              x: new Date(c.processTime).getTime(),
              y: isNaN(c.result) ? '' : parseFloat(c.result),
              label: c.Product,
            });
            arrLRL.push(new Date(c.processTime).getTime());
            arrLRL.push(parseFloat(c.LRL));
            LRLarray.push(arrLRL);
            arrLSL.push(new Date(c.processTime).getTime());
            arrLSL.push(parseFloat(c.LSL));
            LSLarray.push(arrLSL);
            arrLWL.push(new Date(c.processTime).getTime());
            arrLWL.push(parseFloat(c.LWL));
            LWLarray.push(arrLWL);
            arrTGT.push(new Date(c.processTime).getTime());
            arrTGT.push(parseFloat(c.TGT));
            TGTarray.push(arrTGT);
            arrUWL.push(new Date(c.processTime).getTime());
            arrUWL.push(parseFloat(c.UWL));
            UWLarray.push(arrUWL);
            arrUSL.push(new Date(c.processTime).getTime());
            arrUSL.push(parseFloat(c.USL));
            USLarray.push(arrUSL);
            arrURL.push(new Date(c.processTime).getTime());
            arrURL.push(parseFloat(c.URL));
            URLarray.push(arrURL);
          });
          this.stock = new StockChart({
            plotOptions: {
              series: {
                turboThreshold: 50000000,
              },
            },
            chart: {
              height: 730,
            },
            rangeSelector: {
              inputEnabled: false,
              selected: 1,
            },
            time: {
              useUTC: false
            },
            title: {
              text: parameterName.toUpperCase(),
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: true,
            },
            tooltip: {
              formatter(): any {
                // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
                let s = '';
                this.points?.forEach((point: any) => {
                  if (point.series.name === 'Result') {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>' +
                      '<br/><span style="color: #252031">Product : ' +
                      point.point.label +
                      '<span><br/>';
                  } else {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>';
                  }
                });
                return s;
              },
            },
            yAxis: {
              title: {
                text: 'Result',
              },
              opposite: false,
              // tickInterval: 50
            },
            series: [
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'Result',
                type: 'line',
                data: array,
                color: '#040496',
                marker: {
                  enabled: true,
                },
                label: {
                  onArea: false,
                },
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LRL',
                type: 'line',
                data: LRLarray,
                color: '#00ff00',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LSL',
                type: 'line',
                data: LSLarray,
                color: '#FF5733',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LWL',
                type: 'line',
                data: LWLarray,
                color: '#9C412D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'TGT',
                type: 'line',
                data: TGTarray,
                color: '#9C902D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'UWL',
                type: 'line',
                data: UWLarray,
                color: '#25B79B',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'USL',
                type: 'line',
                data: USLarray,
                color: '#257AB7',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'URL',
                type: 'line',
                data: URLarray,
                color: '#FF0909',
                dashStyle: 'ShortDash',
              },
            ],
          });

          chartObj.chartOption = this.stock;
          this.chartArray.push(chartObj);
        },
        (error: any) => {
          this.toaster.error('Error', error.ErrorMessage);
          this.spinnerButtonOptions.active = false;
        }
      );
    });
    this.spinnerButtonOptions.active = false;
  }
  onChangeParamterAnalysisQualityControl(): any {
    this.Gridtype = 'qualityControl';
    const selectedRows = this.selectedParameters;
    this.spinnerButtonOptions.active = true;
    this.chartArray = [];
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    // tslint:disable-next-line:max-line-length
    selectedRows.forEach(async (element: any) => {
      const parameterName = element.Parameter + ' (' + element.Cavity + ')';
      const key = {
        parameterId: element.parameterId,
        cavity: element.Cavity ? element.Cavity : 0,
        groupType: this.qualityGroupType,
        products: this.selectedProducts.map(c => c.Prod_Id).toString(),
        fromDate: fromDate,
        toDate: toDate,
      };
      const chartObj = { id: '', chartOption: {} };
      chartObj.id = element.parameterId + '_' + element.Cavity;
      await this.processService.getQualityProcessParameterAnalysis(key).then(
        (data: any) => {
          this.spinnerButtonOptions.active = false;
          const LRLarray: any[] = [];
          const LSLarray: any[] = [];
          const LWLarray: any[] = [];
          const TGTarray: any[] = [];
          const UWLarray: any[] = [];
          const USLarray: any[] = [];
          const URLarray: any[] = [];
          const array: any[] = [];
          data.forEach((c: any) => {
            // tslint:disable-next-line:one-variable-per-declaration
            const arr = [],
              arrLRL = [];
            const arrLSL = [];
            const arrLWL = [];
            const arrTGT = [];
            const arrUWL = [];
            const arrUSL = [];
            const arrURL = [];
            arr.push(new Date(c.processTime).getTime());
            arr.push(parseFloat(c.result));
            // array.push(arr);
            array.push({
              x: new Date(c.processTime).getTime(),
              y: isNaN(c.result) ? '' : parseFloat(c.result),
              label: c.Product,
            });
            arrLRL.push(new Date(c.processTime).getTime());
            arrLRL.push(parseFloat(c.LRL));
            LRLarray.push(arrLRL);
            arrLSL.push(new Date(c.processTime).getTime());
            arrLSL.push(parseFloat(c.LSL));
            LSLarray.push(arrLSL);
            arrLWL.push(new Date(c.processTime).getTime());
            arrLWL.push(parseFloat(c.LWL));
            LWLarray.push(arrLWL);
            arrTGT.push(new Date(c.processTime).getTime());
            arrTGT.push(parseFloat(c.TGT));
            TGTarray.push(arrTGT);
            arrUWL.push(new Date(c.processTime).getTime());
            arrUWL.push(parseFloat(c.UWL));
            UWLarray.push(arrUWL);
            arrUSL.push(new Date(c.processTime).getTime());
            arrUSL.push(parseFloat(c.USL));
            USLarray.push(arrUSL);
            arrURL.push(new Date(c.processTime).getTime());
            arrURL.push(parseFloat(c.URL));
            URLarray.push(arrURL);
          });
          this.stock = new StockChart({
            plotOptions: {
              series: {
                turboThreshold: 50000000,
              },
            },
            chart: {
              height: 730,
            },
            rangeSelector: {
              inputEnabled: false,
              selected: 1,
            },
            title: {
              text: parameterName.toUpperCase(),
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: true,
            },
            time: {
              useUTC: false
            },
            tooltip: {
              formatter(): any {
                // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
                let s = '';
                this.points?.forEach((point: any) => {
                  if (point.series.name === 'Result') {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>' +
                      '<br/><span style="color: #252031">Product : ' +
                      point.point.label +
                      '<span><br/>';
                  } else {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>';
                  }
                });
                return s;
              },
            },
            yAxis: {
              title: {
                text: 'Result',
              },
              opposite: false,
              // tickInterval: 50
            },
            series: [
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'Result',
                type: 'line',
                data: array,
                color: '#040496',
                marker: {
                  enabled: true,
                },
                label: {
                  onArea: false,
                },
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LRL',
                type: 'line',
                data: LRLarray,
                color: '#00ff00',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LSL',
                type: 'line',
                data: LSLarray,
                color: '#FF5733',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LWL',
                type: 'line',
                data: LWLarray,
                color: '#9C412D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'TGT',
                type: 'line',
                data: TGTarray,
                color: '#9C902D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'UWL',
                type: 'line',
                data: UWLarray,
                color: '#25B79B',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'USL',
                type: 'line',
                data: USLarray,
                color: '#257AB7',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'URL',
                type: 'line',
                data: URLarray,
                color: '#FF0909',
                dashStyle: 'ShortDash',
              },
            ],
          });

          chartObj.chartOption = this.stock;
          this.chartArray.push(chartObj);
        },
        (error: any) => {
          this.toaster.error('Error', error.ErrorMessage);
          this.spinnerButtonOptions.active = false;
        }
      );
    });
    this.spinnerButtonOptions.active = false;
  }

  onClickParamterAnalysisProcessControl(): void {
    this.range.reset();
    this.range.get('fromDate').setValue(new Date(this.processControlForm.value.datePicker.startDate));
    this.range.get('toDate').setValue(new Date(this.processControlForm.value.datePicker.endDate));
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    this.Gridtype = 'processControl';
    const selectedRows = this.processGridApi
      .getSelectedRows()
      .filter(
        (c: any) =>
          c.DataType === 'Int' ||
          c.DataType === 'Bool' ||
          c.DataType === 'Float'
      );
    this.spinnerButtonOptions.active = true;
    // tslint:disable-next-line:max-line-length
    this.dialog.open(this.visibleYearlyTargetTbl, {
      panelClass: 'custom-dialog-container',
      width: '95vw !important',
      height: '100vh',
      minWidth: '95vw',
      maxHeight: '100vh',
    });
    this.selectedParameters = selectedRows;
    this.selectedProducts = this.machineProducts;
    this.chartArray = [];
    selectedRows.forEach(async (element: any) => {
      const parameterName = element.Parameter;
      const key = {
        parameterId: element.parameterId,
        groupType: this.processGroupType,
        products: this.machineProducts.map(c => c.Prod_Id).toString(),
        fromDate: fromDate,
        toDate: toDate
      };
      const chartObj = { id: '', chartOption: {} };
      chartObj.id = element.parameterId;
      await this.processService.getProcessParameterAnalysis(key).then(
        (data: any) => {
          this.spinnerButtonOptions.active = false;
          const LRLarray: any[] = [];
          const LSLarray: any[] = [];
          const LWLarray: any[] = [];
          const TGTarray: any[] = [];
          const UWLarray: any[] = [];
          const USLarray: any[] = [];
          const URLarray: any[] = [];
          const Productarray: any[] = [];
          const array: any[] = [];
          data.forEach((c: any) => {
            // tslint:disable-next-line:one-variable-per-declaration
            const arr = [],
              arrLRL = [];
            const arrLSL = [];
            const arrLWL = [];
            const arrTGT = [];
            const arrUWL = [];
            const arrUSL = [];
            const arrURL = [];
            const arrProduct = [];
            arr.push(new Date(c.processTime).getTime());
            arr.push(parseFloat(c.result));
            array.push({
              x: new Date(c.processTime).getTime(),
              y: parseFloat(c.result),
              label: c.Product,
            });
            arrLRL.push(new Date(c.processTime).getTime());
            arrLRL.push(parseFloat(c.LRL)); // LSL Rename To LRL
            LRLarray.push(arrLRL);
            arrLSL.push(new Date(c.processTime).getTime());
            arrLSL.push(parseFloat(c.LSL)); // LCL Rename To LSL
            LSLarray.push(arrLSL);
            arrLWL.push(new Date(c.processTime).getTime());
            arrLWL.push(parseFloat(c.LWL));
            LWLarray.push(arrLWL);
            arrTGT.push(new Date(c.processTime).getTime());
            arrTGT.push(parseFloat(c.TGT));
            TGTarray.push(arrTGT);
            arrUWL.push(new Date(c.processTime).getTime());
            arrUWL.push(parseFloat(c.UWL));
            UWLarray.push(arrUWL);
            arrUSL.push(new Date(c.processTime).getTime());
            arrUSL.push(parseFloat(c.USL)); // UCL Rename To USL
            USLarray.push(arrUSL);
            arrURL.push(new Date(c.processTime).getTime());
            arrURL.push(parseFloat(c.URL)); // USL Rename To URL
            URLarray.push(arrURL);
            arrProduct.push(new Date(c.processTime).getTime());
            arrProduct.push(c.Product); // USL Rename To URL
            Productarray.push({
              x: new Date(c.processTime).getTime(),
              y: isNaN(c.result) ? '' : parseFloat(c.result),
              label: c.Product,
            });
          });
          this.stock = new StockChart({
            plotOptions: {
              series: {
                turboThreshold: 50000000,
              },
            },
            chart: {
              height: 730,
            },
            rangeSelector: {
              inputEnabled: false,
              selected: 1,
            },
            title: {
              text: parameterName.toUpperCase(),
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: true,
            },
            tooltip: {
              formatter(): any {
                // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
                let s = '';
                this.points?.forEach((point: any) => {
                  if (point.series.name === 'Result') {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>' +
                      '<br/><span style="color: #252031">Product : ' +
                      point.point.label +
                      '<span><br/>';
                  } else {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>';
                  }
                });
                return s;
              },
            },
            yAxis: [
              {
                title: {
                  text: 'Result',
                },
                opposite: false,
              },
              {
                title: {
                  text: 'Product',
                  style: {
                    color: '#252031',
                  },
                },
                opposite: true,
              },
            ],
            series: [
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'Result',
                type: 'line',
                data: array,
                color: '#040496',
                // dataLabels: {
                //   enabled: true,
                //   formatter(): any {
                //
                //     return `<span>${this.point.label}</span>`;
                //   }
                // }
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LRL',
                type: 'line',
                data: LRLarray,
                color: '#00ff00',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LSL',
                type: 'line',
                data: LSLarray,
                color: '#FF5733',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LWL',
                type: 'line',
                data: LWLarray,
                color: '#9C412D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'TGT',
                type: 'line',
                data: TGTarray,
                color: '#9C902D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'UWL',
                type: 'line',
                data: UWLarray,
                color: '#25B79B',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'USL',
                type: 'line',
                data: USLarray,
                color: '#257AB7',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'URL',
                type: 'line',
                data: URLarray,
                color: '#FF0909',
                dashStyle: 'ShortDash',
              },
            ],
          });

          chartObj.chartOption = this.stock;
          this.chartArray.push(chartObj);
        },
        (error: any) => {
          this.toaster.error('Error', error.ErrorMessage);
          this.spinnerButtonOptions.active = false;
        }
      );
    });
    this.spinnerButtonOptions.active = false;
  }
  onChangeParamterAnalysisnProcessControl(): void {

    this.spinnerButtonOptions.active = true;
    // tslint:disable-next-line:max-line-length
    const selectedRows = this.selectedParameters;
    this.chartArray = [];
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    selectedRows.forEach(async (element: any) => {
      const parameterName = element.Parameter;
      const key = {
        parameterId: element.parameterId,
        groupType: this.processGroupType,
        products: this.selectedProducts.map(c => c.Prod_Id).toString(),
        fromDate: fromDate,
        toDate: toDate
      };
      const chartObj = { id: '', chartOption: {} };
      chartObj.id = element.parameterId;
      await this.processService.getProcessParameterAnalysis(key).then(
        (data: any) => {
          this.spinnerButtonOptions.active = false;
          const LRLarray: any[] = [];
          const LSLarray: any[] = [];
          const LWLarray: any[] = [];
          const TGTarray: any[] = [];
          const UWLarray: any[] = [];
          const USLarray: any[] = [];
          const URLarray: any[] = [];
          const Productarray: any[] = [];
          const array: any[] = [];
          data.forEach((c: any) => {
            // tslint:disable-next-line:one-variable-per-declaration
            const arr = [],
              arrLRL = [];
            const arrLSL = [];
            const arrLWL = [];
            const arrTGT = [];
            const arrUWL = [];
            const arrUSL = [];
            const arrURL = [];
            const arrProduct = [];
            arr.push(new Date(c.processTime).getTime());
            arr.push(parseFloat(c.result));
            array.push({
              x: new Date(c.processTime).getTime(),
              y: parseFloat(c.result),
              label: c.Product,
            });
            arrLRL.push(new Date(c.processTime).getTime());
            arrLRL.push(parseFloat(c.LRL)); // LSL Rename To LRL
            LRLarray.push(arrLRL);
            arrLSL.push(new Date(c.processTime).getTime());
            arrLSL.push(parseFloat(c.LSL)); // LCL Rename To LSL
            LSLarray.push(arrLSL);
            arrLWL.push(new Date(c.processTime).getTime());
            arrLWL.push(parseFloat(c.LWL));
            LWLarray.push(arrLWL);
            arrTGT.push(new Date(c.processTime).getTime());
            arrTGT.push(parseFloat(c.TGT));
            TGTarray.push(arrTGT);
            arrUWL.push(new Date(c.processTime).getTime());
            arrUWL.push(parseFloat(c.UWL));
            UWLarray.push(arrUWL);
            arrUSL.push(new Date(c.processTime).getTime());
            arrUSL.push(parseFloat(c.USL)); // UCL Rename To USL
            USLarray.push(arrUSL);
            arrURL.push(new Date(c.processTime).getTime());
            arrURL.push(parseFloat(c.URL)); // USL Rename To URL
            URLarray.push(arrURL);
            arrProduct.push(new Date(c.processTime).getTime());
            arrProduct.push(c.Product); // USL Rename To URL
            Productarray.push({
              x: new Date(c.processTime).getTime(),
              y: isNaN(c.result) ? '' : parseFloat(c.result),
              label: c.Product,
            });
          });
          this.stock = new StockChart({
            plotOptions: {
              series: {
                turboThreshold: 50000000,
              },
            },
            chart: {
              height: 730,
            },
            rangeSelector: {
              inputEnabled: false,
              selected: 1,
            },
            title: {
              text: parameterName.toUpperCase(),
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: true,
            },
            tooltip: {
              formatter(): any {
                // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
                let s = '';
                this.points?.forEach((point: any) => {
                  if (point.series.name === 'Result') {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>' +
                      '<br/><span style="color: #252031">Product : ' +
                      point.point.label +
                      '<span><br/>';
                  } else {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>';
                  }
                });
                return s;
              },
            },
            yAxis: [
              {
                title: {
                  text: 'Result',
                },
                opposite: false,
              },
              {
                title: {
                  text: 'Product',
                  style: {
                    color: '#252031',
                  },
                },
                opposite: true,
              },
            ],
            series: [
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'Result',
                type: 'line',
                data: array,
                color: '#040496',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LRL',
                type: 'line',
                data: LRLarray,
                color: '#00ff00',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LSL',
                type: 'line',
                data: LSLarray,
                color: '#FF5733',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LWL',
                type: 'line',
                data: LWLarray,
                color: '#9C412D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'TGT',
                type: 'line',
                data: TGTarray,
                color: '#9C902D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'UWL',
                type: 'line',
                data: UWLarray,
                color: '#25B79B',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'USL',
                type: 'line',
                data: USLarray,
                color: '#257AB7',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'URL',
                type: 'line',
                data: URLarray,
                color: '#FF0909',
                dashStyle: 'ShortDash',
              },
            ],
          });

          chartObj.chartOption = this.stock;
          this.chartArray.push(chartObj);
        },
        (error: any) => {
          this.toaster.error('Error', error.ErrorMessage);
          this.spinnerButtonOptions.active = false;
        }
      );
    });
    this.spinnerButtonOptions.active = false;
  }

  getTanksByMachine(): void {
    const key = {
      PPDId: this.PPID, // change it later
      PuId: +this.unitId, // change it later
      PlantCode: this.plantSession.plantCode
    }
    this.storageTanksList = [];
    this.filteredStorageTanksList = [];
    this.sfdService.GetTanksByMachine(key).subscribe(
      (response: any) => {
        this.storageTanksList = response;
        this.filteredStorageTanksList = this.storageTanksList?.slice();
        response.length > 0 ? this.productionOutputForm.get('storageTanks').setValue(response[0].TankId) : null;
        if (this.machineType && response.length > 0) {
          this.productionOutputForm.get('storageTanks').setValidators([Validators.required]);
          this.productionOutputForm.get('storageTanks').updateValueAndValidity();
        } else {
          this.productionOutputForm.get('storageTanks').clearValidators();
          this.productionOutputForm.get('storageTanks').updateValueAndValidity();
        }
      },
      ({ error }: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }



  onClickParamterComparsionProcessControl(): void {
    this.range.reset();
    this.range.get('fromDate').setValue(new Date(this.processControlForm.value.datePicker.startDate));
    this.range.get('toDate').setValue(new Date(this.processControlForm.value.datePicker.endDate));

    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    this.Gridtype = 'processControl';
    const selectedRows = this.processGridApi
      .getSelectedRows()
      .filter((c: any) => c.DataType === 'Int' || c.DataType === 'Float');
    this.spinnerButtonOptions1.active = true;
    // tslint:disable-next-line:max-line-length
    this.dialog.open(this.visibleParameterComparison, {
      panelClass: 'custom-dialog-container',
      width: '100vw',
      height: '100vh',
      minWidth: '95vw',
      maxHeight: '100vh',
    });
    this.selectedParameters = selectedRows;
    this.selectedProducts = this.machineProducts;
    const array: any[] = [];
    const yAxisArr: any[] = [];
    const values = selectedRows
      .map((value: any) => value.parameterId)
      .toString();
    const valueNames = selectedRows.map((value: any) => value.Parameter);
    const seletedGroups = selectedRows.map(
      (value: any) => value.ParameterGroup
    );
    const uniqueGroups = [...new Set(seletedGroups)];
    const dataArrName: any[] = [];
    const key = {
      parameterId: values,
      groupType: this.processGroupType,
      products: this.machineProducts.map(c => c.Prod_Id).toString(),
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.show();
    this.processService.getParameterControlComparison(key).then(
      (data: any) => {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < valueNames.length; i++) {
          const dataArr = [];
          // tslint:disable-next-line:prefer-for-of
          for (let j = 0; j < data.length; j++) {
            // const arr = [];
            if (valueNames[i] === data[j].name) {
              dataArr.push({
                x: new Date(data[j].processTime).getTime(),
                y: isNaN(data[j].result) ? '' : parseFloat(data[j].result),
                label: data[j].product,
              });
            }
          }
          let negativeArr = [];
          negativeArr = dataArr.map((c) => c.y);
          const obj = {
            tooltip: {
              valueDecimals: 2,
            },
            name: valueNames[i],
            type: 'line',
            data: dataArr,
            color: this.highChartsColor[i],
            yAxis: i,
          };
          array.push(obj);
          yAxisArr.push({
            lineWidth: 1,
            opposite: negativeArr.some((v) => v < 0) ? true : false,
            title: {
              text: valueNames[i],
              style: {
                color: this.highChartsColor[i],
              },
            },
            labels: {
              style: {
                color: this.highChartsColor[i],
              },
            },
          });
        }
        this.chart = new StockChart({
          chart: {
            height: 730,
          },
          plotOptions: {
            series: {
              turboThreshold: 50000000,
              events: {
                hide(): any {
                  // this.yAxis.axisTitle.hide();
                  this.yAxis.update({
                    visible: false,
                  });
                },
                show(): any {
                  this.yAxis.update({
                    visible: true,
                  });
                },
              },
            },
          },
          rangeSelector: {
            inputEnabled: false,
            selected: 1,
          },
          title: {
            text: uniqueGroups.toString(),
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
          },
          tooltip: {
            formatter(): any {
              // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
              let s = '';
              this.points?.forEach((point: any) => {
                s +=
                  '<br/> <span style="color: ' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ' : ' +
                  point.y +
                  '<span><br/>' +
                  '<br/><span style="color: ' +
                  point.series.color +
                  '">Product : ' +
                  point.point.label +
                  '<span><br/>';
              });
              return s;
            },
          },
          yAxis: yAxisArr,
          series: array,
        });
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
    this.spinnerButtonOptions1.active = false;
  }
  onChangeParamterComparsionProcessControl(): void {
    this.spinnerButtonOptions1.active = true;
    // tslint:disable-next-line:max-line-length

    const selectedRows = this.selectedParameters;
    const array: any[] = [];
    const yAxisArr: any[] = [];
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    const values = selectedRows
      .map((value: any) => value.parameterId)
      .toString();
    const valueNames = selectedRows.map((value: any) => value.Parameter);
    const seletedGroups = selectedRows.map(
      (value: any) => value.ParameterGroup
    );
    const uniqueGroups = [...new Set(seletedGroups)];
    const dataArrName: any[] = [];
    const key = {
      parameterId: values,
      groupType: this.processGroupType,
      products: this.selectedProducts.map(c => c.Prod_Id).toString(),
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.show();
    this.processService.getParameterControlComparison(key).then(
      (data: any) => {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < valueNames.length; i++) {
          const dataArr = [];
          // tslint:disable-next-line:prefer-for-of
          for (let j = 0; j < data.length; j++) {
            // const arr = [];
            if (valueNames[i] === data[j].name) {
              dataArr.push({
                x: new Date(data[j].processTime).getTime(),
                y: isNaN(data[j].result) ? '' : parseFloat(data[j].result),
                label: data[j].product,
              });
            }
          }
          let negativeArr = [];
          negativeArr = dataArr.map((c) => c.y);
          const obj = {
            tooltip: {
              valueDecimals: 2,
            },
            name: valueNames[i],
            type: 'line',
            data: dataArr,
            color: this.highChartsColor[i],
            yAxis: i,
          };
          array.push(obj);
          yAxisArr.push({
            lineWidth: 1,
            opposite: negativeArr.some((v) => v < 0) ? true : false,
            title: {
              text: valueNames[i],
              style: {
                color: this.highChartsColor[i],
              },
            },
            labels: {
              style: {
                color: this.highChartsColor[i],
              },
            },
          });
        }
        this.chart = new StockChart({
          chart: {
            height: 730,
          },
          plotOptions: {
            series: {
              turboThreshold: 50000000,
              events: {
                hide(): any {
                  // this.yAxis.axisTitle.hide();
                  this.yAxis.update({
                    visible: false,
                  });
                },
                show(): any {
                  this.yAxis.update({
                    visible: true,
                  });
                },
              },
            },
          },
          rangeSelector: {
            inputEnabled: false,
            selected: 1,
          },
          title: {
            text: uniqueGroups.toString(),
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
          },
          tooltip: {
            formatter(): any {
              // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
              let s = '';
              this.points?.forEach((point: any) => {
                s +=
                  '<br/> <span style="color: ' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ' : ' +
                  point.y +
                  '<span><br/>' +
                  '<br/><span style="color: ' +
                  point.series.color +
                  '">Product : ' +
                  point.point.label +
                  '<span><br/>';
              });
              return s;
            },
          },
          yAxis: yAxisArr,
          series: array,
        });
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
    this.spinnerButtonOptions1.active = false;
  }
  saveBool(qualityBoolVal: any): void {
    const itemArr: any[] = [];
    let rowNode: any;
    if (this.isProcessGrid) {
      this.processGridApi.forEachLeafNode((node: any) => {
        itemArr.push(node);
      });
      const filterIndex: any = itemArr.filter(
        (c) => c.rowIndex === this.boolRowIndex
      );
      rowNode = this.processGridApi.getRowNode(filterIndex[0].id);
    } else {
      this.qualityGridApi.forEachLeafNode((node: any) => {
        itemArr.push(node);
      });
      const filterIndex: any = itemArr.filter(
        (c) => c.rowIndex === this.boolRowIndex
      );
      rowNode = this.qualityGridApi.getRowNode(filterIndex[0].id);
    }
    rowNode.setDataValue(this.boolColId, qualityBoolVal);
    this.dialog.closeAll();
  }
  reOpenQualityCalendar(): any {
    const self = this;
    setTimeout(() => {
      self.qualitypicker.open();
    }, 50);
  }
  reOpenProcessCalendar(): any {
    const self = this;
    setTimeout(() => {
      self.processpicker.open();
    }, 50);
  }
  processgridDate(event: any): void {
    const itemArr: any[] = [];
    this.processGridApi.forEachLeafNode((node: any) => {
      itemArr.push(node);
    });
    const filterIndex: any = itemArr.filter(
      (c) => c.rowIndex === this.boolRowIndex
    );
    const rowNode = this.processGridApi.getRowNode(filterIndex[0].id);
    rowNode.setDataValue(
      this.boolColId,
      moment(event.value).format('DD/MM/YYYY')
    );
  }
  qualitygridDate(event: any): void {
    const itemArr: any[] = [];
    this.qualityGridApi.forEachLeafNode((node: any) => {
      itemArr.push(node);
    });
    const filterIndex: any = itemArr.filter(
      (c) => c.rowIndex === this.boolRowIndex
    );
    const rowNode = this.qualityGridApi.getRowNode(filterIndex[0].id);
    rowNode.setDataValue(
      this.boolColId,
      moment(event.value).format('DD/MM/YYYY')
    );
  }
  onQualityControlGridReady(params: any): any {
    this.qualityGridApi = params.api;
    this.qualityGridColumnApi = params.columnApi;
    // this.qualityGridApi.sizeColumnsToFit();
  }
  onProcessGridReady(params: any): any {
    this.processGridApi = params.api;
    this.processGridColumnApi = params.columnApi;
    // Following line to make the currently visible columns fit the screen
    params.api.sizeColumnsToFit();

    // Following line dymanic set height to row on content
    params.api.resetRowHeights();
  }
  getParameterIntervalQualityControl(): void {
    const Key = {
      puId: this.unitId,
    };
    this.qualityParameterService.getQualityControlInterval(Key).subscribe(
      (response: any) => {
        this.qualityIntervalList = response;
        if (response.length > 0) {
          this.qualityControlForm
            .get('timeInterval')
            ?.setValue(this.qualityIntervalList[0]?.Interval);
          this.onToProcessDateQuanlityControl();
        }
      },
      (error: { message: any }) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  getQualityIntervalType(): void {
    const key = {
      puId: this.machineId,
    };
    this.processService.getQualityGroupEvents(key).subscribe(
      (data: any) => {
        this.QualityIntervalTypeDDL = data;
        this.qualityControlForm
          .get('eventType')
          ?.setValue(this.QualityIntervalTypeDDL[0]?.val);
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  qualityControlEventMode(): void {
    this.rowDataQualityControl = [];
    // tslint:disable-next-line:max-line-length
    this.qualityGroupType = this.qualityControlGroupTypeList.find(
      (c: any) =>
        c.parameterGroupTypeId === this.qualityControlForm.value.groupType
    )?.groupTypeName;
    if (this.qualityGroupType === 'Time') {
      this.getParameterIntervalQualityControl();
    } else if (this.qualityGroupType === 'Event') {
      this.qualityControlForm.get('eventType')?.setValue('Input');
      this.onToProcessDateQuanlityControl();
    } else if (this.qualityGroupType === 'Manual') {
      this.onToProcessDateQuanlityControl();
      this.getQualityParamterGroupList();
    }
    this.getQualityIntervalType();
  }

  GetQualityControlGroupTypeList(): any {
    const key = {
      puId: this.unitId,
    };
    this.qualityParameterService.getQualityGroupbyUnit(key).subscribe(
      (data: any) => {
        this.qualityControlGroupTypeList = data.filter(
          (c: any) => c.groupTypeName !== 'None'
        );
        this.qualityControlForm
          .get('groupType')
          ?.setValue(this.qualityControlGroupTypeList[0]?.parameterGroupTypeId);
        this.qualityControlEventMode();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  sendNotificationRole(descr: any, title: any): void {
    const key = {
      roleName: 'QC leader',
      egId: this.groupDataForm.value.group,
      createdBy: JSON.parse(localStorage.user).UserId,
      desc: descr,
      title
    };
    this.notificationService.addnotification(key).subscribe(
      (response: any) => {
        this.toaster.success('Notification Sent');
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
  }
  generateColumns(data: any[]): any {
    this.columnDefsProcessControl = [];
    let columnDefinitions: any[] = [];
    data.map((object) => {
      Object.keys(object).map((key) => {
        const mappedColumn = {
          headerName: key, // .toUpperCase()
          headerClass: {},
          headerTooltip: key,
          tooltipComponent: 'customTooltip',
          tooltipValueGetter,
          field: key,
          resizable: true,
          wrapText: true,
          rowGroup: key === 'ParameterGroup' ? true : false,
          width:
            key === 'DataType' || key === 'ParameterGroup'
              ? 150
              : key === 'Parameter'
                ? 300
                : 200,
          pinned:
            key === 'Parameter' ||
              key === 'DataType' ||
              key === 'ParameterGroup'
              ? 'left'
              : '',
          lockPinned:
            key === 'Parameter' ||
              key === 'DataType' ||
              key === 'ParameterGroup'
              ? true
              : false,
          cellStyle: {},
          hide: key === 'ParameterGroup' || key === 'DataType' ||
            key === 'IsCalculationRequired' ? true : false,
          filter: true,
          sortable: true,
          editable: false,
          valueParser: {},
          // tslint:disable-next-line:max-line-length
          valueGetter:
            key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'DataType' &&
              key !== 'parameterId' &&
               key !== 'IsCalculationRequired'
              ? this.abValueGetter
              : null,
          rowSelection: 'multiple',

          onCellClicked: (params: any) => {
            this.boolColId = params.column.colId;
            this.boolRowIndex = params.rowIndex;
             const cellElement = params.event.target;
            const bgColor =
              window.getComputedStyle(cellElement).backgroundColor;
            if (params.data.DataType === 'Bool') {
              params.colDef.cellEditor = 'agRichSelectCellEditor';
              this.GetAllDataTypesDetail(params.data.parameterId);
              this.isProcessGrid = true;
              this.selectionName = params.data.Parameter;
              if (mappedColumn.editable) {
                this.dialog.open(this.qualityBoolListModal, {
                  height: 'auto',
                  width: '45%',
                });
              }
            } else if (params.data.DataType === 'Date') {
              this.isProcessGrid = true;
              this.selectionName = params.data.Parameter;
              if (mappedColumn.editable) {
                this.reOpenProcessCalendar();
              }
            }  else {
                          if (params.data.IsCalculationRequired == false) {
                            if (bgColor == 'rgb(189, 204, 221)') {
                              params.colDef.editable = true;
                            } else {
                              params.colDef.editable = false;
                            }
                          } else {
                            if (
                              key !== 'ParameterGroup' &&
                              key !== 'Parameter' &&
                              key !== 'DataType'
                            ) {
                              this.toaster.warning(
                                CommonMessages.SFDC_CALCULATION_VARIABLE_MESSAGE
                              );
                            }
                            params.colDef.editable = false;
                          }
                          params.colDef.cellEditor = 'agTextCellEditor';
                        }
          },
          cellEditor: null,
          cellEditorParams:
            key !== 'Parameter' && key !== 'DataType'
              ? (params: any): Promise<any> => {
                return params.value;
              }
              : null,
        };
        if (this.processGroupType === 'Time') {
          mappedColumn.cellStyle = (params: any): any => {
            if (
              key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType' &&
              key !== 'parameterId' &&
              key !== 'IsCalculationRequired'
            ) {
              const fromDate = new Date(key.substring(0, 20));
              const toDate = new Date(key.substring(23, 43));
              // tslint:disable-next-line:max-line-length
              if (
                date.getTime() >= fromDate.getTime() &&
                date.getTime() <= toDate.getTime() + 1 * 60000 &&
                (key.split('~poStatus')[1].split('~')[0] === '' ||
                  key.split('~poStatus')[1].split('~')[0] === 'InProcess')
              ) {
                if (params?.data?.IsCalculationRequired === true) {
                  return {
                    'font-weight': 'bold',
                    color: params.value
                      ? params.data[params.colDef.field].split('|')[1]
                      : 'black',
                    //'background-color': 'orange',
                  };
                } else {
                  return {
                    'font-weight': 'bold',
                    color: params.value
                      ? params.data[params.colDef.field].split('|')[1]
                      : 'black',
                    'background-color': '#bdccdd',
                  };
                }
              } else {
                if (params.value) {
                  return {
                    color: params.data[params.colDef.field].split('|')[1],
                  };
                }
              }
            }
            if (key === 'Parameter') {
              // mappedColumn.cellStyle = (params: any) => {
              if (params?.data?.IsCalculationRequired === true) {
                return {
                  'font-weight': 'bold',
                  color: params.value ? params.value : 'black',
                  'background-color': 'orange',
                };
              }
              // };
            }
          };
          const date = new Date(new Date().setSeconds(0));
          if (
            key !== 'Parameter' &&
            key !== 'DataType' &&
            key !== 'parameterId' &&
            key !== 'ParameterGroup' &&
            key !== 'IsCalculationRequired'
          ) {
            const fromDate = new Date(key.substring(0, 20));
            const toDate = new Date(key.substring(23, 43));
            // tslint:disable-next-line:max-line-length
            if (
              date.getTime() >= fromDate.getTime() &&
              date.getTime() <= toDate.getTime() + 1 * 60000
              // key.split('~poStatus')[1] === 'InProcess'
            ) {
              if (
                key.split('~poStatus')[1].split('~')[0] === '' ||
                key.split('~poStatus')[1].split('~')[0] === 'InProcess'
              ) {
                mappedColumn.editable = true;
                mappedColumn.lockPinned = true;
                mappedColumn.pinned = 'left';
              } else {
                mappedColumn.editable = false;
              }
              mappedColumn.valueParser = (params: any) => {
                if (this.IsWrite) {
                  const dataType = params.data.DataType;
                  if (
                    dataType === 'Int' ||
                    dataType === 'Float' ||
                    dataType === 'String'
                  ) {
                    const newVal = params.newValue;
                    if (dataType === 'Int') {
                      const charcter = Number.isInteger(Number(newVal));
                      if (!charcter) {
                        this.toaster.warning(
                          'DigitsOnly',
                          'Please Select Digits Only'
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          params.oldValue
                        );
                        return params.oldValue;
                      } else {
                        params.newValue = parseInt(params.newValue, 10);
                      }
                    }
                    if (dataType === 'Float') {
                      const float = parseFloat(newVal);
                      // tslint:disable-next-line:use-isnan
                      if (isNaN(float)) {
                        this.toaster.warning(
                          'FloatOnly',
                          'Please Select Float Only'
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          params.oldValue
                        );
                        return params.oldValue;
                      } else {
                        params.newValue = parseFloat(params.newValue).toFixed(
                          2
                        );
                      }
                    }
                    const startIntervalDate = params.colDef.field.substring(
                      0,
                      20
                    );
                    const endIntervalDate = params.colDef.field.substring(
                      23,
                      43
                    );
                    if (new Date() > new Date(endIntervalDate)) {
                      this.toaster.warning(
                        'Time Passed',
                        'Slot time has been passed'
                      );
                      return;
                    }
                    let cellData: any;
                    if (!params.oldValue || params.oldValue === '') {
                      cellData = {
                        result: params.newValue,
                        entryOn: new Date(),
                        resultOn: endIntervalDate,
                        varId: params.data.parameterId,
                        isOldValue: false,
                        po: params.column.colId.split('~')[1],
                        createdBy: this.ActiveUserCode,
                        // tslint:disable-next-line:max-line-length
                        prodId:
                          params.column.colId.split('~prodId')[1] !== undefined
                            ? params.column.colId
                              .split('~prodId')[1]
                              .split('~')[0]
                            : '',
                        ppId:
                          params.column.colId.split('~ppId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppId')[1]
                              .split('~')[0]
                            : '',
                        uomId:
                          params.column.colId.split('~uomId')[1] !== undefined
                            ? params.column.colId
                              .split('~uomId')[1]
                              .split('~')[0]
                            : '',
                        ppdId:
                          params.column.colId.split('~ppdId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppdId')[1]
                              .split('~')[0]
                            : '',
                        intervalType: this.processGroupType,
                      };
                    } else {
                      cellData = {
                        result: params.newValue,
                        entryOn: new Date(),
                        resultOn: endIntervalDate,
                        varId: params.data.parameterId,
                        endInterval: endIntervalDate,
                        startInterval: startIntervalDate,
                        isOldValue: true,
                        po: params.column.colId.split('~')[1],
                        createdBy: this.ActiveUserCode,
                        // tslint:disable-next-line:max-line-length
                        prodId:
                          params.column.colId.split('~prodId')[1] !== undefined
                            ? params.column.colId
                              .split('~prodId')[1]
                              .split('~')[0]
                            : '',
                        ppId:
                          params.column.colId.split('~ppId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppId')[1]
                              .split('~')[0]
                            : '',
                        uomId:
                          params.column.colId.split('~uomId')[1] !== undefined
                            ? params.column.colId
                              .split('~uomId')[1]
                              .split('~')[0]
                            : '',
                        ppdId:
                          params.column.colId.split('~ppdId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppdId')[1]
                              .split('~')[0]
                            : '',
                        intervalType: this.processGroupType,
                      };
                    }
                    this.processService.saveProessControl(cellData).subscribe(
                      (response: any) => {
                        if (response.length && response[0]?.ncrId) {
                          this.onNCRCreate(response, params)

                        }
                        const msg = response[0].result;
                        if (msg !== null || msg !== '') {
                          if (msg.substring(2, 1) === '0') {
                            this.toaster.success(
                              'Success',
                              msg.substring(3, msg.length)
                            );
                            params.node.setDataValue(
                              params.colDef.field,
                              response[0].value
                            );
                            if (response[0].value) {
                              const color = response[0].value.split('|')[1];
                              if (color === '#ff2121') {
                                this.sendNotificationRole(
                                  `NCR ID - ${response[0].ncrId}
                                   Out of Specification Limits! The Defect had happened against ${params.column.colId.split('~')[1]
                                  }`,
                                  'Process Control'
                                );
                              }
                              if (color === '#ffff00') {
                                this.sendNotificationRole(
                                  `NCR ID - ${response[0].ncrId}
                                   Watch Out! There is a risk of defect happening against ${params.column.colId.split('~')[1]
                                  }`,
                                  'Process Control'
                                );
                              }
                            }
                          } else {
                            this.toaster.error(
                              'Error',
                              msg.substring(3, msg.length)
                            );
                            params.node.setDataValue(
                              params.colDef.field,
                              response[0].value
                            );
                          }
                        }
                      },
                      (error: any) => {
                        return this.toaster.error('Error', error.message);
                      }
                    );
                  }
                }
              };
            }
          }
          if (
            key !== 'Parameter' &&
            key !== 'parameterId' &&
            key !== 'DataType' &&
            key !== 'ParameterGroup' &&
            key !== 'IsCalculationRequired'
          ) {
            const fromDate = new Date(key.substring(0, 20));
            const toDate = new Date(key.substring(23, 43));
            mappedColumn.headerName =
              moment(fromDate).format('HH:mm:ss') +
              ' - ' +
              moment(toDate).format('HH:mm:ss') +
              ' - ' +
              key.split('~')[1] +
              ' - ' +
              key.split('~poStatus')[1].split('~')[0];

            let pcode = '';
            let po = '';
            let name = '';
            po = `PO  :  ${key.split('~')[1]}`;
            pcode = `Code  :  ${key.split('~')[2]}`;
            name = `Name  :  ${key.split('~prodDesc')[1] ? key.split('~prodDesc')[1].split('~')[0] : ''}`;
            mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;


          }
        }
        if (
          this.processGroupType === 'Event' ||
          this.processGroupType === 'Manual'
        ) {
          if (
            key !== 'Parameter' &&
            key !== 'ParameterGroup' &&
            key !== 'parameterId' &&
            key !== 'Cavity' &&
            key !== 'DataType' &&
            key !== 'IsCalculationRequired'
          ) {
            if (this.processGroupType === 'Event') {

              const fromDate = new Date(key.substring(0, 20));
              mappedColumn.headerName =
                moment(fromDate).format('YYYY-MM-DD HH:mm:ss') +
                ' - ' + `PO  :  ${key.split('~')[1]}`;

              let pcode = '';
              let po = '';
              let name = '';
              po = `PO  :  ${key.split('~')[1]}`;
              pcode = `Code  :  ${key.split('~')[2]}`;
              name = `Name  :  ${key.split('~prodDesc')[1] ? key.split('~prodDesc')[1].split('~')[0] : ''}`;
              mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;


            } else {

              const fromDate = new Date(key.substring(0, 20));
              mappedColumn.headerName =
                moment(fromDate).format('YYYY-MM-DD HH:mm:ss') +
                ' - ' + key.split('~')[1];

              let pcode = '';
              let po = '';
              let name = '';
              po = `PO  :  ${key.split('~')[1]}`;
              pcode = `Code  :  ${key.split('~')[2]}`;
              name = `Name  :  ${key.split('~prodDesc')[1] ? key.split('~prodDesc')[1].split('~')[0] : ''}`;
              mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;

            }
            mappedColumn.editable = true;
          }
          mappedColumn.cellStyle = (params: any): any => {
            if (
              key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType' &&
              key !== 'parameterId' &&
              key !== 'IsCalculationRequired'
            ) {
              // if (params.value) {
              if (params?.data?.IsCalculationRequired === true) {
                return {
                  'font-weight': 'bold',
                  color: params.value
                    ? params.data[params.colDef.field].split('|')[1]
                    : 'black',
                  //'background-color': 'orange',
                };
              } else {
                return {
                  'font-weight': 'bold',
                  color: params.value
                    ? params.data[params.colDef.field].split('|')[1]
                    : 'black',
                  'background-color': '#bdccdd',
                };
              }
              // }
            }
            if (key === 'Parameter') {
              if (params?.data?.IsCalculationRequired === true) {
                return {
                  'font-weight': 'bold',
                  color: params.value ? params.value : 'black',
                  'background-color': 'orange',
                };
              }
            }
          };
          mappedColumn.valueParser = (params: any) => {
            if (this.IsWrite) {
              const dataType = params.data.DataType;
              if (
                dataType === 'Int' ||
                dataType === 'Float' ||
                dataType === 'String'
              ) {
                const dataType = params.data.DataType;
                let newVal = params.newValue;
                if (dataType === 'Int') {
                  const charcter = Number.isInteger(Number(newVal));
                  if (!charcter) {
                    this.toaster.warning(
                      'DigitsOnly',
                      'Please Select Int Value Only'
                    );
                    // newVal = params.oldValue;
                    params.node.setDataValue(
                      params.colDef.field,
                      params.oldValue
                    );
                    return params.oldValue;
                  } else {
                    params.newValue = parseInt(params.newValue, 10);
                  }
                }
                if (dataType === 'Float') {
                  const float = parseFloat(newVal);
                  // tslint:disable-next-line:use-isnan
                  if (isNaN(float)) {
                    this.toaster.warning(
                      'FloatOnly',
                      'Please Select Float Only'
                    );
                    // newVal = params.oldValue;
                    params.node.setDataValue(
                      params.colDef.field,
                      params.oldValue
                    );
                    return params.oldValue;
                  } else {
                    params.newValue = parseFloat(params.newValue).toFixed(2);
                  }
                }
                if (dataType === 'Date') {
                  const date = params.newValue;
                  if (date.match(new RegExp('/', 'g')).length === 2) {
                  } else {
                    this.toaster.warning(
                      'SlashError',
                      'Please Select Correct Date Format'
                    );
                    return params.oldValue;
                  }
                }
                const startIntervalDate = params.colDef.field.substring(0, 20);

                let cellData: any;
                if (!params.oldValue || params.oldValue === '') {
                  cellData = {
                    result: params.newValue,
                    entryOn: new Date(),
                    resultOn: startIntervalDate,
                    endInterval: startIntervalDate,
                    startInterval: startIntervalDate,
                    varId: params.data.parameterId,
                    isOldValue: this.processGroupType !== 'Time' ? true : false,
                    po: params.column.colId.split('~')[1],
                    createdBy: this.ActiveUserCode,
                    intervalType: this.processGroupType,
                    prodId:
                      params.column.colId.split('~prodId')[1] !== undefined
                        ? params.column.colId.split('~prodId')[1].split('~')[0]
                        : '',
                    ppId:
                      params.column.colId.split('~ppId')[1] !== undefined
                        ? params.column.colId.split('~ppId')[1].split('~')[0]
                        : '',
                    uomId:
                      params.column.colId.split('~uomId')[1] !== undefined
                        ? params.column.colId.split('~uomId')[1].split('~')[0]
                        : '',
                    ppdId:
                      params.column.colId.split('~ppdId')[1] !== undefined
                        ? params.column.colId.split('~ppdId')[1].split('~')[0]
                        : '',
                  };
                } else {
                  cellData = {
                    result: params.newValue,
                    entryOn: new Date(),
                    resultOn: startIntervalDate,
                    varId: params.data.parameterId,
                    endInterval: startIntervalDate,
                    startInterval: startIntervalDate,
                    isOldValue: true,
                    po: params.column.colId.split('~')[1],
                    createdBy: this.ActiveUserCode,
                    intervalType: this.processGroupType,
                    prodId:
                      params.column.colId.split('~prodId')[1] !== undefined
                        ? params.column.colId.split('~prodId')[1].split('~')[0]
                        : '',
                    ppId:
                      params.column.colId.split('~ppId')[1] !== undefined
                        ? params.column.colId.split('~ppId')[1].split('~')[0]
                        : '',
                    uomId:
                      params.column.colId.split('~uomId')[1] !== undefined
                        ? params.column.colId.split('~uomId')[1].split('~')[0]
                        : '',
                    ppdId:
                      params.column.colId.split('~ppdId')[1] !== undefined
                        ? params.column.colId.split('~ppdId')[1].split('~')[0]
                        : '',
                  };
                }
                this.processService.saveProessControl(cellData).subscribe(
                  (response: any) => {

                    if (response.length && response[0]?.ncrId) {
                      this.onNCRCreate(response, params)

                    }
                    const msg = response[0].result;
                    if (msg !== null || msg !== '') {
                      if (msg.substring(2, 1) === '0') {
                        this.toaster.success(
                          'Success',
                          msg.substring(3, msg.length)
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          response[0].value
                        );
                        // params.node.setDataValue(params.colDef.field, newVal);
                      } else {
                        this.toaster.error(
                          'Error',
                          msg.substring(3, msg.length)
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          params.oldValue
                        );
                      }
                    }
                  },
                  (error: any) => {
                    return this.toaster.error('Error', error.message);
                  }
                );
                // }
              }
            }
          };
        }
        if (key === 'parameterId') {
          mappedColumn.hide = true;
        }
        columnDefinitions.push(mappedColumn);
      });
    });

    columnDefinitions = columnDefinitions.filter(
      (column, index, self) =>
        index ===
        self.findIndex((colAtIndex) => colAtIndex.field === column.field)
    );
    this.rowSelection = 'multiple';
    this.columns = [];
    const column = columnDefinitions;
    this.columns = column.filter(
      (c) => c.hide !== true
    );
    return columnDefinitions;
  }
  onToProcessDate(): any {
    this.processGridApi.showLoadingOverlay();
    const getdata = {
      fromDate: moment(
        this.processControlForm.value.datePicker.startDate
      ).utc(),
      toDate: moment(this.processControlForm.value.datePicker.endDate).utc(),
      puId: this.unitId,
      processType: 'PO',
      interval: this.processControlForm.value.timeInterval,
      currentDateTime: new Date(),
      intervalType:
        this.processGroupType === 'Time' || this.processGroupType === 'Manual'
          ? this.processGroupType
          : this.processControlForm.value.eventType,
      groupType: this.processGroupType,
    };
    if (
      getdata.puId === undefined ||
      !getdata.fromDate ||
      this.UnitName === ''
    ) {
      this.toaster.warning('Warning', 'Please Select Unit And Dates');
      this.spinner.hide();
      return;
    }

    if (!this.processGroupType) {
      return;
    }
    this.processGridApi.showLoadingOverlay();
    this.processService.getParameterProcessControl(getdata).then(
      (response: any) => {
        this.gridOptionsProcessControl.api.hideOverlay();
        const results: any = [];
        // tslint:disable-next-line:space-before-function-paren
        response.forEach(function (this: any, e: any): any {
          const a =
            e.parameterGroup +
            '|' +
            e.parameterName +
            '|' +
            e.parameterId +
            '|' +
            e.dataType;
          if (!this[a]) {
            this[a] = {
              ParameterGroup: e.parameterGroup,
             Parameter: e.IsCalculationRequired
                ? e.parameterName + ' ' + '(Calculation variable)'
                : e.parameterName,
              parameterId: e.parameterId,
              DataType: e.dataType,
              IsCalculationRequired: e.IsCalculationRequired,
            };
            results.push(this[a]);
          }
          if (e.dataType === 'Date' && e.value) {
            this[a][e.timInterval1] = moment(e.value, 'DD/MM/YYYY HH:mm').utc(e.value).local().format('DD/MM/YYYY HH:mm');
          } else {
            this[a][e.timInterval1] = e.value;
          }
        }, {});
        this.rowDataProcessControl2 = results;
        this.processGridApi.setRowData(results);
        // this.rowDataProcessControl = response;
        if (this.rowDataProcessControl2) {
          this.columnDefsProcessControl = this.generateColumns(
            this.rowDataProcessControl2
          );
          setTimeout(() => {
            this.gridOptionsProcessControl.api.columnController.resetColumnState();
            if (this.qualityGroupType === 'Time') {
              const scroll = document.querySelector(
                '#gridContainerProcessControl .ag-body-horizontal-scroll-viewport'
              );
              if (scroll !== null) {
                scroll.scrollLeft = scroll.scrollWidth;
              }
            }
          }, 100);
          if (this.processGroupType === 'Manual') {
            this.onProcessParameterGroupChange();
          }
        }
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  getParameterInterval(): void {
    const Key = {
      puId: this.unitId,
    };
    this.processService.getProcessControlInterval(Key).subscribe(
      (response: any) => {
        this.intervalList = response;
        if (response.length > 0) {
          this.processControlForm
            .get('timeInterval')
            ?.setValue(this.intervalList[0].Interval);
          this.onToProcessDate();
        }
      },
      (error: { message: any }) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }
  processparamaterdefects(params: any): void {
    const prodId =
      params.column.colId.split('~prodId')[1] !== undefined
        ? params.column.colId.split('~prodId')[1].split('~')[0]
        : '';
    const key = {
      paramId: params.node.data.parameterId,
      prodId,
    };
    this.processService.processparamaterdefects(key).subscribe(
      (response: any) => {
        this.parametrdefect = new MatTableDataSource<any>(response);
        // this.getPaginator();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  processControlDefect(params: any): void {
    this.displayProcssDefectModal = true;
    this.processparamaterdefects(params);
  }
  getContextMenuItemsProcessControl = (params: any) => {
    // const that = this;
    let result: any;
    if (this.IsWrite) {
      if (params.node.data.IsCalculationRequired === true) {
          result = [
            {
              name: 'Specifiction Limits',
              action: () => {
                // this.parameterId = params.node.data.parameterId;
                this.processControlSpecification(params);
              },
            },
            {
              name: 'Defect - Failure Mode Details',
              action: () => {
                // this.parameterId = params.node.data.parameterId;
                this.processControlDefect(params);
              },
            },
            {
              name: 'Manual Refresh Calculation Parameter',
              action: () => {
                this.onCalculationVariableClick(params);
              },
            },
          ];
        } else {
          result = [
            {
              name: 'Specifiction Limits',
              action: () => {
                // this.parameterId = params.node.data.parameterId;
                this.processControlSpecification(params);
              },
            },
            {
              name: 'Defect - Failure Mode Details',
              action: () => {
                // this.parameterId = params.node.data.parameterId;
                this.processControlDefect(params);
              },
            },
          ];
        }
    }
    return result;
  };

 onCalculationVariableClick(params: any): void {
    const startIntervalDate = params.column.colDef.field.substring(0, 20);
    const endIntervalDate = params.column.colDef.field.substring(23, 43);
    if (new Date() > new Date(endIntervalDate)) {
      this.toaster.warning('Time Passed', 'Slot time has been passed');
      return;
    }
    const cellData = {
      CreatedBy: this.ActiveUserCode,
      ResultOn:
        this.processGroupType === 'Time' ? endIntervalDate : startIntervalDate,
      VarId: params.node.data.parameterId,
      PO: params.column.colId.split('~')[1],
    };
    this.processService.saveCalculationVariableForVarId(cellData).subscribe(
      (response: any) => {
        this.showCVPopupMsg(response.Message);
        if (response.Data !== null || response.Data !== '') {
          params.node.setDataValue(params.column.colDef.field, response.Data);
        }
      },
      (error: any) => {
        this.showCVPopupMsg(error?.error?.Message);
      }
    );
  }

    showCVPopupMsg(msg: any): any {
    if (msg !== null || msg !== '') {
      if (msg.substring(2, 1) === '0') {
        this.toaster.success(msg.substring(3, msg.length));
      } else if (msg.substring(2, 1) === '2') {
        this.toaster.warning(msg.substring(3, msg.length));
      } else {
        this.toaster.error(msg.substring(3, msg.length));
      }
    }
  }

  expandprocess() {
    this.isCardExpanded = !this.isCardExpanded;
    this.Exdpandhide = false;
    this.Collapsehide = true;
  }
  closeprocess() {
    this.isCardExpanded = !this.isCardExpanded;
    this.Exdpandhide = true;
    this.Collapsehide = false;
  }
  expandquality() {
    this.isCardExpandedQuality = !this.isCardExpandedQuality;
    this.ExdpandhideQuality = false;
    this.CollapsehideQuality = true;
  }
  closequality() {
    this.isCardExpandedQuality = !this.isCardExpandedQuality;
    this.ExdpandhideQuality = true;
    this.CollapsehideQuality = false;
  }
  GetGroupTypeList(): any {
    const key = {
      puId: this.machineId,
    };
    this.qualityParameterService.getVariableGroupbyUnit(key).subscribe(
      (data: any) => {
        this.groupTypeList = data.filter(
          (c: any) => c.groupTypeName !== 'None'
        );
        if (this.groupTypeList.length) {
          this.processControlForm
            .get('groupType')
            ?.setValue(this.groupTypeList[0].parameterGroupTypeId);
          this.variableEventMode();
        }
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  GetStDuration(): void {
    const key = {
      PUId: this.groupDataForm.value.machine,
    };
    this.sfdService.GetStDuration(key).subscribe((res: any) => {
      this.masterList = res.masterList;
    });
  }
  GetTotalBatchForStaticTotal(): void {
    const key = {
      PPDID: 0,
      BatchTypeId: 3,
      BatchItemTypeId: 0,
      UserCode: this.ActiveUserCode,
    };
    this.sfdService.GetTotalBatch(key).subscribe((res: any) => {
      this.total1 = res.ErrorMessage;
    });
  }
  GetFaultByUnit(): void {
    const key = {
      PUId: this.machineId,
      UserCode: this.ActiveUserCode,
    };
    this.sfdService.GetFaultByUnit(key).subscribe((res: any) => {
      this.DTFaultList = res.FaultList;
      this.filteredDTFaultList = this.DTFaultList.slice();
      this.downTimeForm.get('fault')?.setValue(this.DTFaultList[0]?.FaultId);
      this.shortStopsForm.get('fault')?.setValue(this.FaultList[0]?.FaultId);
    });
  }
  getFoodSector() {
    const key = {
      Id: this.machineId,
    };
    this.sfdService.getFoodSector(key).subscribe(
      (res: any) => {
        this.isFoodSector = res.IsFoodSector;
        this.IsReworkRequired = res.IsReworkRequired;
        this.machineType = res?.MachineType;
        this.columnBatchHistory = [
          {
            headerName: '',
            cellRenderer: 'buttonEditRenderer',
            cellRendererParams: {
              onClick: this.onClickProductHistoryBatch.bind(this),
              label: 'Edit',
            },
            maxWidth: 70,
          },
          {
            headerName: 'Actions',
            cellRenderer: 'buttonViewRenderer',
            cellRendererParams: {
              onClick: this.onClickPopupViewForChecklistHistory.bind(this),
              label: 'View',
            },
            maxWidth: 85,
            suppressMenu: true,
          },
          {
            headerName: '',
            cellRenderer: 'buttonPrintRenderer',
            cellRendererParams: {
              onClick: this.onClickGetBarCodeDetails.bind(this),
              label: 'Print',
            },
            maxWidth: 70,
          },
          { headerName: 'Batch Consumption', field: 'IPBatchNo' },
          { headerName: 'Lotcode/Pallets', field: 'BatchNo' },
          { headerName: 'act', field: 'Result' },
          { headerName: 'remarks', field: 'Remarks' },
          {
            headerName: 'Time',
            field: 'RollStarttime',
            valueFormatter: function (params: any) {
              return moment(params.value).format('MM/DD/YYYY HH:mm');
            },
          },
          {
            headerName: 'Created On', field: 'CreatedOn', valueFormatter: function (params: any) {
              return moment(params.value).format('MM/DD/YYYY HH:mm');
            }
          },
          { headerName: 'Created By', field: 'CreatedBy' },
          {
            headerName: 'Storage Tank',
            field: 'StorageTank',
            hide: !this.machineType
          },

        ];
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  selectedunit = '';

  SelectUnitName(): void {
    this.getAssembly();
    this.resetMeeting();
    this.GetProcessOrderList();
    this.downTimeStarted = false;
    this.machineId = this.groupDataForm.value.machine;
    this.unitId = this.groupDataForm.value.machine;
    const machineName = this.Machines.find(
      (c) => c.unitId === this.machineId
    ).unitDesc;
    this.machineName = machineName;
    if (machineName !== null) {
      this.hideBtn = false;
      // this.machineId = unitname.PrimaryId;
      this.displayMAchineModal = false;
      this.startTime = new Date();
      this.getDefectMgmtTableData();
    }
    this.statusPo = ' ';
    this.StatusColor = '';
    this.showButtons = true;
    this.onlymachineSelectProperty = true;
    this.itemCode = 'Item Code: undefined';
    this.productionOutputForm.get('actQty')?.reset();
    this.productionOutputForm.get('remarks')?.reset();
    if (this.isAuto === false) {
      this.productionOutputForm.get('pallet')?.reset();
    }
    this.groupDataForm.get('processOrder')?.reset();
    this.groupDataForm.get('operationName')?.reset();
    this.groupDataForm.get('productDetail')?.reset();
    this.groupDataForm.get('remarks')?.reset();
    this.materialConsumptionForm.get('qty')?.reset();
    this.total = 'Total: ';
    this.total1 = 'Total: ';
    this.targetQty = '';
    // this.GetLableBatch1(unitname);
    this.centerLineDataSource = new MatTableDataSource<any>([]);
    this.getPaginator(this.centerLineDataSource, 0);
    this.materialConsumptionDataSource = new MatTableDataSource<any>([]);
    this.HistoryBatchDataSource1 = new MatTableDataSource<any>([]);
    this.machineSelectProperty = false;
    this.ItemTypeList = [];
    this.FaultList = [];
    this.getMachineProducts();
    this.getNCRWorkFlow();
    this.getOeeDashboard();
    this.refreshMainScreenForm();
    this.GetJbDowntimeHistory();
    this.GetJbDowntimeHistory1();
    this.GetJbBatchHistory();
    this.GetJbBatchHistory1();
    this.GetCrewScheduleList();
    this.GetGroupTypeList();
    this.GetIsShiftStart();
    this.GetLableBatchForWaste();
    this.GetStDuration();
    this.GetFaultByUnit();
    this.GetSTFault();
    this.GetWasteFaultByUnit();
    this.GetBatchCheckListByUnit();
    this.getAllQualityCheckList();
    this.getFoodSector();
    this.GetLastShiftInfoWithoutModel();
    this.buttonThemeAfterSelectUnit();
    this.disableSFDCbuttons = false;
    this.selectedunit = '(' + machineName + ')';
  }

  getNCRWorkFlow(): void {
    const screenName = 'NCR';
    const key = {
      screenName,
      tenantId: this.plantId,
      companyKey: Constants.COMPANY_KEY,
    };
    this.workFlowService.getWorkFlow(key).subscribe(
      (response) => {
        this.ncrWorkFlow = response;
        this.getWorkFlowTransitions();
      },
      ({ error }) => {
        this.spinner.hide();
      }
    );
  }

  getWorkFlowTransitions() {
    this.workFlowService
      .getWorkflowStatuses(this.ncrWorkFlow.workFlowKey)
      .subscribe(
        (response: any) => {
          this.transitions = response;
        },
        (err: any) => {
        }
      );
  }

  onQualityControlRefresh(): void {
    const selected2 = {
      startDate: this.qualityControlForm.value.datePicker.startDate,
      endDate: new Date(),
    };
    this.qualityControlForm.get('datePicker')?.setValue(selected2);
    if (this.qualityControlResumeInterval) {
      this.qualityControlForm.get('toProcessDate')?.setValue(new Date());
      this.onToProcessDateQuanlityControl();
    }
  }
  getPath(model: any, id: any): any {
    let path;
    const item = model;

    if (!model || typeof model !== 'object') {
      return;
    }

    if (model.id === id) {
      return [item];
    }

    (model.children || []).some(
      (child: any) => (path = this.getPath(child, id))
    );
    return path && [item, ...path];
  }

  refreshMainScreenForm(): void {
    this.poprocessOrder = '';
    this.itemCodePo = null;
    this.itemDescPo = null;
    this.poprocessOrder = '';
    this.SFDC_OEE = '';
    this.SFDC_Availability = '';
    this.SFDC_TotalProducedQTy = 0;
    this.SFDC_TotalGoodPieces = 0;
    this.targetQty = '';
    this.remainingQty = 0;
    this.SFDC_Performance = '';
    this.SFDC_Quality = '';
    this.SFDC_Totalwaste = '';
    this.SFDC_TotalDowntime = 0;
    this.SFDC_TotalAverageSpeed = '';
    this.calculatedremainingtime = '0min(s)';
    this.calculatedremainingtime = '';
    let Startinput = <HTMLInputElement>document.querySelector('#startbtn');
    let Pauseinput = <HTMLInputElement>document.querySelector('#pausebtn');
    let Closeinput = <HTMLInputElement>document.querySelector('#closebtn');
    Pauseinput.style.backgroundColor = '#dddddd';
    Startinput.style.backgroundColor = '#dddddd';
    // Closeinput.style.backgroundColor = '#dddddd';
  }
  getParameterCavity(): void {
    const Key = {
      puId: this.unitId,
    };
    this.qualityParameterService.getMaxCavity(Key).subscribe(
      (response: any) => {
        this.maxCavity = response.cavity;
        this.groupDataForm.get('processType')?.setValue(response.processType);
        const val = response.cavity;
        const arr: any[] = [];
        for (let index = 0; index < val; index++) {
          arr.push({ value: index + 1 });
        }
        this.cavityList = arr;
        this.showCavity = this.cavityList.length > 1 ? true : false;
      },
      (error: { message: any }) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }



  onChange(result: Date): void { }


  ReturnHome(IdMenu: any): any {
    this.urll = 'home';
    localStorage.setItem('O3RightMenuId', IdMenu);
    const href = window.location.href;
    this.urll = href.split('/')[0] + '/home';
    window.location.href = this.urll;
  }



  GetLableBatchForWaste(): void {
    const key = {
      BatchTypeId: 0,
      UserCode: this.ActiveUserCode,
      PUID: this.machineId,
      TypeId: 3,
    };
    this.sfdService.GetLableBatch(key).subscribe((res: any) => {
      this.resultWaste = res.Result;
      this.name = res.Name;
      this.columnWasteHistry.forEach(function (colDef, index) {
        if (colDef.headerName === 'qty') {
          colDef.headerName = res.Result;
        }
        if (colDef.headerName === 'mode') {
          colDef.headerName = res.Name;
        }
      });
    });
  }
  timerflag: boolean = false;
  applyTheme() {
    const downTimer = document.querySelector('#downTimer');
    downTimer?.classList.add('bgColor');
    downTimer?.classList.remove('RemovebgColor');
    const downTimerPrevious = document.querySelector('#downTimerPrevious');
    downTimerPrevious?.classList.add('bgColor');
    downTimerPrevious?.classList.remove('RemovebgColor');
    const timer_blinks = document.querySelector('#timer_blinks');
    timer_blinks?.classList.add('timer_number');
    timer_blinks?.classList.remove('stop_timer_number');
  }
  timerInterval(): void {
    this.rxjsTimer.pipe(takeUntil(this.destroy)).subscribe((val) => {
      this.seconds = this.seconds + 1;
      this.timer =
        ('0' + this.hours).slice(-2) +
        ':' +
        ('0' + this.minutes).slice(-2) +
        ':' +
        ('0' + this.seconds).slice(-2);

      if (this.seconds === 60) {
        this.minutes = this.minutes + 1;
        this.seconds = 0;
      }
      if (this.minutes === 60) {
        this.hours = this.hours + 1;
        this.minutes = 0;
        this.seconds = 0;
      }
    });
  }
  removeTheme() {
    const downTimer = document.querySelector('#downTimer');
    downTimer?.classList.remove('bgColor');
    downTimer?.classList.add('RemovebgColor');
    const downTimerPrevious = document.querySelector('#downTimerPrevious');
    downTimerPrevious?.classList.remove('bgColor');
    const timer_blinks = document.querySelector('#timer_blinks');
    timer_blinks?.classList.remove('timer_number');
    timer_blinks?.classList.add('stop_timer_number');
  }
  startDownTime(): any {
    this.fromStartButton = true;
    if (this.downTimeStarted === true) {
      this.toaster.error('already timer started');
    } else {
      this.SaveJBDowntimeInfo2();
      this.downTimeStarted = true;
    }
  }
  stopDownTime(): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to Stop the timer Right Now!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Stop it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        this.meetingEndTime = new Date();
        this.dialog.open(this.faultmodal, {
          disableClose: true,
          width: '100vw !important',
          height: 'auto',
          minWidth: '100vw',
        });
        this.JbDowntimeHistoryList.forEach((elem) => {
          if (elem.EndTime === null) {
            this.JobDownTimeId = elem.JobDownTimeId;
            this.downTimeForm.get('startDate')?.setValue(elem.StartTime);
            this.downTimeForm.get('fault')?.setValue(elem.FaultId);
            this.downTimeForm.get('endDate')?.setValue(new Date());
          }
        });
      }
    });
    return;
  }
  start(): void {
    const key = {
      PPDId: this.PPID,
      UserCode: this.ActiveUserCode,
      PPSID: this.statusList.find((c) => c.TypeName === 'InProcess').TypeId,
    };
    this.sfdService.SumbitProcessOrderStatus(key).subscribe((res: any) => {
      if (this.machineSelectProperty === true) {
        this.statusPo = this.statusList.find(
          (c) => c.TypeName === 'InProcess'
        ).TypeName;
        this.StatusColor = '#10ce9c';
        this.resetMeeting();
        this.startbutton = true;
        this.pausebutton = false;
        this.closebutton = false;

        this.GetJbDowntimeHistory1();
        this.GetJbDowntimeHistory();
        var Startinput = <HTMLInputElement>document.querySelector('#startbtn');
        var Pauseinput = <HTMLInputElement>document.querySelector('#pausebtn');
        var Closeinput = <HTMLInputElement>document.querySelector('#closebtn');
        Pauseinput.style.backgroundColor = '#65CE9D';
        Startinput.style.backgroundColor = '#dddddd';
        Closeinput.style.backgroundColor = '#65CE9D';
        this.GetProcessOrderList();
        this.showPopupMsg(res.ErrorMessage);
      } else {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('PoListSelection')
        );
      }
    });
  }

  pause(): any {
    const key = {
      PPDId: this.PPID,
      UserCode: this.ActiveUserCode,
      PPSID: this.statusList.find((c) => c.TypeName === 'Pause').TypeId,
    };
    this.sfdService.SumbitProcessOrderStatus(key).subscribe((res: any) => {
      if (this.machineSelectProperty === true) {
        this.statusPo = this.statusList.find(
          (c) => c.TypeName === 'Pause'
        ).TypeName;
        this.StatusColor = 'rgb(255, 255, 0)';
        this.startbutton = false;
        this.pausebutton = true;
        this.closebutton = false;
        this.GetJbDowntimeHistory1();
        this.GetJbDowntimeHistory();
        var Startinput = <HTMLInputElement>document.querySelector('#startbtn');
        var Pauseinput = <HTMLInputElement>document.querySelector('#pausebtn');
        var Closeinput = <HTMLInputElement>document.querySelector('#closebtn');
        Pauseinput.style.backgroundColor = '#dddddd';
        Startinput.style.backgroundColor = '#65CE9D';
        if (this.IsWrite) {
          Closeinput.style.backgroundColor = '#65CE9D';
        }
        this.GetProcessOrderList();
        this.showPopupMsg(res.ErrorMessage);
      } else {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('PoListSelection')
        );
      }
    });
  }
  groupDataMode = true;
  SumbitProcessOrderStatus(): void {
    this.groupDataMode = true;

    const key = {
      PPDId: this.PPID,
      UserCode: this.ActiveUserCode,
      PPSID: this.groupDataForm.get('status')?.value,
    };
    this.sfdService.SumbitProcessOrderStatus(key).subscribe((res: any) => {
      if (this.machineSelectProperty === true) {
        this.GetProcessOrderList();
        this.showPopupMsg(res.ErrorMessage);
      } else {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('PoListSelection')
        );
      }
    });
  }
  close() {
    const key = {
      PPDId: this.PPID,
      UserCode: this.ActiveUserCode,
      PPSID: this.statusList.find((c) => c.TypeName === 'Complete').TypeId,
    };
    this.sfdService.SumbitProcessOrderStatus(key).subscribe((res: any) => {
      if (this.machineSelectProperty === true) {
        this.statusPo = this.statusList.find(
          (c) => c.TypeName === 'Complete'
        ).TypeName;
        this.startbutton = true;
        this.pausebutton = true;
        this.closebutton = true;
        this.GetJbDowntimeHistory1();
        this.GetJbDowntimeHistory();
        var Startinput = <HTMLInputElement>document.querySelector('#startbtn');
        var Pauseinput = <HTMLInputElement>document.querySelector('#pausebtn');
        var Closeinput = <HTMLInputElement>document.querySelector('#closebtn');
        Pauseinput.style.backgroundColor = '#dddddd';
        Startinput.style.backgroundColor = '#dddddd';
        if (this.IsWrite) {
          Closeinput.style.backgroundColor = '#dddddd';
        }
        this.GetProcessOrderList();
        this.showPopupMsg(res.ErrorMessage);
      } else {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('PoListSelection')
        );
      }
    });
  }
  resetMeeting(): void {
    this.removeTheme();
    const wrapper1 = document.querySelector('#timer');
    wrapper1?.classList.add('hide-timer');
    wrapper1?.classList.remove('show-timer');
    clearInterval(this.interval);
    this.timer = '00:00:00';
    this.hours = 0;
    this.minutes = 0;
    this.seconds = 0;
    this.meetingStartTime = undefined;
    this.meetingEndTime = undefined;
  }
  onClickDowntimeHistory(params: any): void {
    const col = params.colDef.field;

    this.ButtonType = '';

    if (col === 'Actions') {
      this.ButtonType = params.event.target.classList[1];
      this.editDownTime(params.data);
    }
  }

  onClickWasteHistory(data: any): void {
    this.editWasteHistory(data.data);
  }
  onClickProductHistoryBatch(data: any): void {
    this.editProductionHistoryBatch(data.data);
  }
  onClickEditMaterialConsumptionBatch(data: any): void {
    this.editMaterialConsumptionHistoryBatch(data.data);
  }
  onClickEditFoodSectorMaterial(data: any): void {
    this.editFoodSectorMaterial(data.data);
  }
  onClickPopupViewForMaterialHistory(data: any): void {
    this.openPopupViewForMaterialHistory(data.data);
  }
  openPopupViewForMaterialHistory(element: any): void {
    this.dialog.open(this.materialViewModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.getBatchItemBOMInfo(element, '');
  }

  onClickGetBarCodeDetails(data: any): void {
    this.GetBarCodeDetails(data.data);
  }
  editFoodSectorMaterial(element: any) {
    this.JobBatchMaterialId = element.JobBatchId;
    this.spinner.show();
    const key = {
      Ishistory: false,
      PPDId: this.PPID,
      JobBatchId: element.JobBatchId,
    };
    this.sfdService.getBatchItemBOMList(key).subscribe(
      (res: any) => {
        this.materialFoodSectorConsumptionForm
          .get('mActQtys')
          ?.setValue(element.Result);
        this.materialFoodSectorConsumptionForm
          .get('mlotCode')
          ?.setValue(element.BatchNo);
        this.materialFoodSectorConsumptionForm
          .get('mTime')
          ?.setValue(element.RollStarttime);
        this.materialFoodSectorConsumptionForm
          .get('remarks')
          ?.setValue(element.Remarks);
        this.materialFoodSectorConsumptionForm
          .get('isRework')
          ?.setValue(element.IsRework);
        this.getBatchItemBOMInfo(element, 'edit');
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }
  getBatchItemBOMInfo(element: any, actionType: string) {
    if (actionType === 'edit') {
      const key = {
        PUId: this.machineId,
        JobBatchId: element.JobBatchId,
      };
      this.sfdService.getBatchItemBOMInfo(key).subscribe(
        (res: any) => {
          this.ItemBOMList = res.batchItemBOMList;
          this.ItemBOMList?.data?.forEach((x: any, index) => {
            const calculatedValue = (x?.ItemBOMValue / x.MinSkuUnit);
            this.ItemBOMList.data[index].calculatedValue = isNaN(calculatedValue) ? 0 : calculatedValue.toFixed(2);

            const valueDrums = (x?.ItemBOMValue / x.MinSkuUnit);
            this.ItemBOMList.data[index].ItemBOMValueDrums = isNaN(valueDrums) ? 0 : valueDrums.toFixed(2);
          });
          let obj = this.ItemBOMList?.data.find((item) => item.ItemBOMDetailId);
          if (obj?.supplierList?.length > 0) {
            let findObj = obj.supplierList.find((item: any) => item.supplierName === obj.Supplier);
            this.indexMaterial = obj.supplierList.indexOf(findObj);
            this.ItemBOMList.data.find((item) => item.ItemBOMDetailId === findObj.ItemBOMDetailId).supplierList[this.indexMaterial].supplierName = obj.Supplier;
            this.ItemBOMList.data.find((item) => item.ItemBOMDetailId === findObj.ItemBOMDetailId).supplierList[this.indexMaterial].NOBags = obj.NOBags;
            this.ItemBOMList.data.find((item) => item.ItemBOMDetailId === findObj.ItemBOMDetailId).supplierList[this.indexMaterial].BagperWeight = obj.BagperWeight;
            this.ItemBOMList.data.find((item) => item.ItemBOMDetailId === findObj.ItemBOMDetailId).supplierList[this.indexMaterial].totalWeight = obj.totalWeight;

          }
        },
        (error: any) => {
          this.toaster.error(
            this.translate.instant('Error'),
            this.translate.instant('WentWrong')
          );
        }
      );
      this.dialog.closeAll();
    } else {
      const key = {
        PUId: this.machineId,
        JobBatchId: element.JobBatchId,
      };
      this.sfdService.getBatchItemBOMInfo(key).subscribe(
        (res: any) => {
          this.ItemBOMViewList = res.batchItemBOMList;
          this.ItemBOMViewList?.forEach((x: any, index) => {
            if (true) {
              this.ItemBOMViewList[index].NoOfDrums = x?.ItemBOMValue ? x.MinSkuUnit ? (x?.ItemBOMValue / x.MinSkuUnit)?.toFixed(2) : 0 : 0;
            }
            else {
              this.ItemBOMViewList[index].NoOfDrums = 0;
            }
          });
        },
        (error: any) => {
          this.toaster.error(
            this.translate.instant('Error'),
            this.translate.instant('WentWrong')
          );
        }
      );
    }
  }

  GetItemTypeByUnit(element: any): void {
    this.spinner.show();
    const key = {
      PUId: this.machineId,
      BatchTypeId: 1,
      PPId: this.PPID,
      UserId: this.ActiveUserCode,
    };
    this.sfdService.GetItemTypeByUnit(key).subscribe((res: any) => {
      this.spinner.hide();
      this.ItemTypeList = res.ItemTypeList;
      this.materialConsumptionForm
        .get('materialDate')
        ?.setValue(this.ItemTypeList[0]?.BatchItemTypeId);
      this.itemCode = this.ItemTypeList.find(
        (x: any) => x.BatchItemTypeId === this.ItemTypeList[0]?.BatchItemTypeId
      )?.ItemCode;
      this.JobBatchItemTypeId = this.materialConsumptionForm.value.materialDate;
      const code = { value: this.ItemTypeList[0]?.BatchItemTypeId };
      this.GetLableBatch(code);
      this.GetJbBatchHistory();
      this.GetJbBatchHistory1();
      this.GetTotalBatch();
    });
  }
  downtime: string = '';
  selectedOption: number = 0;
  index: number = 0;

  selectHistoryProcessOrdersForSelectionChange(element: any): void {
    const wrapper1 = document.querySelector('#timer');
    wrapper1?.classList.add('hide-timer');
    wrapper1?.classList.remove('show-timer');
    this.groupDataForm.get('Unit')?.reset();
    this.groupDataForm.get('status')?.reset();
    this.materialConsumptionForm.get('materialDate')?.reset();
    this.materialConsumptionForm.get('qty')?.reset();
    this.wasteForm.get('categoryType')?.reset();
    this.downTimeForm.get('fault')?.reset();
    this.shortStopsForm.get('fault')?.reset();
    this.shortStopsForm.get('duration')?.reset();
    this.productionOutputForm.get('pallet')?.reset();
    this.ItemTypeList = [];
    this.FaultList = [];
    this.DTFaultList = [];
    this.GTList = [];
    this.filteredDTFaultList = [];
    this.filteredGTList = [];
    this.masterList = [];
    this.showButtons = false;
    this.showShiftClose = false;
    this.onlymachineSelectProperty = false;
    this.machineSelectProperty = false;
    this.productionOutputDataSource = new MatTableDataSource<any>([]);
    this.selectHistoryProcessOrders(element);
    this.resetMeeting();
    const index = this.groups.findIndex((x) => x.TypeId === element.value);
    this.downtime = '(' + this.groups[index].TypeName + ')';
  }
  getItemBomListInfo() {
    this.materialFoodSectorConsumptionForm.get('remarks')?.reset();
    this.JobBatchMaterialId = '';
    const key = {
      IsRework: this.isRework,
      PPDId: this.PPID,
    };
    this.sfdService.getItemBomListInfo(key).subscribe(
      (res: any) => {
        this.ItemBOMList = res.ItemBOMList;
        this.materialFoodSectorConsumptionForm
          .get('mActQtys')
          ?.setValue(res.Qty);
        this.materialFoodSectorConsumptionForm
          .get('mlotCode')
          ?.setValue(res.Lotcode);
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  getFoodSectorMaterialConsumptionList() {
    const key = {
      Ishistory: false,
      PPDId: this.PPID,
    };
    this.sfdService.getBatchItemBOMList(key).subscribe(
      (res: any) => {
        this.batchItemBOMList = res.BatchItemBOMList;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  GetLableBatch1(element: any): void {
    const key = {
      PPDID: 0,
      BatchTypeId: this.PPID,
      UserCode: this.ActiveUserCode,
      PUID: this.machineId,
      TypeId: 2,
    };
    this.sfdService.GetLableBatch(key).subscribe((res: any) => {
      this.productionOutputForm.get('time')?.setValue(new Date());
      this.targetQty = res.Qty;
      this.remainingQty =
        (this.targetQty as number) - (this.SFDC_TotalGoodPieces as number) ||
        0;
      this.Result = '(' + res.Result + ')';
    });
  }
  GetStatus(): void {
    const key = {};
    this.sfdService.GetStatus(key).subscribe((res: any) => {
      this.statusList = res.masterList;
    });
  }
  buttonThemeAfterSelectUnit() {
    var materialbtn = <HTMLInputElement>(
      document.querySelector('#MaterialConsumption')
    );
    var PObtn = <HTMLInputElement>document.querySelector('#ProductionOutput');
    var wastebtn = <HTMLInputElement>document.querySelector('#Waste');
    var processbtn = <HTMLInputElement>(
      document.querySelector('#ProcessControl')
    );
    var qualitybtn = <HTMLInputElement>(
      document.querySelector('#QualityControl')
    );
    var downtinebtn = <HTMLInputElement>(
      document.querySelector('#downTimerPrevious')
    );
    var checklistbtn = <HTMLInputElement>(
      document.querySelector('#ChecklistExecution')
    );
    materialbtn.style.backgroundColor = '#1F01FF';
    PObtn.style.backgroundColor = '#312AF8';
    wastebtn.style.backgroundColor = '#524CFD';
    processbtn.style.backgroundColor = 'rgb(55 51 157)';
    qualitybtn.style.backgroundColor = 'rgb(93 89 201)';
    downtinebtn.style.backgroundColor = 'rgb(84 79 211)';
    checklistbtn.style.backgroundColor = 'rgb(126 124 233)';
  }

  initialTheme() {
    var Startinput = <HTMLInputElement>document.querySelector('#startbtn');
    var Pauseinput = <HTMLInputElement>document.querySelector('#pausebtn');
    var Closeinput = <HTMLInputElement>document.querySelector('#closebtn');
    var materialbtn = <HTMLInputElement>(
      document.querySelector('#MaterialConsumption')
    );
    var PObtn = <HTMLInputElement>document.querySelector('#ProductionOutput');
    var wastebtn = <HTMLInputElement>document.querySelector('#Waste');
    var processbtn = <HTMLInputElement>(
      document.querySelector('#ProcessControl')
    );
    var qualitybtn = <HTMLInputElement>(
      document.querySelector('#QualityControl')
    );
    var downtinebtn = <HTMLInputElement>(
      document.querySelector('#downTimerPrevious')
    );
    var checklistbtn = <HTMLInputElement>(
      document.querySelector('#ChecklistExecution')
    );
    Pauseinput.style.backgroundColor = '#dddddd';
    Startinput.style.backgroundColor = '#dddddd';
    if (this.IsWrite) {
      Closeinput.style.backgroundColor = '#dddddd';
    }
    materialbtn.style.backgroundColor = '#dddddd';
    PObtn.style.backgroundColor = '#dddddd';
    wastebtn.style.backgroundColor = '#dddddd';
    processbtn.style.backgroundColor = '#dddddd';
    qualitybtn.style.backgroundColor = '#dddddd';
    downtinebtn.style.backgroundColor = '#dddddd';
    checklistbtn.style.backgroundColor = '#dddddd';
  }
  StatusChangeBTN(element: any) {
    if (element.OperStatus === 'Ready To Start') {
      var Startinput = <HTMLInputElement>document.querySelector('#startbtn');
      var Pauseinput = <HTMLInputElement>document.querySelector('#pausebtn');
      var Closeinput = <HTMLInputElement>document.querySelector('#closebtn');
      this.startbutton = false;
      this.pausebutton = true;
      if (this.IsWrite) {
        this.closebutton = true;
      }

      Pauseinput.style.backgroundColor = '#dddddd';
      Startinput.style.backgroundColor = '#65CE9D';
      if (this.IsWrite) {
        Closeinput.style.backgroundColor = '#dddddd';
      }
    }
    if (element.OperStatus == 'InProcess') {
      var Startinput = <HTMLInputElement>document.querySelector('#startbtn');
      var Pauseinput = <HTMLInputElement>document.querySelector('#pausebtn');
      var Closeinput = <HTMLInputElement>document.querySelector('#closebtn');
      Pauseinput.style.backgroundColor = '#65CE9D';
      Startinput.style.backgroundColor = '#dddddd';
      if (this.IsWrite) {
        Closeinput.style.backgroundColor = '#65CE9D';
      }

      this.startbutton = true;
      this.pausebutton = false;
      if (this.IsWrite) {
        this.closebutton = false;
      }
    }
    if (element.OperStatus == 'Complete') {
      var Startinput = <HTMLInputElement>document.querySelector('#startbtn');
      var Pauseinput = <HTMLInputElement>document.querySelector('#pausebtn');
      var Closeinput = <HTMLInputElement>document.querySelector('#closebtn');
      Pauseinput.style.backgroundColor = '#dddddd';
      Startinput.style.backgroundColor = '#dddddd';
      if (this.IsWrite) {
        Closeinput.style.backgroundColor = '#dddddd';
      }

      this.startbutton = true;
      this.pausebutton = true;
      if (this.IsWrite) {
        this.closebutton = true;
      }
    }
    if (element.OperStatus == 'Close') {
      var Startinput = <HTMLInputElement>document.querySelector('#startbtn');
      var Pauseinput = <HTMLInputElement>document.querySelector('#pausebtn');
      var Closeinput = <HTMLInputElement>document.querySelector('#closebtn');
      this.startbutton = true;
      this.pausebutton = true;
      if (this.IsWrite) {
        this.closebutton = true;
      }

      Pauseinput.style.backgroundColor = '#dddddd';
      Startinput.style.backgroundColor = '#dddddd';
      if (this.IsWrite) {
        Closeinput.style.backgroundColor = '#dddddd';
      }
    }
    if (element.OperStatus == 'Pause') {
      var Startinput = <HTMLInputElement>document.querySelector('#startbtn');
      var Pauseinput = <HTMLInputElement>document.querySelector('#pausebtn');
      var Closeinput = <HTMLInputElement>document.querySelector('#closebtn');
      Pauseinput.style.backgroundColor = '#dddddd';
      Startinput.style.backgroundColor = '#65CE9D';
      Closeinput.style.backgroundColor = '#65CE9D';
      this.startbutton = false;
      this.pausebutton = true;
      if (this.IsWrite) {
        this.closebutton = false;
      }
    }
  }
  selectHistoryProcessOrders(element: any): void {
    this.filteredbatchConsumptionList = [];
    this.spinner.show();
    if (element.OperStatus === 'InProcess') {
      this.StatusColor = '#65CE9D';
    } else if (element.OperStatus === 'Pause') {
      this.StatusColor = 'rgb(255, 255, 0)';
    } else if (element.OperStatus === 'Complete') {
      this.StatusColor = '#0000FF';
    }
    this.poStartDate = element.CreatedOn;
    this.dialog.closeAll();
    this.GetShiftCloseValidation();
    this.centerLineDataSource = new MatTableDataSource<any>([]);
    this.getPaginator(this.centerLineDataSource, 0);
    this.materialConsumptionDataSource = new MatTableDataSource<any>([]);
    this.HistoryBatchDataSource1 = new MatTableDataSource<any>([]);
    this.wasteDataSource1 = new MatTableDataSource<any>([]);
    this.downtimeDataSource = new MatTableDataSource<any>([]);
    this.total = 'Total: ';
    this.total1 = 'Total: ';
    this.totalWaste = 'Total: ';
    this.targetQty = 0;
    this.itemCode = 'ProdCode: ';
    this.groupDataForm.get('Id')?.setValue(element.PPDId);
    this.poprocessOrder = element.PO;
    this.groupDataForm.get('operationName')?.setValue(element.Oper);
    this.groupDataForm.get('productDetail')?.setValue(element.ProductDetail);
    this.PDtooltip = element.ProductDetail;
    this.itemCodePo = element.ItemCode;
    this.itemDescPo = element.ItemDesc;
    this.IDtooltip = element.ItemDesc;
    this.groupDataForm.get('remarks')?.setValue(element.Remarks);
    this.groupDataForm
      .get('status')
      ?.setValue(
        this.statusList.find((c) => c.TypeName === element.OperStatus)?.TypeId
      );
    this.statusPo = this.statusList.find(
      (c) => c.TypeName === element.OperStatus
    )?.TypeName;
    this.StatusChangeBTN(element);
    const input = document.querySelector('#input');
    input?.classList.remove('effect');
    input?.classList.add('disableEffect');
    this.PPID = element.PPDId;
    this.PPS_ID = element.PPS_Id;
    this.GetKpiParamInfoList(element);
    this.GetItemTypeByUnit(element);
    this.getChangeStartTime(element);
    this.GetStatus();
    this.GetTotalWaste();
    this.GetLableBatch1(element);
    this.GetJbWasteHistory();
    this.GetJbDowntimeHistory1();
    this.GetJbDowntimeHistory();
    this.getTanksByMachine();
    this.getMinutes(element);
    this.GetLatestLotCode();
    this.GetTotalBatch1();
    this.LastInstOPjobBatch();
    this.getItemBomListInfo();
    this.getFoodSectorMaterialConsumptionList();
    this.getBatchConsumption();
    this.wasteButtonShow = true;
    this.showMaterialButtons = true;
    this.machineSelectProperty = true;
  }

  async GetAllQualityParameterIntervals(): Promise<void> {
    const key = {
      puId: this.MachineId,
    };
    this.qualityParameterService
      .GetAllQualityParameterIntervals(key)
      .subscribe((res: any) => {
        if (res.length !== 0) {
          this.intervalId = res[0].intervalId;
          this.changeIntervalMode = false;
          if (
            res[0].intervalStartDate !== '' &&
            res[0].intervalEndDate !== ''
          ) {
            const startInterval = this.toDateWithOutTimeZone(
              res[0].intervalStartDate
            );
            const endInterval = new Date(
              new Date(
                this.toDateWithOutTimeZone(res[0].intervalStartDate)
              ).getTime() +
              60 * 60 * 24 * 1000
            );
            this.startInterval = startInterval;
            this.endInterval = endInterval;
            this.groupDataForm.get('fromProcessDate')?.setValue(startInterval);
            this.groupDataForm.get('toProcessDate')?.setValue(endInterval);
          }
        } else {
          this.changeIntervalMode = true;
          this.isIntervalSaveMode = true;
          this.changeStartParameterInterval('');
          this.changeEndParameterInterval('');
          this.toDateWithOutTimeZone('');
        }
      });
  }

  toDateWithOutTimeZone(date: any): any {
    const tempTime = date.split(':');
    const dt = new Date();
    dt.setHours(tempTime[0]);
    dt.setMinutes(tempTime[1]);
    dt.setSeconds(tempTime[2]);
    return dt;
  }

  // start interval event change
  changeStartParameterInterval(event: any): void {
    this.startInterval = event;
  }

  // end interval event change
  changeEndParameterInterval(event: any): void {
    this.endInterval = event;
  }
  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }
  selectHistory(data: any): void {
    this.POType = data.data?.POType;
    this.ProductId = data.data?.ProductId;
    if (data?.data?.OperStatus == 'Ready To Start' ||
      data?.data?.OperStatus == 'Pause') {
      this.isChangeOverCheckListShow = true;
    }
    else {
      this.isChangeOverCheckListShow = false;
    }
    this.selectHistoryProcessOrders(data.data);
    this.GetAllQualityParameterIntervals();
  }
  getProcessIntervalType(): void {
    const key = {
      puId: this.machineId,
    };
    this.processService.getVariableGroupEvents(key).subscribe(
      (data: any) => {
        this.processIntervalTypeDDL = data;
        this.processControlForm
          .get('eventType')
          ?.setValue(this.processIntervalTypeDDL[0].val);
        this.onToProcessDate();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  variableEventMode(): void {
    this.rowDataProcessControl = [];
    this.processGroupType = this.groupTypeList.find(
      (c: any) =>
        c.parameterGroupTypeId === this.processControlForm.value.groupType
    )?.groupTypeName;
    if (this.processGroupType === 'Time') {
      this.getParameterInterval();
    } else if (this.processGroupType === 'Event') {
      this.getProcessIntervalType();
    } else if (this.processGroupType === 'Manual') {
      this.onToProcessDate();
      this.getProcessParamterGroupList();
    }
  }

  onProcessControlRefresh(): void {
    if (this.processControlForm.valid && this.processControlResumeInterval) {
      this.rowDataProcessControl = [];
      const selected = {
        startDate: this.processControlForm.value.datePicker.startDate,
        endDate: new Date(),
      };
      this.processControlForm.get('datePicker')?.setValue(selected);
      this.onToProcessDate();
    }
  }
  onQualityIntervalChange(): void {
    this.onToProcessDateQuanlityControl();
  }

  getCurrentProcessOrder(val: any): void {
    const data = {
      puId: this.machineId,
    };
    this.qualityParameterService.getCurrentProcessOrder(data).subscribe(
      (response) => {
        if (response.length) {
          this.currentprocessOrder = response[0].ProcessOrder;
          this.PPID = response[0].PPD_Id;
          this.manualInput(val);
        } else {
          this.currentprocessOrder = null;
          this.PPID = null;
          this.manualInput(val);
        }
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  manualInput(val: any): void {
    this.spinner.show();
    const data = {
      plantId: this.groupDataForm.value.plant,
      lotcode: null,
      eventDateTime: new Date(),
      eventTypeId: 3,
      puId: this.machineId,
      processOrder: this.currentprocessOrder,
      processOrderId: this.PPID,
      type: val
    };
    this.sfdService.insertSfdcEvent(data).then(
      (response) => {
        this.toaster.success(
          this.translate.instant('Success'),
          this.translate.instant('ManualInput') +
          ' ' +
          this.translate.instant('Event') +
          ' ' +
          this.translate.instant('AddedSuccessfully')
        );
        if (val === 'process') {
          this.onProcessControlRefresh();
        } else {
          this.onQualityControlRefresh();
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  qualityProcessOrderProcessControl = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginatorProcessControl!: MatPaginator;

  onClickControlProcessOrderProcessControl(): any {
    const key = {
      fromDate: this.processControlForm.value.datePicker.startDate,
      toDate: this.processControlForm.value.datePicker.endDate,
      puId: this.unitId,
      processType: this.processControlForm.value.processType,
    };
    this.spinnerButtonOptionsOrders.active = true;
    this.processService
      .getQualityControlProcessOrder(key)
      .subscribe((response: any) => {
        this.dialog.open(this.displayQualityOrdersModal, {
          height: 'auto',
          width: '90%',
        });
        this.qualityProcessOrderProcessControl.data = response;
        this.qualityProcessOrder.data = response;
      });
    this.spinnerButtonOptionsOrders.active = false;
  }

  // C1-Result Time Should Not Be More Than Current Time!"

  manualOutPut(): void {
    const data = {
      plantId: this.groupDataForm.value.plant,
      lotcode: null,
      eventDateTime: new Date(),
      eventTypeId: 4,
      puId: this.machineId,
      processOrder: this.groupDataForm.get('processOrder')?.value,
      processOrderId: this.PPID,
    };
    this.sfdService.insertSfdcEvent(data).then(
      (response) => {
        this.toaster.success(
          this.translate.instant('Success'),
          this.translate.instant('ManualOutPut') +
          ' ' +
          this.translate.instant('Event') +
          ' ' +
          this.translate.instant('AddedSuccessfully')
        );
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }
  openQualitySpecification(params: any): void {
    this.displayQualitySpecificationModal = true;
    const podata = params.column.colId.split('~')[1];
    this.paramterSpcecificationName = params.node.data.Parameter;
    const key = {
      processOrder: podata,
      paramterId: params.node.data.parameterId,
      prodId:
        params.column.colId.split('~prodId')[1] !== undefined
          ? params.column.colId.split('~prodId')[1].split('~')[0]
          : '',
    };
    this.getParameterSpecifications(key);
  }
  getParameterSpecifications(key: any): void {
    this.qualityParameterService.getParameterSpecifications(key).subscribe(
      (response: any) => {
        this.parameterspecifications.data = response;
        this.chartSpecifications = response;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  openQualityDefecct(params: any): void {
    this.displayQualityDefectModal = true;
    this.qualityparamaterdefects(params);
  }
  qualityparamaterdefects(params: any): void {
    const prodId =
      params.column.colId.split('~prodId')[1] !== undefined
        ? params.column.colId.split('~prodId')[1].split('~')[0]
        : '';
    const key = {
      paramId: params.node.data.parameterId,
      prodId,
    };
    this.qualityParameterService.qualityparamaterdefects(key).subscribe(
      (response: any) => {
        this.parametrdefect = new MatTableDataSource<any>(response);
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  openQc(params: any): void {
    this.qcParamsSlot = params.column.userProvidedColDef.headerName;
    this.qcStartTimeSlot = params.column.userProvidedColDef.field.substring(
      0,
      20
    );
    if (this.qualityGroupType === 'Time') {
      this.qcEndTimeSlot = params.column.userProvidedColDef.field.substring(
        23,
        43
      );
    } else {
      this.qcEndTimeSlot = params.column.userProvidedColDef.field.substring(
        0,
        20
      );
    }
    this.qcheadertooltip = params.column.userProvidedColDef.headerTooltip;
    this.qcProcessorderNo = params.column.colId.split('~')[1];
    this.qcProdCode = params.column.colId.split('~')[3];
    this.qcProcdDesc = params.column.colId.split('~')[2];
    const qcTableArr: any[] = [];
    const dateCol = params.column.colId;

    params.api.forEachLeafNode((node: any) => {
      qcTableArr.push({
        parameter: node.data.Parameter,
        value: node.data[dateCol]
          ? node.data[dateCol].split('|')[0]
          : node.data[dateCol],
        parameterId: node.data.parameterId,
        sample: node.data.Cavity,
        verificationStatus: 'Approve',
        remarks: node.data.remarks,
      });
    });
    this.qcdataSource.data = qcTableArr;

    // global array empty
    this.detailArray = [];
    // for verified
    this.qcdataSource.data.forEach(
      (ele: {
        parameter: any;
        parameterId: any;
        sample: any;
        value: any;
        verificationStatus: any[];
        remarks: any;
      }) => {
        const obj = {
          parameter: ele.parameter,
          parameterId: ele.parameterId,
          sample: ele.sample,
          value: ele.value,
          verificationStatus: ele.verificationStatus
            ? ele.verificationStatus
            : 'Approve',
          remarks: ele.remarks ? ele.remarks : '',
        };
        this.detailArray.push(obj);
      }
    );
    // get qc verified data
    const key = {
      startTime: this.qcStartTimeSlot,
      endTime: this.qcEndTimeSlot,
      puId: this.unitId,
    };
    this.qualityParameterService
      .GetQCVerifyDetail(key)
      .subscribe((res: any) => {
        this.verifyCheckedArray = res;
        const mergeArray = this.detailArray.map((element: any) => {
          const tableArray = this.verifyCheckedArray.find(
            (x: any) => x.paramterId === element.parameterId
          );
          return { ...element, ...tableArray };
        });
        this.qcdataSource.data = mergeArray;
      });
    // modal open
    this.dialog.open(this.displayQCModal, { height: '90%', width: '90%' });
  }
  getContextMenuItems = (params: any) => {
    // const that = this;
    let result: any;
    if (this.qualityGroupType === 'Time') {
      const key = params.column.colId;
      const date = new Date(new Date().setSeconds(0));
      const fromDate = new Date(key.substring(0, 20));
      const toDate = new Date(key.substring(23, 43));
      const array = JSON.parse(localStorage.roleName).map((v: any) =>
        v.toLowerCase()
      );
      this.qcRole = array.includes('qc leader') === true ? true : false;
      if (
        this.IsWrite &&
        this.qcRole &&
        date.getTime() >= fromDate.getTime() &&
        date.getTime() <= toDate.getTime() + 1 * 60000 &&
        key.split('~poStatus')[1].split('~')[0] === 'InProcess'
        ||
        key.split('~poStatus')[1].split('~')[0] === ''
      ) {
        result = [
          {
            name: 'Specifiction Limits',
            action: () => {
              this.openQualitySpecification(params);
            },
          },
          {
            name: 'Defect - Failure Mode Details',
            action: () => {
              this.openQualityDefecct(params);
            },
          },
          {
            name: 'QC Verify',
            action: () => {
              this.openQc(params);
            },
          },
        ];
      } else {
        result = [
          {
            name: 'Specifiction Limits',
            action: () => {
              this.openQualitySpecification(params);
            },
          },
          {
            name: 'Defect - Failure Mode Details',
            action: () => {
              this.openQualityDefecct(params);
            },
          },
        ];
      }
    } else {
      result = [
        {
          name: 'Specifiction Limits',
          action: () => {
            this.openQualitySpecification(params);
          },
        },
        {
          name: 'Defect - Failure Mode Details',
          action: () => {
            this.openQualityDefecct(params);
          },
        },
        {
          name: 'QC Verify',
          action: () => {
            this.openQc(params);
          },
        },
      ];
    }
    return result;
  };

  SFDC_PerformanceList: any = [];
  SFDC_PerformanceList1: any = [];

  GetShiftCloseValidation(): void {
    const key = {
      // Id: this.Shift
      CrewId: this.crewId,
    };
    this.PerformanceDataSource = new MatTableDataSource<any>(
      []
    );
    this.qualityDataSource = new MatTableDataSource<any>([]);
    this.shiftDataSource = new MatTableDataSource<any>();
    this.availabilityDataSource = new MatTableDataSource<any>([]);
    this.sfdService.GetShiftCloseValidation(key).subscribe((res: any) => {
      this.availabilityDataSource = new MatTableDataSource<any>(
        res.AvailabilityList
      );
      this.PerformanceDataSource = new MatTableDataSource<any>(
        res.PerformanceList
      );
      this.SFDC_PerformanceList1 = res.PerformanceList;
      this.qualityDataSource = new MatTableDataSource<any>(res.QualityList);
      this.SFDC_PerformanceList = res.QualityList;
      this.shiftDataSource = new MatTableDataSource<any>(res.ValidationList);
      this.shiftactionDataSource =
        new MatTableDataSource<ShiftCloseInterface>();
    });
  }
  openshiftcloseModal(): void {
    this.dialog.open(this.displayshiftcloseRoleModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.GetShiftCloseValidation();
  }
  getSorting(data: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      if (data) {
        data.sort = this.sort.toArray()[index];
      }
    }, 1000);
  }
  GetProcessOrderList(): void {
    const key = {
      PUId: this.groupDataForm.value.machine,
      PPDId: 0,
      UserCode: this.ActiveUserCode?.toString(),
    };
    this.spinner.show();
    this.sfdService.GetProcessOrderList(key).subscribe((res: any) => {
      const namesToRemove = ["Pending", "Scheduled"];
      this.rowData = res.ProcessOrderList.filter(c => !namesToRemove.includes(c.OperStatus));
      const data = res.ProcessOrderList.find(x => x.OperStatus === 'InProcess');
      if (data) {
        const obj = {
          data: data
        }
        this.selectHistory(obj);
      }
      this.spinner.hide();
      this.getPaginator(this.poListDataSource, 2);
      this.getSorting(this.poListDataSource, 9);
    });
  }
  openPoModal(): void {
    this.dialog.open(this.displayPoModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
  }
  colorCode(value: any): any {
    let colorCode = '';
    if (Math.round(value) > 0 && Math.round(value) <= 20) {
      return (colorCode = '#FF0000');
    } else if (Math.round(value) > 20 && Math.round(value) <= 50) {
      return (colorCode = '#ffff00');
    } else if (Math.round(value) > 50 && Math.round(value) <= 70) {
      return (colorCode = '#ffa500');
    } else if (Math.round(value) > 70) {
      return (colorCode = '#008000');
    } else if (Math.round(value) === 0) {
      return (colorCode = '');
    }
  }

  GetLastShiftInfoWithoutModel(): void {
    const key = {
      Id: this.machineId,
    };
    this.spinner.show();
    this.OEEInfoList = [];
    this.sfdService.GetLastShiftInfo(key).subscribe((res: any) => {
      this.masterList = res.ShiftInfoList;
      this.OEEInfoList = res.OEEInfoList;
      const array = res.OEEInfoList;
      this.DowntimeInfoList = res.DowntimeInfoList;
      this.lastShiftDataSource = new MatTableDataSource<any>(res.masterList);
      this.spinner.hide();

      this.getPaginator(this.lastShiftDataSource, 3);

      array.forEach((element1: any) => {
        let colorCode = '';
        if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 0 &&
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) <= 20
        ) {
          colorCode = '#FF0000';
        } else if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 20 &&
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) <= 50
        ) {
          colorCode = '#ffff00';
        } else if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 50 &&
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) <= 70
        ) {
          colorCode = '#ffa500';
        } else if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 70
        ) {
          colorCode = '#008000';
        }
        element1.OEE = element1.OEE.toFixed(2);
        element1.Availability = element1.Availability.toFixed(2);
        element1.Performance = element1.Performance.toFixed(2);
        element1.Quality = element1.Quality.toFixed(2);
        this.showLastShiftProperty = element1.OEE > 0 ? true : false;
        element1.capacityUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.OEE),
          secondColor: '#E5E5E5',
          progress: element1.OEE > 0 ? Math.round(element1.OEE) : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
        element1.availabilityUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.Availability),
          secondColor: '#E5E5E5',
          progress:
            element1.Availability > 0
              ? Math.round(element1.Availability)
              : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
        element1.performanceUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.Performance),
          secondColor: '#E5E5E5',
          progress:
            element1.Performance > 0 ? Math.round(element1.Performance) : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
        element1.qualityUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.Quality),
          secondColor: '#E5E5E5',
          progress: element1.Quality > 0 ? Math.round(element1.Quality) : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
      });

      if (res.ShiftInfoList.length > 0) {
        this.UserName = res.ShiftInfoList[0].UserName;
        this.Shift = res.ShiftInfoList[0].Shift;
        this.ShiftStart = moment(this.masterList[0].ShiftStart).format(
          'YYYY-MM-DD HH:mm'
        );
        this.ShiftEnd = moment(this.masterList[0].ShiftEnd).format(
          'YYYY-MM-DD HH:mm'
        );
        this.Supervisor = this.masterList[0].Supervisor;
        this.OEEInfoList = array;
        this.showMode = true;
      } else {
        this.UserName = '';
        this.Shift = '';
        this.ShiftStart = '';
        this.ShiftEnd = '';
        this.Supervisor = '';
        this.OEEInfoList = array;
        this.showMode = true;
      }

      // DownTime Chart
      this.canvas = document.getElementById('downTimeChart');
      if (this.canvas) {
        this.canvas.height = 300;
        this.canvas.width = 530;
      }

      this.ctx = this.canvas?.getContext('2d');
      const faultArray: any[] = [];
      const durationArray: any[] = [];
      res.DowntimeInfoList.forEach((element: any) => {
        faultArray.push(element.Fault);
      });
      res.DowntimeInfoList.forEach((element: any) => {
        durationArray.push(element.Duration);
      });
      if (this.ctx) {
        const downtime = new Chart(this.ctx, {
          type: 'horizontalBar',
          data: {
            labels: faultArray,
            datasets: [
              {
                data: durationArray,
                label: 'Down Time (Mins)',
                backgroundColor: '#040496',
              },
            ],
          },
          options: {
            responsive: false,
            maintainAspectRatio: false,
            title: { display: true, text: 'Percentage' },
            tooltips: {
              callbacks: {
                label: (tooltipItem: any, data: any) => {
                  return data.datasets[0].data[tooltipItem.index] + '%';
                },
              },
            },
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                padding: 20,
              },
            },
            scales: {
              xAxes: [
                {
                  stacked: true,
                  gridLines: {
                    display: false,
                  },
                },
              ],
              yAxes: [
                {
                  stacked: true,
                  gridLines: {
                    borderDash: [8, 4],
                  },
                  ticks: {
                    beginAtZero: true,
                    stepSize: 10,
                    min: 0,
                    max: 80,
                    callback(value: any, index: any): any {
                      if (value === 0) {
                        return 0 + '%';
                      } else {
                        return value + '%';
                      }
                    },
                  },
                },
              ],
            },
          },
        });
      }

      // Weight Chart
      this.canvas = document.getElementById('weightChart');
      if (this.canvas) {
        this.canvas.height = 300;
        this.canvas.width = 530;
      }
      this.ctx = this.canvas?.getContext('2d');
      const pcsFaultArray: any[] = [];
      const amountArray: any[] = [];
      res.WasteInfoList.forEach((element: any) => {
        pcsFaultArray.push(element.Fault);
      });
      res.WasteInfoList.forEach((element: any) => {
        amountArray.push(element.Amount);
      });
      if (this.ctx) {
        const weight = new Chart(this.ctx, {
          type: 'horizontalBar',
          data: {
            labels: pcsFaultArray,
            datasets: [
              { data: amountArray, label: 'Pcs', backgroundColor: '#040496' },
            ],
          },
          options: {
            responsive: false,
            maintainAspectRatio: false,
            title: { display: true, text: 'Percentage' },
            tooltips: {
              callbacks: {
                label: (tooltipItem: any, data: any) => {
                  return data.datasets[0].data[tooltipItem.index] + '%';
                },
              },
            },
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                padding: 20,
              },
            },
            scales: {
              xAxes: [
                {
                  stacked: true,
                  gridLines: {
                    display: false,
                  },
                },
              ],
              yAxes: [
                {
                  stacked: true,
                  gridLines: {
                    borderDash: [8, 4],
                  },
                  ticks: {
                    beginAtZero: true,
                    stepSize: 20,
                    min: 0,
                    max: 120,
                    callback(value: any, index: any): any {
                      if (value === 0) {
                        return 0 + '%';
                      } else {
                        return value + '%';
                      }
                    },
                  },
                },
              ],
            },
          },
        });
      }
    });
  }

  GetLastShiftInfo(element: any): void {
    this.dialog.open(this.lastshiftModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    const key = {
      Id: this.machineId, // 1
    };
    this.spinner.show();
    this.sfdService.GetLastShiftInfo(key).subscribe((res: any) => {
      this.masterList = res.ShiftInfoList;
      this.OEEInfoList = res.OEEInfoList;
      const array = res.OEEInfoList;
      this.DowntimeInfoList = res.DowntimeInfoList;
      this.lastShiftDataSource = new MatTableDataSource<any>(res.masterList);
      this.spinner.hide();

      this.getPaginator(this.lastShiftDataSource, 3);

      array.forEach((element1: any) => {
        let colorCode = '';
        if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 0 &&
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) <= 20
        ) {
          colorCode = '#FF0000';
        } else if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 20 &&
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) <= 50
        ) {
          colorCode = '#ffff00';
        } else if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 50 &&
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) <= 70
        ) {
          colorCode = '#ffa500';
        } else if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 70
        ) {
          colorCode = '#008000';
        }
        element1.OEE = element1.OEE.toFixed(2);
        element1.Availability = element1.Availability.toFixed(2);
        element1.Performance = element1.Performance.toFixed(2);
        element1.Quality = element1.Quality.toFixed(2);
        this.showLastShiftProperty = element1.OEE > 0 ? true : false;
        element1.capacityUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.OEE),
          secondColor: '#E5E5E5',
          progress: element1.OEE > 0 ? Math.round(element1.OEE) : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
        element1.availabilityUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.Availability),
          secondColor: '#E5E5E5',
          progress:
            element1.Availability > 0
              ? Math.round(element1.Availability)
              : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
        element1.performanceUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.Performance),
          secondColor: '#E5E5E5',
          progress:
            element1.Performance > 0 ? Math.round(element1.Performance) : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
        element1.qualityUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.Quality),
          secondColor: '#E5E5E5',
          progress: element1.Quality > 0 ? Math.round(element1.Quality) : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
      });

      if (res.ShiftInfoList.length > 0) {
        this.UserName = res.ShiftInfoList[0].UserName;
        this.Shift = res.ShiftInfoList[0].Shift;
        this.ShiftStart = moment(this.masterList[0].ShiftStart).format(
          'YYYY-MM-DD HH:mm'
        );
        this.ShiftEnd = moment(this.masterList[0].ShiftEnd).format(
          'YYYY-MM-DD HH:mm'
        );
        this.Supervisor = this.masterList[0].Supervisor;
        this.OEEInfoList = array;
        this.showMode = true;
      } else {
        this.UserName = '';
        this.Shift = '';
        this.ShiftStart = '';
        this.ShiftEnd = '';
        this.Supervisor = '';
        this.OEEInfoList = array;
        this.showMode = true;
      }

      // DownTime Chart
      this.canvas = document.getElementById('downTimeChart');
      this.canvas.height = 300;
      this.canvas.width = 530;
      this.ctx = this.canvas.getContext('2d');
      const faultArray: any[] = [];
      const durationArray: any[] = [];
      res.DowntimeInfoList.forEach((element: any) => {
        faultArray.push(element.Fault);
      });
      res.DowntimeInfoList.forEach((element: any) => {
        durationArray.push(element.Duration);
      });
      const downtime = new Chart(this.ctx, {
        type: 'horizontalBar',
        data: {
          labels: faultArray,
          datasets: [
            {
              data: durationArray,
              label: 'Down Time (Mins)',
              backgroundColor: '#040496',
            },
          ],
        },
        options: {
          responsive: false,
          maintainAspectRatio: false,
            title: { display: true, text: 'Percentage' },
          tooltips: {
            callbacks: {
              label: (tooltipItem: any, data: any) => {
                return data.datasets[0].data[tooltipItem.index] + '%';
              },
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              padding: 20,
            },
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                stacked: true,
                gridLines: {
                  borderDash: [8, 4],
                },
                ticks: {
                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 80,
                  callback(value: any, index: any): any {
                    if (value === 0) {
                      return 0 + '%';
                    } else {
                      return value + '%';
                    }
                  },
                },
              },
            ],
          },
        },
      });

      // Weight Chart
      this.canvas = document.getElementById('weightChart');
      this.canvas.height = 300;
      this.canvas.width = 530;
      this.ctx = this.canvas.getContext('2d');
      const pcsFaultArray: any[] = [];
      const amountArray: any[] = [];
      res.WasteInfoList.forEach((element: any) => {
        pcsFaultArray.push(element.Fault);
      });
      res.WasteInfoList.forEach((element: any) => {
        amountArray.push(element.Amount);
      });
      const weight = new Chart(this.ctx, {
        type: 'horizontalBar',
        data: {
          labels: pcsFaultArray,
          datasets: [
            { data: amountArray, label: 'Pcs', backgroundColor: '#040496' },
          ],
        },
        options: {
          responsive: false,
          maintainAspectRatio: false,
            title: { display: true, text: 'Percentage' },
          tooltips: {
            callbacks: {
              label: (tooltipItem: any, data: any) => {
                return data.datasets[0].data[tooltipItem.index] + '%';
              },
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              padding: 20,
            },
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                stacked: true,
                gridLines: {
                  borderDash: [8, 4],
                },
                ticks: {
                  beginAtZero: true,
                  stepSize: 20,
                  min: 0,
                  max: 120,
                  callback(value: any, index: any): any {
                    if (value === 0) {
                      return 0 + '%';
                    } else {
                      return value + '%';
                    }
                  },
                },
              },
            ],
          },
        },
      });
    });
  }
  sizeToFit() {
    this.gridOptionsProcessControl.api.sizeColumnsToFit();
  }
  gridOptionsProcessControl: any = {
    suppressFieldDotNotation: true,
    defaultColDef: {
      flex: 1,
      resizable: true,
      sortable: true,
      wrapText: true,
      autoHeight: true,
      minWidth: 200,
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    groupDefaultExpanded: 1,
    popupParent: document.querySelector('body'),
    frameworkComponents: {
      customTooltip: CustomTooltip,
      primeCellEditor: PrimeCellEditorComponent,
      btnCellRendererActualEntry: BtnCellRendererActualEntry,
      btnCellRenderer: BtnCellRenderer,
    },
  };

  onCellValueChanged(params: any): void {
    if (this.IsWrite) {
      const dataType = params.data.DataType;
      if (dataType === 'Date' || dataType === 'Bool') {
        if (dataType === 'Date') {
          const date = params.value;
          if (date.match(new RegExp('/', 'g')).length === 2) {
          } else {
            this.toaster.warning(
              'SlashError',
              'Please Select Correct Date Format'
            );
            return params.oldValue;
          }
        }
        const startIntervalDate = params.colDef.field.substring(0, 20);
        const endIntervalDate = params.colDef.field.substring(23, 43);
        if (this.processGroupType === 'Time') {
          if (new Date() > new Date(endIntervalDate)) {
            this.toaster.warning('Time Passed', 'Slot time has been passed');
            return;
          }
        }
        let cellData: any;
        if (this.processGroupType === 'Time') {
          if (!params.oldValue || params.oldValue === '') {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: endIntervalDate,
              varId: params.data.parameterId,
              isOldValue: false,
              po: params.column.colId.split('~')[0],
              createdBy: this.ActiveUserCode,
              prodId:
                params.column.colId.split('~prodId')[1] !== undefined
                  ? params.column.colId.split('~prodId')[1].split('~')[0]
                  : '',
              ppId:
                params.column.colId.split('~ppId')[1] !== undefined
                  ? params.column.colId.split('~ppId')[1].split('~')[0]
                  : '',
              uomId:
                params.column.colId.split('~uomId')[1] !== undefined
                  ? params.column.colId.split('~uomId')[1].split('~')[0]
                  : '',
              ppdId:
                params.column.colId.split('~ppdId')[1] !== undefined
                  ? params.column.colId.split('~ppdId')[1].split('~')[0]
                  : '',
              intervalType: this.processGroupType,
            };
          } else {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: endIntervalDate,
              varId: params.data.parameterId,
              endInterval: endIntervalDate,
              startInterval: startIntervalDate,
              isOldValue: true,
              po: params.column.colId.split('~')[0],
              createdBy: this.ActiveUserCode,
              prodId:
                params.column.colId.split('~prodId')[1] !== undefined
                  ? params.column.colId.split('~prodId')[1].split('~')[0]
                  : '',
              ppId:
                params.column.colId.split('~ppId')[1] !== undefined
                  ? params.column.colId.split('~ppId')[1].split('~')[0]
                  : '',
              uomId:
                params.column.colId.split('~uomId')[1] !== undefined
                  ? params.column.colId.split('~uomId')[1].split('~')[0]
                  : '',
              ppdId:
                params.column.colId.split('~ppdId')[1] !== undefined
                  ? params.column.colId.split('~ppdId')[1].split('~')[0]
                  : '',
              intervalType: this.processGroupType,
            };
          }
        } else if (
          this.processGroupType === 'Event' ||
          this.processGroupType === 'Manual'
        ) {
          this.spinner.show();
          cellData = {
            result: params.value,
            entryOn: new Date(),
            resultOn: startIntervalDate,
            varId: params.data.parameterId,
            endInterval: startIntervalDate,
            startInterval: startIntervalDate,
            isOldValue: true,
            po: params.column.colId.split('~')[1],
            createdBy: this.ActiveUserCode,
            intervalType: this.processGroupType,
          };
          // }
        }
        this.spinner.show();
        this.processService.saveProessControl(cellData).subscribe(
          (response: any) => {
            this.spinner.hide();
            if (response.length && response[0]?.ncrId) {
              this.onNCRCreate(response, params)
            }
            const msg = response[0].result;
            if (msg !== null || msg !== '') {
              if (msg.substring(2, 1) === '0') {
                this.toaster.success('Success', msg.substring(3, msg.length));
              } else {
                this.spinner.hide();
                this.toaster.error('Error', msg.substring(3, msg.length));
              }
            }
          },
          (error: any) => {
            this.spinner.hide();
            return this.toaster.error('Error', error.message);
          }
        );
      }
    }
  }
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout('autoHeight');
    const element: HTMLElement = document.querySelector(
      '#myGrid'
    ) as HTMLElement;
    if (element !== null) {
      element.style.height = '';
    }
  }

  onGridReadyForBatchHistory(params: any): any {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridColumnApi = params.columnApi;
  }
  onGridSizeChanged(params: any): any {
    params.api.sizeColumnsToFit();
  }

  gridOptionsQualityControl: any = {
    suppressFieldDotNotation: true,
    headerHeight: 50,
    flex: 1,
    groupDefaultExpanded: 1,
    paginationPageSize: 10,
    popupParent: document.querySelector('body'),
    frameworkComponents: {
      customTooltip: CustomTooltip,
      primeCellEditor: PrimeCellEditorComponent,
      btnCellRendererActualEntry: BtnCellRendererActualEntry,
      btnCellRenderer: BtnCellRenderer,
      customLoadingCellRenderer: CustomLoadingCellRenderer,
    },
  };

  onQualityControlCellValueChanged(params: any): void {
    if (this.IsWrite) {
      const dataType = params.data.DataType;
      if (dataType === 'Bool' || dataType === 'Date') {
        let newVal = params.value;
        if (dataType === 'Int') {
          const charcter = this.isCharNumeric(newVal);
          if (!charcter) {
            this.toaster.warning('DigitsOnly', 'Please Select Digits Only');
            // newVal = params.oldValue;
            params.node.setDataValue(params.colDef.field, params.oldValue);
            return params.oldValue;
          }
        }
        if (dataType === 'Float') {
          const float = parseFloat(newVal);
          // tslint:disable-next-line:use-isnan
          if (isNaN(float)) {
            this.toaster.warning(
              'Decimal Only',
              'Please Select Decimal values Only'
            );
            // newVal = params.oldValue;
            params.node.setDataValue(params.colDef.field, params.oldValue);
            return params.oldValue;
          } else {
            params.value = parseFloat(params.value).toFixed(2);
          }
        }
        if (dataType === 'Date') {
          const date = params.value;
          if (date.match(new RegExp('/', 'g')).length === 2) {
          } else {
            this.toaster.warning(
              'SlashError',
              'Please Select Correct Date Format'
            );
            return params.oldValue;
          }
        }
        const startIntervalDate = params.colDef.field.substring(0, 20);
        const endIntervalDate = params.colDef.field.substring(23, 43);
        if (this.qualityGroupType === "Time") {
          if (new Date() > new Date(endIntervalDate)) {
            this.toaster.warning('Time Passed', 'Slot time has been passed');
            return;
          }
        }
        let cellData: any;
        if (this.qualityGroupType === 'Time') {
          if (!params.oldValue || params.oldValue === '') {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: endIntervalDate,
              endInterval: endIntervalDate,
              startInterval: startIntervalDate,
              varId: params.data.parameterId,
              isOldValue: false,
              cavity: params.data.Cavity ? params.data.Cavity : 0,
              po: params.column.colId.split('~')[1],
              createdBy: this.ActiveUserCode,
              prodId:
                params.column.colId.split('~prodId')[1] !== undefined
                  ? params.column.colId.split('~prodId')[1].split('~')[0]
                  : '',
              ppId:
                params.column.colId.split('~ppId')[1] !== undefined
                  ? params.column.colId.split('~ppId')[1].split('~')[0]
                  : '',
              uomId:
                params.column.colId.split('~uomId')[1] !== undefined
                  ? params.column.colId.split('~uomId')[1].split('~')[0]
                  : '',
              ppdId:
                params.column.colId.split('~ppdId')[1] !== undefined
                  ? params.column.colId.split('~ppdId')[1].split('~')[0]
                  : '',
              intervalType: this.qualityGroupType,
            };
          } else {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: endIntervalDate,
              varId: params.data.parameterId,
              endInterval: endIntervalDate,
              startInterval: startIntervalDate,
              isOldValue: true,
              cavity: params.data.Cavity ? params.data.Cavity : 0,
              po: params.column.colId.split('~')[1],
              createdBy: this.ActiveUserCode,
              prodId:
                params.column.colId.split('~prodId')[1] !== undefined
                  ? params.column.colId.split('~prodId')[1].split('~')[0]
                  : '',
              ppId:
                params.column.colId.split('~ppId')[1] !== undefined
                  ? params.column.colId.split('~ppId')[1].split('~')[0]
                  : '',
              uomId:
                params.column.colId.split('~uomId')[1] !== undefined
                  ? params.column.colId.split('~uomId')[1].split('~')[0]
                  : '',
              ppdId:
                params.column.colId.split('~ppdId')[1] !== undefined
                  ? params.column.colId.split('~ppdId')[1].split('~')[0]
                  : '',
              intervalType: this.qualityGroupType,
            };
          }
        } else if (
          this.qualityGroupType === 'Event' ||
          this.qualityGroupType === 'Manual'
        ) {
          if (!params.oldValue || params.oldValue === '') {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: startIntervalDate,
              endInterval: startIntervalDate,
              startInterval: startIntervalDate,
              varId: params.data.parameterId,
              isOldValue: true,
              cavity: params.data.Cavity ? params.data.Cavity : 0,
              po: params.column.colId.split('~')[1],
              // eventId: params.column.colId.split('~EventId')[1].split('~')[0],
              createdBy: this.ActiveUserCode,
              intervalType: this.qualityGroupType,
            };
          } else {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: startIntervalDate,
              varId: params.data.parameterId,
              endInterval: startIntervalDate,
              startInterval: startIntervalDate,
              isOldValue: true,
              cavity: params.data.Cavity ? params.data.Cavity : 0,
              po: params.column.colId.split('~')[1],
              createdBy: this.ActiveUserCode,
              intervalType: this.qualityGroupType,
            };
          }
        }
        this.spinner.show();
        this.processService.saveQualityProcessControl(cellData).subscribe(
          (response: any) => {
            this.spinner.hide();

            if (response.length && response[0]?.ncrId) {
              this.onNCRCreate(response, params)
            }
            const msg = response[0].result;
            if (msg !== null || msg !== '') {
              if (msg.substring(2, 1) === '0') {
                this.toaster.success('Success', msg.substring(3, msg.length));
                this.gridApi.refreshCells(params);
              } else {
                this.spinner.hide();
                this.toaster.error('Error', msg.substring(3, msg.length));
              }
            }
          },
          (error: any) => {
            this.spinner.hide();
            return this.toaster.error('Error', error.message);
          }
        );
      }
    }
  }


  getListType(): any {
    const getTypesByPlant = {
      groupCode: this.groupSession.groupCode,
      plantCode: this.plantSession.plantCode
    }
    this.ChecklistService.getTypesByPlant(getTypesByPlant).subscribe(
      (areadata: any) => {
        this.listTypeDDL = areadata;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }
  getItemType(): any {
    this.ChecklistService.getItemTypes().subscribe(
      (areadata: any) => {
        this.itemTypeDDL = areadata;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
        this.spinner.hide();
      }
    );
  }
  removeImagesColumns(name: string): void {
    const removeIndex = this.itemColumns.findIndex((i: any) => {
      return i === name;
    });
    if (removeIndex >= 0) {
      const good = this.itemColumns.splice(removeIndex, 1);
    }
  }
  getDataRowVisible(data: any): boolean {
    const groupRows = this.checkListAddModel.data.filter((row) => {
      if (!(row instanceof Group)) {
        return false;
      }
      let match = true;
      this.groupByColumns.forEach((column: any) => {
        if (!row[column] || !data[column] || row[column] !== data[column]) {
          match = false;
        }
      });
      return match;
    });

    if (groupRows.length === 0) {
      return true;
    }
    const parent = groupRows[0] as Group;
    return parent.visible && parent.expanded;
  }
  customFilterPredicate(data: any | Group, filter: string): boolean {
    return data instanceof Group ? data.visible : this.getDataRowVisible(data);
  }
  uniqueBy(a: any, key: any): any {
    const seen: any = {};
    return a.filter((item: any) => {
      const k = key(item);
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  }
  getSublevel(
    data: any[],
    level: number,
    groupByColumns: string[],
    parent: Group
  ): any[] {
    if (level >= groupByColumns.length) {
      return data;
    }
    const groups = this.uniqueBy(
      data.map((row) => {
        const result = new Group();
        result.level = level + 1;
        result.parent = parent;
        for (let i = 0; i <= level; i++) {
          result[groupByColumns[i]] = row[groupByColumns[i]];
        }
        return result;
      }),
      JSON.stringify
    );

    const currentColumn = groupByColumns[level];
    let subGroups: any[] = [];
    groups.forEach((group: any) => {
      const rowsInGroup = data.filter(
        (row) => group[currentColumn] === row[currentColumn]
      );
      group.totalCounts = rowsInGroup.length;
      const subGroup = this.getSublevel(
        rowsInGroup,
        level + 1,
        groupByColumns,
        group
      );
      subGroup.unshift(group);
      subGroups = subGroups.concat(subGroup);
    });
    this.spinner.hide();
    return subGroups;
  }

  addGroups(data: any[], groupByColumns: string[]): any[] {
    const rootGroup = new Group();
    rootGroup.expanded = true;
    return this.getSublevel(data, 0, groupByColumns, rootGroup);
  }



  getDateShifts(event: any): void {
    const key = {
      Date: this.checklistDataForm.value.executionDate,
      PUID: this.unitId,
    };
    this.checklistDataForm.get('shift')?.reset();
    this.checklistDataForm.get('shiftName')?.reset();
    this.crewService.GetCrewScheduleList(key).then(
      (response: any) => {
        const date = new Date();
        this.shiftList = response.CrewScheduleList;
        const record = this.shiftList.filter(
          (c: any) =>
            date.getTime() >= new Date(c.ShiftStart).getTime() &&
            date.getTime() <= new Date(c.ShiftEnd).getTime()
        );
        if (response.CrewScheduleList.length > 0) {
          this.checklistDataForm.get('shift')?.setValue(record[0].CrewId);
          this.checklistDataForm.get('shiftName')?.setValue(record[0].Shift);
        } else {
        }
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
        this.spinner.hide();
      }
    );
  }
  async Chart(): Promise<any> {
    this.options = {
      chart: {
        type: 'xrange',
        backgroundColor: '#000',
        height: 80,
      },
      title: {
        text: '',
        style: {
          color: '#fff',
        },
      },
      credits: {
        enabled: false,
      },
      exporting: {
        buttons: {
          contextButton: {
            enabled: false,
          },
        },
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        type: 'datetime',
        maxRange: 900000,
        labels: {
          style: {
            color: '#F0F0F0',
          },
        },
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        style: {
          color: '#F0F0F0',
        },
      },
      yAxis: {
        title: {
          text: '',
        },
        categories: [this.selectedunit],
        visible: false,
        reversed: true,
      },
      series: [
        {
          name: '',
          borderWidth: 0,
          pointWidth: 100,
          borderRadius: 0,
          className: 'borderleft',
          data: await this.formatChartData(),
          enablePolling: true,
          dataLabels: {
            enabled: false,
          },
        },
      ],
    };
    this.chart = Highcharts.chart('container', this.options);
  }

  getSFDCChart(): void {
    const key = {
      PuId: this.groupDataForm.value.machine,
      StartTime: this.shiftstart,
      EndTime: new Date()
    };
    if (key.StartTime && key.EndTime) {
      this.sfdService.GetSFDCChart(key).subscribe((downTimeList: any) => {
        this.chartData = downTimeList;
        const date = new Date();
        if (downTimeList.length) {
          const totalDownTime = downTimeList.filter(({ Status }) => Status === 'Down').reduce(
            (total, obj) => obj.Duration + total,
            0
          );
          this.SFDC_TotalDowntime = totalDownTime.toFixed(2) ?? 0;
        }
        const timeslotsDiff =
          this.SFDC_TotalProducedQTy < 1
            ? 0
            : (this.timedifference - this.SFDC_TotalDowntime) /
            (this.SFDC_TotalProducedQTy > 0 ? this.SFDC_TotalProducedQTy : 1);
        this.SFDC_TotalAverageSpeed = timeslotsDiff.toFixed(2) ?? 0;
        this.Chart();
      });
    }
  }

  formatChartData(): any {
    let dataArray = [];
    dataArray = this.chartData.map(c => {
      const start = Date.UTC(new Date(c.StartTime).getFullYear(), new Date(c.StartTime).getMonth(),
        new Date(c.StartTime).getDate(),
        new Date(c.StartTime).getHours(), new Date(c.StartTime).getMinutes(), new Date(c.StartTime).getSeconds());

      const end = Date.UTC(new Date(c.EndTime).getFullYear(), new Date(c.EndTime).getMonth(),
        new Date(c.EndTime).getDate(),
        new Date(c.EndTime).getHours(), new Date(c.EndTime).getMinutes(), new Date(c.EndTime).getSeconds());

      let color: any;
      if (c.Status === 'InProgress') {
        color = [
          [0, '#008000'], // start
          [1, '#008000'] // end
        ];
      }
      else if (c.Status === 'Down') {
        color = [
          [0, '#ff0000'], // start
          [1, '#ff0000']// end
        ];
      }
      const obj = {
        x: start,
        x2: end,
        color:
        {
          linearGradient: { x1: 0, x2: 1, y1: 1, y2: 0 },
          stops: color
        },
        y: 0
      };
      return obj;
    });
    return dataArray;
  }

  getCheckListById(element: any): void {
    const checkList = {
      checkListId: element.qualityCheckListId,
      unitId: this.unitId,
    };

    this.qualityexecutionService
      .getCheckListByIdForNewExecution(checkList)
      .subscribe(
        (response: any) => {
          this.checklistDataForm
            .get('group')
            ?.setValue(this.groupDataForm.get('group')?.value);
          this.checklistDataForm
            .get('plant')
            ?.setValue(this.groupDataForm.value.plant);
          this.checklistDataForm
            .get('unitName')
            ?.setValue(this.groupDataForm.get('machine')?.value);
          this.checklistDataForm
            .get('checktype')
            ?.setValue(response[0].listType);
          this.checklistDataForm
            .get('checkname')
            ?.setValue(response[0].listName);
          this.checklistDataForm
            .get('currentProcessOrder')
            ?.setValue(
              response[0].currentProcessOrder === null
                ? ''
                : response[0].currentProcessOrder
            );
          this.checklistDataForm
            .get('currentProcessOrderId')
            ?.setValue(response[0].currentProcessOrderId);
          this.isAuto = response.currentProcessOrder;
          this.valueCheck = this.checklistDataForm.value.currentProcessOrderId;
          if (this.valueCheck) {
            this.isAuto = true;
          } else {
            this.isAuto = false;
          }

          this.checklistDataForm
            .get('currentProductName')
            ?.setValue(
              response[0].currentProduct === null
                ? ''
                : response[0].currentProduct
            );
          this.preCheck = this.checklistDataForm.value.currentProductName;
          if (this.preCheck) {
            this.preAuto = true;
          } else {
            this.preAuto = false;
          }
          this.checklistDataForm
            .get('previousProcessOrder')
            ?.setValue(
              response[0].prevProcessOrder === null
                ? ''
                : response[0].prevProcessOrder
            );
          this.checklistDataForm
            .get('previousProcessOrderId')
            ?.setValue(response[0].prevProcessOrderId);
          this.valueCheck2 =
            this.checklistDataForm.value.previousProcessOrderId;
          if (this.valueCheck2) {
            this.isAuto2 = true;
          } else {
            this.isAuto2 = false;
          }

          this.checklistDataForm
            .get('previousProductName')
            ?.setValue(
              response[0].prevProduct === null ? '' : response[0].prevProduct
            );
          this.preCheck2 = this.checklistDataForm.value.previousProductName;
          if (this.preCheck2) {
            this.preAuto2 = true;
          } else {
            this.preAuto2 = false;
          }
          this.getDateShifts(event);
          this.checklistDataForm.get('area')?.setValue(element.AreaName);
          response.forEach((ele: any) => {
            const row = {
              id: this.counter,
              item: ele.itemName,
              itemtype: ele.itemType,
              drop: ele.itemGroup,
              checkListDetailId: ele.checkListDetailId,
              remarks: '',
              score: 0,
              catType: '',
              goodImage: ele.goodExampleImage,
              badImage: ele.badExampleImage,
            };
            this.addtabledata.push(row);
            const f = new File([''], 'filename');
            this.goodImgArray.push(f);
          });

          response.forEach((item: any, index: any) => {
            item.id = index + 1;
            item.remarks = '';
            item.score = '';
            item.catType = '';
            item.goodImage = item.goodExampleImage,
              item.badImage = item.badExampleImage,
              item.dropDown = JSON.parse(item.dropDown)
          });

          this._alldata = response;
          this.checkListAddModel.data = this.addGroups(
            this._alldata,
            this.groupByColumns
          );
          this.checkListAddModel.filterPredicate =
            this.customFilterPredicate.bind(this);
          this.checkListAddModel.filter = performance.now().toString();

          const goodImage = response.filter((element: any) => {
            if (element.goodExampleImage.split('/')[5]?.length > 0) {
              return element;
            }
          });
          if (goodImage.length > 0) {
            this.GoodExampleImage = true;
          } else {
            this.removeImagesColumns('good');
          }
          const badImage = response.filter((element: any) => {
            if (element.badExampleImage.split('/')[5]?.length > 0) {
              return element;
            }
          });
          if (badImage.length > 0) {
            this.BadExampleImage = true;
          } else {
            this.removeImagesColumns('bad');
          }
        },
        (error: any) => {
          this.toaster.error(
            this.translate.instant('Error'),
            this.translate.instant('WentWrong')
          );
        }
      );
  }

  resetForm(): void {
    this.checklistDataForm.reset();
    this.dialog.closeAll();

    this.addtabledata = [];
    this.addtabledata.length = 0;
  }
  sendNotification(): void {
    const key = {
      roleName: 'Line Leader',
      createdBy: this.ActiveUserCode,
      groupCode: this.groupSession.groupCode,
      title: 'CheckList Execution',
      desc:
        'Execution has been created in check list ' +
        this.checklistDataForm.value.checkname +
        ' by ' +
        this.ActiveUsername,
    };
    this.notificationService.addnotification(key).subscribe(
      (response: any) => { },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }
  getAllQualityCheckList(): void {
    const key = {
      plantCode: this.plantSession.plantCode,
      puId: this.unitId,
    };
    if (this.executeRole === true) {
      this.hidetrue = true;
    } else {
      this.hidetrue = false;
    }
    this.spinner.show();
    this.qualityexecutionService.getCheckList(key).subscribe(
      (checklist: any) => {
        this.customerManagementDataSource.data = [];
        this.customerManagementDataSource.data = checklist;
        this.getPaginator(this.customerManagementDataSource, 4);
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }
  addCheckListExecution(): void {
    const result = this._alldata;
    const executionDetails: any[] = [];
    result.forEach((element, i) => {
      const v = {
        checkListDetailId: element.checkListDetailId,
        remarks: element.remarks,
        acutalValue: element.score,
        goodImage: element.goodImage,
        badImage: element.badImage,
        itemTypeId: element.itemType,
        catType:
          element.itemType !== 4
            ? element.catType
            : this.goodImgArray[i].name === 'filename'
              ? ''
              : this.goodImgArray[i].name,
      };
      executionDetails.push(v);
    });
    const found = executionDetails.some((el) => el.catType !== '');
    if (!found) {
      this.toaster.warning(this.translate.instant('SelectAnyValue'));
      return;
    }
    const formdata = new FormData();
    for (let index = 0; index < this.goodImgArray.length; index++) {
      formdata.append('goodImages', this.goodImgArray[index]);
    }
    const key = {
      UserCode: this.ActiveUserCode,
      checkListId: this.checklistId,
      execDate: this.checklistDataForm.get('executionDate')?.value,
      shift: this.checklistDataForm.get('shift')?.value,
      unitId: this.unitId,
      processOrder: this.checklistDataForm
        .get('currentProcessOrder')
        ?.value.toString(),
      previousProcessOrder:
        this.isAuto2 === false
          ? this.checklistDataForm.get('previousProcessOrder')?.value
          : this.checklistDataForm.get('previousProcessOrderId')?.value,
      productName: this.checklistDataForm.get('currentProductName')?.value,
      previousProductName: this.checklistDataForm.get('previousProductName')
        ?.value,
      executionDetails,
    };
    formdata.append('checkListexecution', JSON.stringify(key));
    this.qualityexecutionService.addCheckListExecution(formdata).subscribe(
      (response) => {
        this.dialog.closeAll();
        this.toaster.success(
          this.translate.instant('Success'),
          this.translate.instant('AuditExecution') +
          this.translate.instant('AddedSuccessfully')
        );
        this.sendNotification();
        this.resetForm();

        this.getAllQualityCheckList();
      },
      (error) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  OpenViewCheckList(checkListId: any, displayRoleModalView: any): void {
    if (checkListId.lastExecutionId !== null) {
      this.spinner.show();
      this.shiftName = null;
      this.checklistDataForm.get('shift')?.reset();
      this.checklistId = checkListId.checkListId;
      this.itemColumns = ['items', 'good', 'bad', 'standard',
        'minimum',
        'maximum', 'score', 'remarks'];
      this.getListType();
      this.getItemType();
      this.getCheckListHistorybyId(checkListId.lastExecutionId, checkListId);

      this.resetForm();
      this.goodImgArray = [];
      this.dialog.open(displayRoleModalView, {
        width: '90vw !important',
        height: 'auto',
        maxHeight: '90vh',
        minWidth: '90vw',
        disableClose: true
      });
      const d = new Date();
      this.checklistDataForm.get('executionDate')?.setValue(d);
      this.formMode = false;
    }
    else {
      this.toaster.error('Error', 'No Execution History');
    }
  }

  getCheckListHistorybyId(ExecutionId: number, element: any): void {
    const checkListHistory = {
      executionId: ExecutionId,
    };
    if (ExecutionId !== null) {
      this.QualityCheckService.getCheckListHistoryById(
        checkListHistory
      ).subscribe(
        (data: any) => {
          data.forEach(element => {
            if (element.dropDown) {
              if (element.ItemType == 5) {
                element.dropDown = JSON.parse(element.dropDown);
              }
            }
            element.typefile = ''
            if (element.ItemType === 4) {
              let x = element.CatType;
              element.typefile = x.split('.').pop();
            }
          });
          this.spinner.hide();
          this.checklistDataFormView.get('group')?.setValue(data[0].EG_Desc);
          this.checklistDataFormView.get('plant')?.setValue(data[0].PT_Desc);
          this.checklistDataFormView.get('checktype')?.setValue(data[0].QualityType);
          this.checklistDataFormView.get('Listname')?.setValue(data[0].ListName);
          this.checklistDataFormView.get('area')?.setValue(element.AreaName);
          this.checklistDataFormView
            .get('executionDate')
            ?.setValue(moment(data[0].ExecDate).format('DD-MM-YYYY'));
          this.checklistDataFormView.get('shift')?.setValue(data[0].ShiftName);
          this.checklistDataFormView.get('Unit')?.setValue(data[0].PU_Desc);
          this.checklistDataFormView.get('currentProcessOrder')?.setValue(data[0].ProcessOrder !== null ? data[0].ProcessOrder : '');
          // this.checklistDataFormView.get('currentProcessOrder')?.setValue(data.ProcessOrder);
          this.checklistDataFormView
            .get('currentProductDescription')
            ?.setValue(data[0].ProductName !== 'null' ? data[0].ProductName : '');
          this.checklistDataFormView
            .get('previousProcessOrder')
            ?.setValue(
              data[0].PreviousProcessOrder !== null
                ? data[0].PreviousProcessOrder
                : ''
            );
          this.checklistDataFormView
            .get('previousProductDescription')
            ?.setValue(data[0].PreviousProductName);
          this.checklistDataFormView
            .get('targetOrderQuantity')
            ?.setValue(data[0].targetOrderQuantity);
          this.checklistDataFormView
            .get('producedQuantity')
            ?.setValue(data[0].producedQuantity);
          this.spinner.show();

          this.alldataView = data;
          this.dataSourceView.data = this.addGroups(
            this.alldataView,
            this.groupByColumnsView
          );
          this.getPaginatorView(this.dataSourceView, 4);
          this.dataSourceView.filterPredicate = this.customFilterPredicateView.bind(this);
          this.dataSourceView.filter = performance.now().toString();
          const goodImage = data.filter((element: any) => {
            if (element.GoodExampleImage) {
              if (element.GoodExampleImage != "") {
                return element;
              }
            }
          });
          if (goodImage.length > 0) {
            this.GoodExampleImage = true;
          } else {
            this.removeImagesColumns('good');
          }
          const badImage = data.filter((element: any) => {
            if (element.BadExampleImage) {
              if (element.BadExampleImage != "") {
                return element;
              }
            }
          });
          if (badImage.length > 0) {
            this.BadExampleImage = true;
          } else {
            this.removeImagesColumns('bad');
          }
          this.spinner.hide();
        },
        (error) => {
          this.toaster.error('Error', error.error.message);
          this.spinner.hide();
        }
      );
    }
    else {
      this.toaster.error('Error', 'No Execution History');
    }
  }
  getDataRowVisibleView(data: any): boolean {
    const groupRows = this.dataSourceView.data.filter((row) => {
      if (!(row instanceof Group)) {
        return false;
      }
      let match = true;
      this.groupByColumnsView.forEach((column: any) => {
        if (!row[column] || !data[column] || row[column] !== data[column]) {
          match = false;
        }
      });
      return match;
    });

    if (groupRows.length === 0) {
      return true;
    }
    const parent = groupRows[0] as Group;
    return parent.visible && parent.expanded;
  }
  groupHeaderClickView(row: any): any {
    row.expanded = !row.expanded;
    this.dataSourceView.filter = performance.now().toString(); // bug here need to fix
  }
  customFilterPredicateView(data: any | Group, filter: string): boolean {
    return data instanceof Group ? data.visible : this.getDataRowVisibleView(data);
  }
  groupByView(event: any, column: any): void {
    event.stopPropagation();
    this.checkGroupByColumnView(column.field, true);
    this.dataSourceView.data = this.addGroupsView(this.alldataView, this.groupByColumnsView);
    this.dataSourceView.filter = performance.now().toString();
    this.getPaginatorView(this.dataSourceView, 4);
  }

  checkGroupByColumnView(field: any, add: any): any {
    let found = null;
    for (const column of this.groupByColumns) {
      if (column === field) {
        found = this.groupByColumnsView.indexOf(column, 0);
      }
    }
    if (found != null && found >= 0) {
      if (!add) {
        this.groupByColumnsView.splice(found, 1);
      }
    } else {
      if (add) {
        this.groupByColumns.push(field);
      }
    }
  }

  addGroupsView(data: any[], groupByColumns: string[]): any[] {
    const rootGroup = new Group();
    rootGroup.expanded = true;
    return this.getSublevel(data, 0, groupByColumns, rootGroup);
  }

  getSublevelView(data: any[], level: number, groupByColumns: string[], parent: Group
  ): any[] {
    if (level >= groupByColumns.length) {
      return data;
    }
    const groups = this.uniqueByView(
      data.map((row) => {
        const result = new Group();
        result.level = level + 1;
        result.parent = parent;
        for (let i = 0; i <= level; i++) {
          result[groupByColumns[i]] = row[groupByColumns[i]];
        }
        return result;
      }),
      JSON.stringify
    );

    const currentColumn = groupByColumns[level];
    let subGroups: any[] = [];
    groups.forEach((group: any) => {
      const rowsInGroup = data.filter(
        (row) => group[currentColumn] === row[currentColumn]
      );
      group.totalCounts = rowsInGroup.length;
      const subGroup = this.getSublevelView(
        rowsInGroup,
        level + 1,
        groupByColumns,
        group
      );
      subGroup.unshift(group);
      subGroups = subGroups.concat(subGroup);
    });
    return subGroups;
  }
  uniqueByView(a: any, key: any): any {
    const seen: any = {};
    return a.filter((item: any) => {
      const k = key(item);
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  }
  getPaginatorView(dataSource: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      dataSource.paginator = this.paginatorView.toArray()[index];
      dataSource.sort = this.sortView.toArray()[index];
    }, 1000);
  }


  fillLarge() {
    this.setWidthAndHeight('100%', '100%');
  }
  setWidthAndHeight(width: any, height: any) {
    this.style = {
      width: width,
      height: height,
    };
  }
  OpenEditCheckList(listId: any, checklistExecutionModal: any): void {
    this.shiftName = null;
    this.checklistDataForm.get('shift')?.reset();

    this.itemColumns = ['items', 'good', 'bad', 'standard',
      'minimum',
      'maximum', 'score', 'remarks'];
    this.checklistId = listId.checkListId;
    this.getListType();
    this.getItemType();
    this.getCheckListById(listId);

    this.resetForm();
    const d = new Date();
    this.checklistDataForm.get('executionDate')?.setValue(d);
    this.checklistDataForm.get('area')?.setValue(listId.AreaName);
    this.goodImgArray = [];
    this.dialog.open(checklistExecutionModal, {
      width: '90vw !important',
      height: '90vh',
      minWidth: '90vw',
    });

    this.formMode = false;
  }

  // CIL Management Functions Starts Here

  public checkErrorType = (controlName: string, errorName: string) => {
    return this.performCILItemForm.controls[controlName].hasError(errorName);
  };

  opensideMachineModal(): void {
    this.formMode = true;

    this.displayMAchineModal = true;
    this.getUnitTreeModal();
  }

  opensideComponentModal(): void {
    this.formMode = true;
    this.displayComponentModal = true;
    this.onRemove(this.file);
    this.GetCompModelTreeForCIL();
  }

  openActionModal(): void {
    this.formMode = true;
    this.onRemove(this.file);
    this.displayActionModal = true;
  }
  closeActionModal(): void {
    this.displayActionModal = false;
  }

  closeaddNewPlantItemModel(): void {
    this.displayMAchineModal = false;
    this.displayComponentModal = false;
    this.displayUserModal = false;
  }

  closeaddNewVariableModel(): void { }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  OnChangeGroup(element: any): void {
    this.selectedGroup = element.value;
    const key = {
      EGId: this.selectedGroup, // 10, //this.CilManagDataForm.value.group,
      Level: 'Unit',
      IsOptional: 0,
      CreatedBy: 0,
    };
    this.cilService.GetTreeModal(key).subscribe(
      (res: any) => {
        this.machineList = res.TreeModalList;
        if (
          res.TreeModalList.Level === 'Unit' &&
          res.TreeModalList.level.length()
        ) {
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }
  GetPlantByEgDDL(): void {
    const key = {
      GroupId: this.selectedGroup,
    };

    this.machineService.getPlantsData(key).subscribe(
      (data: any) => {
        this.plants = data.DepartList;
        this.CilManagDataForm.get('plant')?.setValue(data.DepartList[0].DeptId);
        this.getUnits();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getUnits(): void {
    const key = {
      ptId: this.CilManagDataForm.value.plant,
      userId: JSON.parse(localStorage.user).UserId,
    };
    this.filteredbatchConsumptionList = [];
    this.machineService.getUnitbyUser(key).subscribe(
      (data: any) => {
        this.getAssembly();
        this.units = data;
        this.filteredUnits = this.units.slice();
        this.CilManagDataForm.get('machine')?.setValue(data[0].puId);
        this.startTime = new Date();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getComponents(): void {
    const key = {
      UserCode: this.ActiveUserCode?.toString(),
      A_ID: this.CilManagDataForm.value.assembly?.toString()
    };

    this.sfdService.getComponentListByAssembly(key).subscribe(
      (data: any) => {
        this.components = data.lstComponent;
        this.filteredcomponents = this.components.slice();
        this.CilManagDataForm.get('component')?.setValue(0);

        this.getDefectMgmtTableData();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  getUnitTreeModal(): void {
    const key = {
      EGId: this.selectedGroup, // 10, //this.CilManagDataForm.value.group,
      Level: 'Unit',
      IsOptional: 0,
      CreatedBy: 0,
    };
    this.cilService.GetTreeModal(key).subscribe(
      (res: any) => {
        this.machineList = res.TreeModalList;
        const TreeData: PlantGroupElement[] = res.TreeModalList;
        this.machineTreeSource.data = TreeData;

        this.treeControl.dataNodes = this.machineTreeSource.data;
        this.flattenArr = flatten(TreeData);
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  performCILItemFormSubmit(): void {
    //
  }

  getDefectMgmtTableData(): void {
    this.spinner.show();
    this.selection.clear();
    const key = {
      plantcode: this.plantSession.plantCode

    };
    this.cilService.GetCILDataForSFDC(key).subscribe((res: any) => {
      const list = res.GetCILList
      if (list && list.length) {
        list.forEach((elem: any) => {
          if (elem.submitted === false) {
            elem.expiryDate = new Date(new Date(elem.nextTime).getTime() - 60000)
          }
        });
        this.cilManagementVariableGroupData =
          new MatTableDataSource<CILManagementElement>(list.filter(c => c.submitted === false));
        this.cilManagementExecuted =
          new MatTableDataSource<CILManagementElement>(list.filter(c => c.submitted));
      } else {
        this.cilManagementVariableGroupData = new MatTableDataSource<CILManagementElement>([]);
        this.cilManagementExecuted = new MatTableDataSource<CILManagementElement>([]);
      }
      this.getPaginator(this.cilManagementVariableGroupData, 5);
      setTimeout(() => {
        this.cilManagementExecuted.paginator = this.paginator.toArray()[1];
        this.cilManagementExecuted.sort = this.sort.toArray()[1];
      }, 1000);
      setTimeout(() => {
        this.spinner.hide();
      }, 1000);
    },
      (error: any) => {
        throw error;
        this.spinner.hide();
      }
    );
    this.selection.selected.length = 0;
    this.isButtonEnable = true;
  }

  GetCompModelTreeForCIL(): void {
    const key = {
      ParentId: this.selectedGroup,
      plantId: this.CilManagDataForm.get('plant')?.value,
      machineId: this.CilManagDataForm.value.machine,
    };

    this.cilService.GetCompModelTreeForCIL(key).subscribe(
      (res: any) => {
        this.componentList = res.Tree;
        const TreeData: PlantGroupElement[] = res.Tree;
        this.compTreeSource.data = TreeData;
        this.treeControlComponent.dataNodes = this.compTreeSource.data;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  GetMachineModelTreeForCIL(): void {
    const key = {
      ParentId: this.selectedGroup,
      plantId: 1,
    };
    this.cilService.GetMachineModelTreeForCIL(key).subscribe(
      (res: any) => {
        this.machineList = res.Tree;
        const TreeData: PlantGroupElement[] = res.Tree;
        this.machineTreeSource.data = TreeData;
        this.treeControl.dataNodes = this.machineTreeSource.data;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  SelectComponent(component: any): void {
    if (component.text !== null) {
      this.CilManagDataForm.get('component')?.setValue(component.text);
      this.componentId = component.id;
      this.displayComponentModal = false;
      this.getDefectMgmtTableData();
    }
  }

  SelectNodeName(line: any): any { }

  SelectNodeNameForComp(line: any): any {
    if (line.Level === 'Component') {
      this.selectedComponent = line.SelectNodeNameForComp;
    }
  }
  scanQrCode(elem): void {
    this.slectedItemBOMDetailId = elem
    this.scanning = !this.scanning;
    this.qrCodeDialogRef = this.dialog.open(this.QRscanner, {
      width: '455px',
      height: '505px'
    });
  }
  changeTraceCode(event: any, id: number) {
    this.ItemBOMList?.data?.forEach((x: any, index) => {
      if (x?.ItemBOMDetailId === id) {
        this.ItemBOMList.data[index].traceCode = event.target.value;
      }
    });
  }
  onCodeResult(resultString: string) {
    this.qrCodeDialogRef.close();
    this.qrResultObj = JSON.parse(resultString);
    if (this.qrResultObj?.Code) {
      this.ItemBOMList?.data?.forEach((x: any, index) => {
        if (x?.ItemBOMDetailId === this.slectedItemBOMDetailId) {
          this.ItemBOMList.data[index].traceCode = this.qrResultObj?.Code;
        }
      });
    }
    this.cdRef.detectChanges();
    if (this.qrResultObj) {
      this.scanning = false;
    }
  }
  onNodeSelectForComp(node: any): void {
    //
    if (node.Level === 'Component') {
      //
    }
  }

  // collapse group view

  collapseAllNodeComp(): void {
    this.treeControl.collapseAll();
  }

  expandAllNodeComp(): void {
    this.treeControl.expandAll();
  }

  // open edit CIL variable group model
  openEditCILGroupModel(element: CILManagementElement): void {
    // this.editGroupItemParent = element;
  }
  openCILExecformModel(): void {
    this.formMode = true;
    this.performCILItemForm.reset();
    this.isEditCILModelVisible = true;
    const t = new Date();

    this.performCILItemForm.get('endDate')?.setValue(t);
    this.performCILItemForm.get('startDate')?.setValue(t);
    this.performCILItemForm.get('postImage')?.reset();
  }

  openCILPerformModel(element: CILManagementElement): void {
    this.performCILItemForm.reset();
    this.formMode = false;
    this.isEditCILModelVisible = true;
    this.selectedTaskId = element.id;
    this.selectedTaskComp = element.componentId;
    this.onRemove(this.file);
    const t = new Date();
    this.performCILItemForm.get('endDate')?.setValue(t);
    this.performCILItemForm.get('startDate')?.setValue(t);
    this.performCILItemForm.get('postImage')?.reset();
    if (this.CilManagDataForm.get('machine')?.value === '') {
      this.toaster.error('please select machine first');
      this.isEditCILModelVisible = false;
    }
  }
  onNCRCreate(response, params) {
    if (response.length) {
      const NCRId = response[0]?.ncrId;
      const instanceKey = generateGuid();
      const instance = {
        workFlowKey: this.ncrWorkFlow ? this.ncrWorkFlow.workFlowKey : '',
        UserCode: this.ActiveUserCode,
        userName: this.ActiveUsername,
        instanceKey
      };


      this.workFlowService.createSingleInstances(instance).subscribe(
        (resp) => {

          const createInstance = {
            instanceKey,
            UserCode: this.ActiveUserCode,
            userName: this.ActiveUsername,
            actionName: 'Create',
            rules: null,
            tenantId: this.plantId,
            tableId: NCRId,
            payload: {

              ...response[0]

            }
          }

          this.workFlowService.setSingleInstance(createInstance).subscribe(
            (res) => {

            },
            ({ error }) => {
              this.spinner.hide();
              this.toaster.error('Error', error?.message);
            }
          );

        }
      )
    }

  }
  async GetAllDataTypesDetailQC(val: any): Promise<any> {
    const key = {
      variableId: val,
    };
    await this.qualityParameterService
      .GetAllDataTypesDetail(key)
      .then((res: any) => {
        this.boolList = res.map((c: any) => c.text);
      });
  }
  saveCilAction(): void {
    const arr: any[] = [];
    const data = this.selection.selected.filter(
      (c: any) => c.submitted === false
    );
    data.forEach((element) => {
      const si = {
        taskId: element.id, // this.taskForm.value.plantId,
        rbDone: this.performCILItemForm.value.option,
        startTime: this.performCILItemForm.value.startDate,
        endTime: new Date(), // this.performCILItemForm.value.endDate,
        userId: JSON.parse(localStorage.user).UserId,
        remarks: this.performCILItemForm.value.Remarks,
        componentId: this.CilManagDataForm.value.component,
        taskImage: '',
        taskImageName: '',
      };
      arr.push(si);
    });
    this.cilService.performCilAction(arr).subscribe(
      (res: any) => {
        this.toaster.success('Action Saved Successfully');
        this.selection.clear();
        this.getDefectMgmtTableData();
        this.isEditCILModelVisible = false;
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }
  getProcessParamterGroupList(): void {
    const key = {
      paramterType: 'Process Control',
      puId: this.unitId,
      groupType: this.processGroupType,
    };
    this.processService.getParamterGroupList(key).subscribe(
      (data: any) => {
        this.processparameterGroupList = data;
        this.processControlForm
          .get('parameterGroup')
          ?.setValue(this.processparameterGroupList);
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  getQualityParamterGroupList(): void {
    const key = {
      paramterType: 'Quality Control',
      puId: this.unitId,
      groupType: this.qualityGroupType,
    };
    this.processService.getParamterGroupList(key).subscribe(
      (data: any) => {
        this.qualityparameterGroupList = data;
        this.qualityControlForm
          .get('parameterGroup')
          ?.setValue(this.qualityparameterGroupList);
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  onProcessParameterGroupChange(): void {
    const instance = this.processGridApi.getFilterInstance('ParameterGroup');
    const myArray: any = [];
    for (let i = 0; i < this.processControlForm.value.parameterGroup.length; i++) {
      myArray.push(this.processControlForm.value.parameterGroup[i].vgDesc);
    }
    instance.setModel({
      values: myArray.length > 0 ? myArray : [],
    });
    this.processGridApi.onFilterChanged();
  }



  onQualityParameterGroupChange(): void {
    const instance = this.qualityGridApi.getFilterInstance('ParameterGroup');
    const myArrayquality: any = [];
    // tslint:disable-next-line:prefer-for-of
    if (this.qualityControlForm.value.parameterGroup) {
      for (let i = 0; i < this.qualityControlForm.value.parameterGroup.length; i++) {
        myArrayquality.push(this.qualityControlForm.value.parameterGroup[i].vgDesc);
      }
    }
    if (instance) {
      instance.setModel({
        values: myArrayquality.length > 0 ? myArrayquality : [],
      });
    }
    this.qualityGridApi.onFilterChanged();
  }
  SavePerformTask(): void {
    const formData: any = new FormData();
    formData.append('Imagefile', this.file);
    formData.append(
      'obj',
      JSON.stringify({
        taskId: this.selectedTaskId, // this.taskForm.value.plantId,
        rbDone: this.performCILItemForm.value.option,
        startTime: this.performCILItemForm.value.startDate,
        endTime: new Date(), // this.performCILItemForm.value.endDate,
        userId: JSON.parse(localStorage.user).UserId,
        remarks: this.performCILItemForm.value.Remarks,
        componentId: this.CilManagDataForm.value.component,
        taskImage: '',
        taskImageName: '',
      })
    );
    this.spinner.show();
    this.cilService.PerformCilTask(formData).subscribe(
      (res: any) => {
        if (res.HasError === false) {
          this.toaster.success('Task Performed Successfully');
          this.selection.clear();
          this.closeCILPerformModel();
          this.performCILItemForm.reset();
          this.getDefectMgmtTableData();
          this.spinner.hide();
        } else {
          this.toaster.error('error', res.ErrorMessage);
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }
  onFileSelect(event: any): void {
    this.file = undefined;
    this.file = event.addedFiles[0];
  }
  onRemove(event: any): void {
    this.file = undefined;
  }
  getEndTime(): void {
    const d = new Date();
  }

  // close machine parameter variable  model
  closeCILPerformModel(): void {
    this.isEditCILModelVisible = false;
    this.performCILItemForm.reset();
  }

  reset(): void {
    this.CilManagDataForm.reset();
    this.getDefectMgmtTableData();
  }

  deleteCIL(element: any): void { }


  openFile(): void {
    this.fileInput.nativeElement.click();
  }


  isAllSelected(): any {
    if (this.selection.selected.length > 1) {
      this.show = true;
    } else {
      this.show = false;
    }

    const numSelected = this.selection.selected.length;
    const numRows = this.cilManagementVariableGroupData.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(): void {
    this.isAllSelected()
      ? (this.selection.clear(), this.checkBoxCount())
      : this.cilManagementVariableGroupData.data.forEach((row) =>
        this.selection.select(row)
      );
  }

  checkBoxCount(): void {
    this.show = false;
  }

  // CIL Management Ends Here
  GetcolumnDefs(): void {



    this.columnWasteHistry = [
      {
        headerName: 'Actions',
        hide: !this.IsWrite,
        cellRenderer: 'buttonEditRenderer',
        cellRendererParams: {
          onClick: this.onClickWasteHistory.bind(this),
          label: 'Edit',
        },
        maxWidth: 100,
      },
      { headerName: 'Category type', field: 'FaultName' },
      {
        headerName: 'Time', field: 'Time', cellRenderer: (data: any) => {
          return data.value
            ? moment(new Date(data.value)).format('DD/MM/YYYY HH:mm:ss')
            : '';
        },
      },
      { headerName: 'qty', field: 'Amount' },
      { headerName: 'mode', field: 'Remarks' },
      {
        headerName: 'Created On',
        field: 'CreatedOn',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
        },
      },
      { headerName: 'Created By', field: 'CreatedBy' },
    ];

    this.columnDefsDowntimeHistory = [
      {
        headerName: 'Actions',
        field: 'Actions',
        hide: !this.IsWrite,
        cellRenderer: (params: any): any => {
          return `
                <div>
                <button mat-mini-fab="" color="primary"  class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary style="background-color: #20b2aa;"  ng-reflect-color="primary" ng-reflect-text="Action Detail" ng-reflect-tooltip-position="top"><span class="mat-button-wrapper"><i class="fa fa-pencil" style="color: #fff;"></i></span><span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
                </div>
              `;
        },
        cellRendererParams: {
          clicked(field: any) { },
        },
        maxWidth: 100,
      },
      {
        headerName: 'Start time',
        field: 'StartTime',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
      },
      {
        headerName: 'End time',
        field: 'EndTime',

        valueFormatter: function (params: any) {
          if (params.value !== null) {
            return moment(params.value)?.format('MM/DD/YYYY HH:mm');
          } else {
            return null;
          }
        },
      },
      {
        headerName: 'Duration(min)', field: 'Duration',
        valueFormatter: function (params: any) {
          if (params.value !== null) {
            return params.value.toFixed(2);
          } else {
            return null;
          }
        },
      },
      { headerName: 'Fault', field: 'FaultName' },
      { headerName: 'Remarks', field: 'Remarks' },
      {
        headerName: 'Created On',
        field: 'CreatedOn',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
      },
      { headerName: 'Created By', field: 'CreatedBy' },
    ];

  }



  openChangeOverCheckListModel(): void {
    this.shiftName = null;
    if (this.onlymachineSelectProperty === true) {

      this.checklistDataForm.get('shift')?.reset();
      this.itemColumns = ['items', 'good', 'bad', 'standard',
        'minimum',
        'maximum', 'score', 'remarks'];

      this.getChangeOverCheckList();
      this.resetForm();

    }
    else {
      this.toaster.error('error', this.translate.instant('UnitSelection'));
    }
  }


  getChangeOverCheckList(): void {
    const checkList = {
      unitId: this.unitId,
    };
    this.spinner.show();
    this.qualityexecutionService
      .getChangeOverCheckListForExecution(checkList)
      .subscribe(
        (response: any) => {
          this.spinner.hide();
          if (!response?.length) {
            this.toaster.warning('Warn', 'There is not CheckList')
          }
          else {
            this.dialog.open(this.changeOverCheckListExecutionModel, {
              width: '90vw !important',
              height: '90vh',
              minWidth: '90vw',
            });
            this.getListType();
            this.getChangeOverProducts();
            this.getItemType();
            const d = new Date();
            this.checklistDataForm.get('executionDate')?.setValue(d);
            this.checklistId = response[0]?.checkLlistId;
            this.checklistDataForm
              .get('group')
              ?.setValue(this.groupDataForm.get('group')?.value);
            this.checklistDataForm.get('plant')?.setValue(this.plantId);
            this.checklistDataForm
              .get('unitName')
              ?.setValue(this.groupDataForm.get('Unit')?.value);
            this.checklistDataForm
              .get('checktype')
              ?.setValue(response[0].listType);
            this.checklistDataForm
              .get('checkname')
              ?.setValue(response[0].listName);
            this.checklistDataForm
              .get('currentProcessOrder')
              ?.setValue(
                response[0].currentProcessOrder === null
                  ? ''
                  : response[0].currentProcessOrder
              );
            this.checklistDataForm
              .get('currentProcessOrderId')
              ?.setValue(response[0].currentProcessOrderId);
            this.isAuto = response[0].currentProcessOrder;
            this.valueCheck = this.checklistDataForm.value.currentProcessOrderId;
            if (this.valueCheck) {
              this.isAuto = true;
            } else {
              this.isAuto = false;
            }

            this.checklistDataForm
              .get('currentProductName')
              ?.setValue(
                response[0].currentProduct === null
                  ? ''
                  : response[0].currentProduct
              );
            this.preCheck = this.checklistDataForm.value.currentProductName;
            if (this.preCheck) {
              this.preAuto = true;
            } else {
              this.preAuto = false;
            }
            this.checklistDataForm
              .get('previousProcessOrder')
              ?.setValue(
                response[0].prevProcessOrder === null
                  ? ''
                  : response[0].prevProcessOrder
              );
            this.checklistDataForm
              .get('previousProcessOrderId')
              ?.setValue(response[0].prevProcessOrderId);
            this.valueCheck2 =
              this.checklistDataForm.value.previousProcessOrderId;
            if (this.valueCheck2) {
              this.isAuto2 = true;
            } else {
              this.isAuto2 = false;
            }

            this.checklistDataForm
              .get('previousProductName')
              ?.setValue(
                response[0].prevProduct === null ? '' : response[0].prevProduct
              );
            this.preCheck2 = this.checklistDataForm.value.previousProductName;
            if (this.preCheck2) {
              this.preAuto2 = true;
            } else {
              this.preAuto2 = false;
            }
            this.getDateShifts(event);
            this.checklistDataForm.get('area')?.setValue(response[0].areaName);
            response.forEach((ele: any) => {
              const row = {
                id: this.counter,
                item: ele.itemName,
                itemtype: ele.itemType,
                drop: ele.itemGroup,
                checkListDetailId: ele.checkListDetailId,
                remarks: '',
                score: 0,
                catType: '',
                goodImage: ele.goodExampleImage,
                badImage: ele.badExampleImage,
                dropDown: JSON.parse(ele.dropDown)
              };
              this.addtabledata.push(row);
              const f = new File([''], 'filename');
              this.goodImgArray.push(f);
            });

            response.forEach((item: any, index: any) => {
              item.id = index + 1;
              item.remarks = '';
              item.score = '';
              item.catType = '';
              item.goodImage = item.goodExampleImage,
                item.badImage = item.badExampleImage,
                item.dropDown = JSON.parse(item.dropDown)
            });

            this._alldata = response;
            this.checkListAddModel.data = this.addGroups(
              this._alldata,
              this.groupByColumns
            );
            this.checkListAddModel.filterPredicate =
              this.customFilterPredicate.bind(this);
            this.checkListAddModel.filter = performance.now().toString();

            const goodImage = response.filter((element: any) => {
              if (element.goodExampleImage.split('/')[5]?.length > 0) {
                return element;
              }
            });
            if (goodImage.length > 0) {
              this.GoodExampleImage = true;
            } else {
              this.removeImagesColumns('good');
            }
            const badImage = response.filter((element: any) => {
              if (element.badExampleImage.split('/')[5]?.length > 0) {
                return element;
              }
            });
            if (badImage.length > 0) {
              this.BadExampleImage = true;
            } else {
              this.removeImagesColumns('bad');
            }
          }
        },
        (error: any) => {
          this.spinner.hide();
          this.toaster.error(
            this.translate.instant('Error'),
            this.translate.instant('WentWrong')
          );
        }
      );
  }

  getChangeOverProducts(): void {
    const key = {
      ProdId: this.ProductId
    }
    this.changeOverProductionList = [];
    this.changeOverProductionDataSource = new MatTableDataSource(<any>[]);
    this.spinner.show();
    this.qualityexecutionService.getChangeOverProducts(key).subscribe((res: any) => {
      this.spinner.hide();
      this.changeOverProductionDataSource = res;
      this.getPaginator(this.changeOverProductionDataSource, 8);
      res?.forEach((x: any) => {
        const key = {
          ProdLabelId: x.Id,
          value: null
        }
        this.changeOverProductionList?.push(key);
      })
    },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', 'Issue In ProductList');
      });
  }




  getDefaultFault(): void {
    const key = {
      PUID: this.machineId
    };
    this.sfdService.getOEEInfo(key).subscribe((data: any) => {

      this.selectedfaultId = data.AutoFault;
      this.filteredDTFaultList.forEach(elem => {
      });
    });
  }

  getAssembly(): void {
    const key = {
      PU_ID: this.groupDataForm.value.machine,
    };
    this.components = [];
    this.filteredcomponents = [];
    this.cilService.getAssemblyList(key).subscribe(
      (data: any) => {
        this.assembly = data.lstasmb;
        this.filteredAssembly = this.assembly.slice();
        this.CilManagDataForm.get('assembly')?.setValue(this.filteredAssembly[0]?.Asmb_Id);
        this.getComponents();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  onCellProductionClicked(params: any): void {
    const col = params.colDef.field;
    this.ButtonType = '';
    if (col === 'Action') {
      this.ButtonType = params.event.target.textContent;
      if (this.ButtonType === 'edit') {
        this.editProductionHistoryBatch(params.data);
      }
      else if (this.ButtonType === 'remove_red_eye') {
        this.openPopupViewForChecklistHistory(params.data);
      }
      else if (this.ButtonType === 'local_printshop') {
        this.GetBarCodeDetails(params.data);
      }

    }
  }


  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.clear();
    this.toaster.info('logged out');
    const href = window.location.href;
    const url = href.split('/')[0] + '/login';
    window.location.href = url;
  }
  getMachineProducts(): void {
    const data = {
      puId: this.unitId,
    };
    this.machineProducts = [];
    this.processService.getMachineProducts(data).subscribe(
      (response) => {
        const key = {
          Prod_Id: 0,
          Prod_Desc: 'Other'
        };

        this.machineProducts = response;
        this.machineProducts.unshift(key);

      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  ViewResponsible(elem: any): void {
    this.AssignedUsers = [];
    this.getTaskAssignedUsers(elem);
  }

  resultUpdate(event: any, id: any): void {
    this.changeOverProductionList?.forEach((x: any, index) => {
      if (x.ProdLabelId === id) {
        this.changeOverProductionList[index].value = event.value;
      }
    });
  }
  addChangeOverCheckListExecution(): void {
    const result = this._alldata;
    const executionDetails: any[] = [];
    result.forEach((element, i) => {
      const v = {
        checkListDetailId: element.checkListDetailId,
        remarks: element.remarks,
        acutalValue: element.score,
        goodImage: element.goodImage,
        badImage: element.badImage,
        itemTypeId: element.itemType,
        catType:
          element.itemType !== 4
            ? element.catType
            : this.goodImgArray[i].name === 'filename'
              ? ''
              : this.goodImgArray[i].name,
      };
      executionDetails.push(v);
    });
    const found = executionDetails.some((el) => el.catType !== '');
    if (!found) {
      this.toaster.warning(this.translate.instant('SelectAnyValue'));
      return;
    }
    const formdata = new FormData();
    for (let index = 0; index < this.goodImgArray.length; index++) {
      formdata.append('goodImages', this.goodImgArray[index]);
    }
    const key = {
      UserCode: this.ActiveUserCode,
      checkListId: this.checklistId,
      execDate: this.checklistDataForm.get('executionDate')?.value,
      shift: this.checklistDataForm.get('shift')?.value,
      unitId: this.unitId,
      processOrder: this.checklistDataForm
        .get('currentProcessOrder')
        ?.value.toString(),
      previousProcessOrder:
        this.isAuto2 === false
          ? this.checklistDataForm.get('previousProcessOrder')?.value
          : this.checklistDataForm.get('previousProcessOrderId')?.value,
      productName: this.checklistDataForm.get('currentProductName')?.value,
      previousProductName: this.checklistDataForm.get('previousProductName')
        ?.value,
      executionDetails,
      ProductDetail: this.changeOverProductionList
    };
    formdata.append('checkListexecution', JSON.stringify(key));
    this.qualityexecutionService.addChangeOverCheckListExecution(formdata).subscribe(
      (response) => {
        this.dialog.closeAll();
        this.toaster.success(
          this.translate.instant('Success'),
          this.translate.instant('AuditExecution') +
          this.translate.instant('AddedSuccessfully')
        );
        this.sendNotification();
        this.resetForm();

        this.getAllQualityCheckList();
      },
      (error) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  openFilePopUpChangeOver(elem: any, index: number, n: number): void {
    if (n === 1) {
      const array = elem.goodExampleImage.split('.');
      const fileType = array[array.length - 1];
      this.doc = elem.goodExampleImage;
      if (fileType === 'jpeg' || fileType === 'jpg' || fileType === 'png' || fileType === 'gif') {
        this.images = [];
        this.fileType = 'img';
        this.images.push(this.doc);
      } else {
        this.fileType = 'doc';
      }
      this.displayMaximizable = true;
    }
    else if (n === 2) {
      const array = elem.badExampleImage.split('.');
      const fileType = array[array.length - 1];
      this.doc = elem.badExampleImage;
      if (fileType === 'jpeg' || fileType === 'jpg' || fileType === 'png' || fileType === 'gif') {
        this.images = [];
        this.fileType = 'img';
        this.images.push(this.doc);
      } else {
        this.fileType = 'doc';
      }
      this.displayMaximizable = true;
    }

  }


  OnDropdownUpdate(event: any, data: any): void {
    const checkListDetailId = parseInt(data.checkListDetailId, 10);
    const d = this._alldata.find(
      (x) => x.checkListDetailId === checkListDetailId
    );
    if (data.itemType === 5) {
      const v = event.value;
      d.catType = v;
    }


  }

  openFilePopUp(elem: any, index: number, n: number): void {
    if (n === 1) {
      const array = elem.goodExampleImage.split('.');
      const fileType = array[array.length - 1];
      this.doc = elem.goodExampleImage;
      if (fileType === 'jpeg' || fileType === 'jpg' || fileType === 'png' || fileType === 'gif') {
        this.images = [];
        this.fileType = 'img';
        this.images.push(this.doc);
      } else {
        this.fileType = 'doc';
      }
      const file = this.goodImgArray[index];
      this.displayMaximizable = true;
    }
    else if (n === 2) {
      const array = elem.badExampleImage.split('.');
      const fileType = array[array.length - 1];
      this.doc = elem.badExampleImage;
      if (fileType === 'jpeg' || fileType === 'jpg' || fileType === 'png' || fileType === 'gif') {
        this.images = [];
        this.fileType = 'img';
        this.images.push(this.doc);
      } else {
        this.fileType = 'doc';
      }
      const file = this.goodImgArray[index];
      this.displayMaximizable = true;
    }

  }
  downloadPDFQC() {

    const columnsToExport = this.getColumnsToExportQC();

    const widths = this.getExportedColumnsWidthsQC(columnsToExport);

    const rowsToExport = this.getRowsToExportQC(columnsToExport);

    const body = [columnsToExport, ...rowsToExport];


    const fillColor = (rowIndex, node, columnIndex) => {
      if (rowIndex < node.table.headerRows) {
        return "#f8f8f8";
      }
      return rowIndex % 2 === 0 ? '#fcfcfc' : '#ffffff';
    };

    const hLineWidth = (i, node) =>
      i === 0 || i === node.table.body.length ? 1 : 1;

    const vLineWidth = (i, node) =>
      i === 0 || i === node.table.widths.length ? 1 : 0;

    const hLineColor = (i, node) =>
      i === 0 || i === node.table.body.length
        ? '#dde2eb'
        : '#babfc7';

    const vLineColor = (i, node) =>
      i === 0 || i === node.table.widths.length
        ? '#dde2eb'
        : '#babfc7';

    const docDefintiion = {
      pageOrientation: 'landscape',
      content: [
        {
          style: 'myTable',
          table: {
            widths,
            body,
          },
          layout: {
            fillColor,
          },
        },
      ],
      images: {
        'ag-grid-logo': 'Good'
      },
      styles: {
        myTable: {
          margin: [0, 0, 0, 0],
        },
        tableHeader: {
          bold: true,
          margin: [0, 25 / 3, 0, 0],
        },
        tableCell: {
        },
      },
    };
    pdfMake.createPdf(docDefintiion).download('QualityControl.pdf');
    this.dialog.closeAll();
    this.processControlForm.get('pdfcolumnQC')?.setValue('');
    this.selectedColumnsQC = [];
  }

  getPdfExportOptionsQC(colId) {
    let col = this.gridOptionsQualityControl.columnApi.getColumn(colId);
    return col.colDef.pdfExportOptions;
  }
  createTableCellQC(cellValue, colId) {
    const tableCell = {
      text: cellValue !== undefined ? cellValue : '',
      style: 'tableCell',
    };

    const pdfExportOptions = this.getPdfExportOptionsQC(colId);

    if (pdfExportOptions) {
      const { styles, createURL } = pdfExportOptions;
    }

    return tableCell;
  }
  getExportedColumnsWidthsQC(columnsToExport) {
    return columnsToExport.map(() => 100 / columnsToExport.length + '%');
  }
  getRowsToExportQC(columnsToExport) {
    let rowsToExport = [];

    this.gridOptionsQualityControl.api.forEachNodeAfterFilterAndSort((node) => {
      let rowToExport = columnsToExport.map(({ colId }) => {
        let cellValue = this.gridOptionsQualityControl.api.getValue(colId, node);
        let tableCell = this.createTableCellQC(cellValue, colId);
        return tableCell;
      });
      rowsToExport.push(rowToExport);
    });

    return rowsToExport;
  }
  columnSelectQC() {
    let column = [];
    this.selectedColumnsQC = [];
    column = this.qualityControlForm.get('pdfcolumnQC')?.value;
    for (let i = 0; i < column.length; i++) {
      this.selectedColumnsQC.push(column[i].headerName);
    }
    this.selectedColumnsQC = this.selectedColumnsQC.toString();
  }

  getColumnsToExportQC() {
    let columnsToExport = [];
    let column;
    this.gridOptionsQualityControl.columnApi.getAllDisplayedColumns().forEach((col) => {
      const select = this.selectedColumnsQC.split(',');
      if (col.userProvidedColDef) {
        column = select.find((x: any) =>
          x == col.userProvidedColDef.headerName
        )
        if (column) {
          let pdfExportOptions = this.getPdfExportOptionsQC(col.getColId());
          if (pdfExportOptions && pdfExportOptions.skipColumn) {
            return;
          }
          let headerCell = this.createHeaderCellQC(col);
          columnsToExport.push(headerCell);
        }
      } else {
        let pdfExportOptions = this.getPdfExportOptions(col.getColId());
        if (pdfExportOptions && pdfExportOptions.skipColumn) {
          return;
        }
        let headerCell = this.createHeaderCell(col);
        columnsToExport.push(headerCell);
      }
    });

    return columnsToExport;
  }
  createHeaderCell(col) {
    let headerCell = {
      text: '',
      colSpan: '',
      colId: '',
    };

    let isColGroup = col.hasOwnProperty('children');

    if (isColGroup) {
      headerCell.text = col.originalColumnGroup.colGroupDef.headerName;
      headerCell.colSpan = col.children.length;
      headerCell.colId = col.GroupCode;
    } else {
      let headerName = col.colDef.headerName;

      if (col.sort) {
        headerName += ` (${col.sort})`;
      }
      if (col.filterActive) {
        headerName += ` [FILTERING]`;
      }

      headerCell.text = headerName;
      headerCell.colId = col.getColId();
    }

    headerCell['style'] = 'tableHeader';

    return headerCell;
  }

  createHeaderCellQC(col) {
    let headerCell = {
      text: '',
      colSpan: '',
      colId: '',
    };

    let isColGroup = col.hasOwnProperty('children');

    if (isColGroup) {
      headerCell.text = col.originalColumnGroup.colGroupDef.headerName;
      headerCell.colSpan = col.children.length;
      headerCell.colId = col.GroupCode;
    } else {
      let headerName = col.colDef.headerName;

      if (col.sort) {
        headerName += ` (${col.sort})`;
      }
      if (col.filterActive) {
        headerName += ` [FILTERING]`;
      }

      headerCell.text = headerName;
      headerCell.colId = col.getColId();
    }

    headerCell['style'] = 'tableHeader';

    return headerCell;
  }
  getPdfExportOptions(colId) {
    let col = this.gridOptionsProcessControl.columnApi.getColumn(colId);
    return col.colDef.pdfExportOptions;
  }
  pdfExportQC() {
    this.selectedColumnsQC = [];
    this.qualityControlForm.get('pdfcolumnQC')?.setValue('');
    this.dialog.open(this.pdfModelQC, {
      width: '50vw !important',
      height: '65vh', minWidth: '50vw', disableClose: true
    });
  }

  pdfExport() {
    this.selectedColumns = [];
    this.processControlForm.get('pdfcolumn')?.setValue('');
    this.dialog.open(this.pdfModel, {
      width: '50vw !important',
      height: '65vh', minWidth: '50vw', disableClose: true
    });
  }
  excelExportPC(): void {
    const params = {
      fileName: 'PC' + new Date(),
    };
    this.gridOptionsProcessControl.api.exportDataAsExcel(params);
  }
  csvExportPC(): void {
    const params = {
      fileName: 'PC ' + new Date(),
    };
    this.gridOptionsProcessControl.api.exportDataAsCsv(params);
  }
  excelExportQC(): void {
    const params = {
      fileName: 'QC' + new Date(),
    };
    this.gridOptionsQualityControl.api.exportDataAsExcel(params);
  }
  csvExportQC(): void {
    const params = {
      fileName: 'QC ' + new Date(),
    };
    this.gridOptionsQualityControl.api.exportDataAsCsv(params);
  }
  downloadPDF() {

    const columnsToExport = this.getColumnsToExport();

    const widths = this.getExportedColumnsWidths(columnsToExport);

    const rowsToExport = this.getRowsToExport(columnsToExport);

    const body = [columnsToExport, ...rowsToExport];


    const fillColor = (rowIndex, node, columnIndex) => {
      if (rowIndex < node.table.headerRows) {
        return "#f8f8f8";
      }
      return rowIndex % 2 === 0 ? '#fcfcfc' : '#ffffff';
    };

    const hLineWidth = (i, node) =>
      i === 0 || i === node.table.body.length ? 1 : 1;

    const vLineWidth = (i, node) =>
      i === 0 || i === node.table.widths.length ? 1 : 0;

    const hLineColor = (i, node) =>
      i === 0 || i === node.table.body.length
        ? '#dde2eb'
        : '#babfc7';

    const vLineColor = (i, node) =>
      i === 0 || i === node.table.widths.length
        ? '#dde2eb'
        : '#babfc7';

    const docDefintiion = {
      pageOrientation: 'landscape',
      content: [
        {
          style: 'myTable',
          table: {
            widths,
            body,
          },
          layout: {
            fillColor,
          },
        },
      ],
      images: {
        'ag-grid-logo': 'Good'
      },
      styles: {
        myTable: {
          margin: [0, 0, 0, 0],
        },
        tableHeader: {
          bold: true,
          margin: [0, 25 / 3, 0, 0],
        },
        tableCell: {
        },
      },
    };
    pdfMake.createPdf(docDefintiion).download('ProcessControl.pdf');
    this.dialog.closeAll();
    this.processControlForm.get('pdfcolumn')?.setValue('');
    this.selectedColumns = [];
  }
  columnSelect() {
    let column = [];
    this.selectedColumns = [];
    column = this.processControlForm.get('pdfcolumn')?.value;
    for (let i = 0; i < column.length; i++) {
      this.selectedColumns.push(column[i].headerName);
    }
    this.selectedColumns = this.selectedColumns.toString();
  }
  getRowsToExport(columnsToExport) {
    let rowsToExport = [];

    this.gridOptionsProcessControl.api.forEachNodeAfterFilterAndSort((node) => {
      let rowToExport = columnsToExport.map(({ colId }) => {
        let cellValue = this.gridOptionsProcessControl.api.getValue(colId, node);
        let tableCell = this.createTableCell(cellValue, colId);
        return tableCell;
      });
      rowsToExport.push(rowToExport);
    });

    return rowsToExport;
  }

  createTableCell(cellValue, colId) {
    const tableCell = {
      text: cellValue !== undefined ? cellValue : '',
      style: 'tableCell',
    };

    const pdfExportOptions = this.getPdfExportOptions(colId);

    if (pdfExportOptions) {
      const { styles, createURL } = pdfExportOptions;
    }

    return tableCell;
  }
  getExportedColumnsWidths(columnsToExport) {
    return columnsToExport.map(() => 100 / columnsToExport.length + '%');
  }
  openAlternativeItemsModel(element: any) {
    this.getAlternativeItems(element);
    this.dialog.open(this.alternativeMaterialModel, {
      width: '70vw !important',
      height: 'auto',
      minWidth: '50vw'
    });
  }
  getAlternativeItems(element: any) {
    this.spinner.show();
    const key = {
      ppdId: this.PPID,
      IsRework: this.isRework,
      ItemBOMDetailId: element.ItemBOMDetailId,
      ParentId: element.parentId
    }
    this.sfdService.GetAlternativeItems(key).subscribe((res: any) => {
      this.alternativeItemsRowData = res;

      this.spinner.hide();
    },
      (error: any) => {
        this.spinner.hide();
      });
  }
  onAlternativeSearchChange() {
    this.gridApiAlternateItem.setQuickFilter(
      (document.getElementById('filter-text-box-alternateItem') as HTMLInputElement).value
    );
  }
  cellClickedAlternateItemGrid(params: any) {
    let element = params?.data;
    this.ItemBOMList?.data.forEach((elem: any, index) => {
      if ((elem.parentId == element.parentId && element.parentId && elem.parentId) || elem.ItemBOMDetailId == element?.parentId || element.ItemBOMDetailId == elem.parentId) {
        // this.tempArray?.push(elem);
        this.ItemBOMList.data[index] = element;
      }
    });

    let tempArray: any = new MatTableDataSource<any>(this.ItemBOMList?.data);
    this.ItemBOMList = new MatTableDataSource<any>(this.ItemBOMList?.data);
    this.ItemBOMList = tempArray;
    let totalEstimatedQuantity = 0;
    tempArray.data?.forEach((x: any) => totalEstimatedQuantity = totalEstimatedQuantity + x.EsimatedQty);
    this.materialFoodSectorConsumptionForm
      .get('mActQtys')
      ?.setValue(totalEstimatedQuantity);
    this.dialog.closeAll();
    this.cdRef.detectChanges();
  }
  getRowStyle = params => {
    if (!params.data.parentId) {
      return { background: '#a2c6c6e8 !important;' };
    }
  };
  onGridReadyAlternateItem(params) {
    this.gridApiAlternateItem = params.api;
    this.gridColumnApiAlternateItem = params.columnApi;
    this.gridApiAlternateItem.setDomLayout('autoHeight');
    const element: HTMLElement = document.querySelector('#agGridAlternate') as HTMLElement;
    if (element !== null) {
      element.style.height = '';
    }
  }
  onGridReadyCheckList(params: any): any {
    this.gridApiCheckList = params.api;
    this.gridColumnCheckListApi = params.columnApi;

    this.gridApiCheckList.setDomLayout('autoHeight');
    const element: HTMLElement = document.querySelector('#agGridCheckList') as HTMLElement;
    if (element !== null) {
      element.style.height = '';
    }
  }
  getColumnsToExport() {
    let columnsToExport = [];
    let column;
    this.gridOptionsProcessControl.columnApi.getAllDisplayedColumns().forEach((col) => {
      const select = this.selectedColumns.split(',');
      if (col.userProvidedColDef) {
        column = select.find((x: any) =>
          x == col.userProvidedColDef.headerName
        )
        if (column) {
          let pdfExportOptions = this.getPdfExportOptions(col.getColId());
          if (pdfExportOptions && pdfExportOptions.skipColumn) {
            return;
          }
          let headerCell = this.createHeaderCell(col);
          columnsToExport.push(headerCell);
        }
      } else {
        let pdfExportOptions = this.getPdfExportOptions(col.getColId());
        if (pdfExportOptions && pdfExportOptions.skipColumn) {
          return;
        }
        let headerCell = this.createHeaderCell(col);
        columnsToExport.push(headerCell);
      }
    });

    return columnsToExport;
  }
  closeSacnnerDialoge(): void {
    this.dialog.closeAll();
    this.scanning = false;
  }
  getTaskAssignedUsers(param: any): void {
    this.spinner.show();
    const key = {
      PlantId: this.CilManagDataForm.value.plant,
      TaskId: param.id
    };
    this.cilService.getTaskAssignedUsers(key).subscribe(
      (response: any) => {
        this.spinner.hide();
        this.dialog.open(this.displayResponsibleModal, { height: 'auto', width: '45%', maxHeight: '50vh' });
        this.AssignedUsers = response?.data;
      });
  }
}
const tooltipValueGetter = (params: any) => ({ value: params.value });
class Group {
  [key: string]: any;
  level = 0;
  parent!: Group; // =new Group();
  expanded = true;
  totalCounts = 0;
  get visible(): boolean {
    return !this.parent || (this.parent.visible && this.parent.expanded);
  }
}
